
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jQbDV", function(module, exports) {
// raw data is returned from Legion API
var $24bf014d867e0790$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
var $24bf014d867e0790$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    TeamMembershipSettings["ORG_ADMIN_MANAGED"] = "ORG_ADMIN_MANAGED";
    return TeamMembershipSettings;
}({});
var $24bf014d867e0790$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
var $24bf014d867e0790$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
var $24bf014d867e0790$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({});
module.exports["TeamState"] = $24bf014d867e0790$export$c5c56131401e0716;
module.exports["TeamMembershipSettings"] = $24bf014d867e0790$export$93b1c6cf9d16dce6;
module.exports["TeamDiscoverability"] = $24bf014d867e0790$export$c698762b98da6685;
module.exports["TeamRestriction"] = $24bf014d867e0790$export$e94592bde85a4d74;
module.exports["TeamPermission"] = $24bf014d867e0790$export$4db108522156032a;

});

parcelRegister("cF2M0", function(module, exports) {
const $b44b7ef446e616a8$export$17d8d8786fe5d4ac = ({ product: product, canInviteToJiraSoftware: canInviteToJiraSoftware, canInviteToConfluence: canInviteToConfluence })=>{
    const inviteProducts = [];
    if (canInviteToJiraSoftware) inviteProducts.push('jira-software');
    if ((product === 'atlas' || !product) && canInviteToConfluence) inviteProducts.push('confluence');
    return inviteProducts;
};
module.exports["getInviteProducts"] = $b44b7ef446e616a8$export$17d8d8786fe5d4ac;

});

parcelRegister("dsjDS", function(module, exports) {
const $2eb821880b834853$export$e9ebe20ff7f8ff23 = (email)=>{
    if (!email) return undefined;
    const emailParts = email.split('@');
    if (emailParts.length === 2 && emailParts[1]) return emailParts[1];
    return undefined;
};
module.exports["getUserDomain"] = $2eb821880b834853$export$e9ebe20ff7f8ff23;

});

parcelRegister("fcfcA", function(module, exports) {

var $fDXXi = parcelRequire("fDXXi");


var $iE25L = parcelRequire("iE25L");


var $8zu5m = parcelRequire("8zu5m");


var $dAQwn = parcelRequire("dAQwn");


var $6Co6F = parcelRequire("6Co6F");





var $fAdjB = parcelRequire("fAdjB");








var $1UbNf = parcelRequire("1UbNf");

// Copied from platform/packages/people-and-teams/invite-people/src/utils/index.ts
// Consider moving to a shared package on productionisaton
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
const $5a50b15bfd5734ea$var$DEV_ENV_HOSTNAMES = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'statlas.atl-paas.net',
    'atlaskit.atlassian.com'
];
const $5a50b15bfd5734ea$var$isProd = ()=>window.location.host.includes('-dev.com') ? false : true;
const $5a50b15bfd5734ea$var$isDevEnv = ()=>$5a50b15bfd5734ea$var$DEV_ENV_HOSTNAMES.includes(window.location.hostname);
const $5a50b15bfd5734ea$export$f6c02f8ff560b96f = ()=>$5a50b15bfd5734ea$var$isDevEnv() ? $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_DEV : $5a50b15bfd5734ea$var$isProd() ? $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_PROD : $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_STAGING;


const $87838d91281aa10f$var$getContinueUrl = ({ originTracer: originTracer })=>{
    const origin = window.location.origin;
    // For product domains, preference sending to the origin location in order to give the user an "onboarding" experience.
    if (origin && (origin.endsWith('.jira-dev.com') || origin.endsWith('.atlassian.net'))) return originTracer.addToUrl(origin);
    return '';
};
const $87838d91281aa10f$export$77fe4ed5de1c713e = ({ products: products, source: source, originProduct: originProduct })=>{
    const { getRecaptchaToken: getRecaptchaToken, unloadRecaptchaForSite: unloadRecaptchaForSite } = (0, $fAdjB.useInvisibleRecaptcha)({
        siteKey: (0, $5a50b15bfd5734ea$export$f6c02f8ff560b96f)(),
        displayBadge: false,
        analyticsChannel: 'peopleAndTeams',
        analyticsSource: 'useInviteToProduct',
        preventUnloadRecaptchaOnCleanup: true
    });
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return async (emails, cloudId)=>{
        try {
            // Get reCAPTCHA token
            const recaptchaToken = await getRecaptchaToken?.('invite_to_product').catch(()=>{
                // If token generation fails we want to just continue with the
                // request without a recaptcha token (the lib will fire an event)
                return undefined;
            });
            const productAris = (0, $1UbNf.getProductAris)({
                products: products,
                cloudId: cloudId
            });
            const originTracer = new (0, $6Co6F.default)({
                product: originProduct
            });
            const originAttributes = originTracer.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const payload = {
                users: emails.map((email)=>({
                        email: email
                    })),
                continueUrl: $87838d91281aa10f$var$getContinueUrl({
                    originTracer: originTracer
                }),
                resources: productAris,
                suppressInviteEmail: false,
                roleName: 'product/member'
            };
            const result = await (0, $dAQwn.postJson)('/gateway/api/invitations/invite', payload, recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : undefined);
            // Manually unload recaptcha. Could not rely on built in cleanup on unmount since it was happening too early and causing token not to be generated
            unloadRecaptchaForSite?.();
            const invites = result.filter((item)=>item.results && (Object.values(item.results).includes('INVITED') || Object.values(item.results).includes('INVITED_PENDING_APPROVAL')));
            invites.forEach((invite)=>{
                if (invite.id) // @ts-expect-error - we should never dynamically set the actionSubjectId
                fireEvent(`track.user.invited.${invite.id}`, {
                    integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                    products: products,
                    inviteResult: invite.results || {},
                    inviteErrorReasons: invite.errorReasons || {},
                    ...originAttributes
                });
            });
            const errors = result.filter((item)=>item.errorReasons && Object.keys(item.errorReasons).length > 0);
            if (errors.length > 0) fireEvent('track.inviteToProductService.failed', {
                integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                message: 'Errors occurred with inviting users',
                errorsCount: errors.length,
                errors: errors,
                result: result
            });
            return result;
        } catch (error) {
            const errorMessage = 'Failed to invite users';
            const typeGuardedError = error instanceof Error ? error : new Error(errorMessage);
            fireEvent('track.inviteToProductService.failed', {
                integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                message: typeGuardedError.message,
                errorsCount: null,
                errors: null,
                result: null
            });
        }
    };
};


const $a6c5b6caec115345$var$addToTeam = async ({ members: members, orgId: orgId, teamId: teamId, source: source, fireEvent: fireEvent })=>{
    try {
        if (members.length === 0) return;
        const url = `/gateway/api/public/teams/v1/org/${orgId}/teams/${teamId}/members/add`;
        const data = await (0, $dAQwn.postJson)(url, {
            members: members
        });
        if (data?.members.length > 0) fireEvent('track.invitedTeamMembers.added', {
            numberOfMembers: data.members.length,
            members: data.members,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG
        });
        if (data.errors.length > 0) fireEvent('track.addToTeamService.failed', {
            errorsCount: data.errors.length,
            errors: data.errors,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
            message: null
        });
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('Failed to add users to team');
        fireEvent('track.addToTeamService.failed', {
            message: typeGuardedError.message,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
            errorsCount: null,
            errors: null
        });
    }
};
const $a6c5b6caec115345$export$4c14c870b6415a98 = ({ products: products, source: source, originProduct: originProduct })=>{
    const inviteToProduct = (0, $87838d91281aa10f$export$77fe4ed5de1c713e)({
        products: products,
        source: source,
        originProduct: originProduct
    });
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return async ({ newUsersWhoNeedInvite: newUsersWhoNeedInvite, cloudId: cloudId, teamId: teamId, orgId: orgId })=>{
        try {
            if (newUsersWhoNeedInvite.length === 0) return;
            const newUsersEmails = newUsersWhoNeedInvite.map((selectedMember)=>selectedMember.id);
            const inviteToProductResult = await inviteToProduct(newUsersEmails, cloudId);
            if (!inviteToProductResult || !orgId) return;
            return new Promise((resolve)=>{
                // There is a permission sync which occurs for new invitees. The timeout is to increase chances of success for the add to team
                setTimeout(async ()=>{
                    try {
                        const members = [];
                        inviteToProductResult.forEach((invitee)=>{
                            if (invitee.id) members.push({
                                accountId: invitee.id
                            });
                        });
                        await $a6c5b6caec115345$var$addToTeam({
                            members: members,
                            orgId: orgId,
                            teamId: teamId,
                            source: source,
                            fireEvent: fireEvent
                        });
                    } catch (error) {
                        (0, $iE25L.logException)(error, 'addToTeamError');
                    } finally{
                        resolve();
                    }
                }, 6000);
            });
        } catch (error) {
            (0, $iE25L.logException)(error, 'useInviteAndAddToTeamError');
        }
    };
};
module.exports["useInviteAndAddToTeam"] = $a6c5b6caec115345$export$4c14c870b6415a98;

});

parcelRegister("dAQwn", function(module, exports) {
const $49909d5d95652733$export$83179404a61b001a = 'FetchError';
function $49909d5d95652733$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $49909d5d95652733$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $49909d5d95652733$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $49909d5d95652733$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $49909d5d95652733$export$c776284ef4b1209a = (url, data, headers)=>$49909d5d95652733$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });
module.exports["fetchJson"] = $49909d5d95652733$export$6d71b655afe1638d;
module.exports["postJson"] = $49909d5d95652733$export$c776284ef4b1209a;

});

parcelRegister("bte6P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $iE25L = parcelRequire("iE25L");


var $hYSRS = parcelRequire("hYSRS");


var $8zu5m = parcelRequire("8zu5m");


var $dAQwn = parcelRequire("dAQwn");


var $1UbNf = parcelRequire("1UbNf");

const $fa9707026b041c7c$var$fetchInviteCapabilities = async ({ products: products, cloudId: cloudId, source: source, fireEvent: fireEvent })=>{
    try {
        const productARIs = (0, $1UbNf.getProductAris)({
            products: products,
            cloudId: cloudId
        });
        const payload = {
            productARIs: productARIs
        };
        const result = await (0, $dAQwn.postJson)('/gateway/api/v3/invitations/capabilities', payload);
        return result;
    } catch (e) {
        fireEvent('operational.inviteCapabilitiesService.failed', {
            products: products,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG
        });
        return undefined;
    }
};
const $fa9707026b041c7c$export$67376debdcebd5d2 = ({ product: product, response: response })=>{
    if (!response) return false;
    const productResponseItem = response.find((responseItem)=>responseItem.resourceARI?.includes(product));
    if (!productResponseItem) return false;
    if (productResponseItem.directInvite?.mode === 'ANYONE' || productResponseItem.directInvite?.mode === 'DOMAIN_RESTRICTED') return true;
    return false;
};
const $fa9707026b041c7c$export$e3ce16335d404d03 = ({ cloudId: cloudId, shouldRun: shouldRun, source: source })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [data, setData] = (0, $42omo.useState)(undefined);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $hYSRS.useOnceWhen)(!isLoading && !data && shouldRun, async ()=>{
        setIsLoading(true);
        try {
            const result = await $fa9707026b041c7c$var$fetchInviteCapabilities({
                products: [
                    'jira-software',
                    'confluence'
                ],
                cloudId: cloudId,
                source: source,
                fireEvent: fireEvent
            });
            setIsLoading(false);
            setData(result);
        } catch (error) {
            (0, $iE25L.logException)(error, 'useInviteCapabilitiesError');
        } finally{
            setIsLoading(false);
        }
    });
    return {
        isLoading: isLoading,
        data: data,
        canInviteToJiraSoftware: $fa9707026b041c7c$export$67376debdcebd5d2({
            product: 'jira-software',
            response: data
        }),
        canInviteToConfluence: $fa9707026b041c7c$export$67376debdcebd5d2({
            product: 'confluence',
            response: data
        })
    };
};
module.exports["useInviteCapabilities"] = $fa9707026b041c7c$export$e3ce16335d404d03;

});

parcelRegister("hYSRS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c7e560c947f43c7d$export$602521d848dcbc8f = (fn, deps = [])=>{
    const called = (0, $42omo.useRef)(false);
    return (0, $42omo.useCallback)(()=>{
        if (!called.current) {
            called.current = true;
            fn();
        }
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
const $c7e560c947f43c7d$export$4ff988088e6353d2 = (condition, fn, deps)=>{
    const fire = $c7e560c947f43c7d$export$602521d848dcbc8f(fn, deps);
    (0, $42omo.useEffect)(()=>{
        if (condition) fire();
    }, [
        condition,
        fire
    ]);
};
module.exports["useOnceWhen"] = $c7e560c947f43c7d$export$4ff988088e6353d2;

});

parcelRegister("iBtX5", function(module, exports) {
const $49d505ddbcfe4978$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};
module.exports["hasProductPermission"] = $49d505ddbcfe4978$export$a2eea90ce05a9f1c;

});

parcelRegister("kdU21", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS = [
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery'
];
const $11f3ff053e659fe4$export$29429bc4d26dfcf8 = ({ url: url, query: query, variables: variables })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
};
const $11f3ff053e659fe4$export$98fa14561e3049ec = ({ url: url, body: body })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    });
};
const $11f3ff053e659fe4$export$e16fe80afd1ad74c = (cloudId, userId, productPermissions)=>{
    const body = productPermissions.reduce((acc, productPermission)=>{
        const permission = {
            permissionId: productPermission.permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        if (productPermission.product === 'jira') $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        else acc.push({
            ...permission,
            resourceId: `ari:cloud:${productPermission.product}::site/${cloudId}`
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};


const $271938b51863a92c$export$544dab20dbe3f2e7 = (product, permissionId, cloudId)=>{
    if (product === 'jira' && permissionId === 'CREATE_PROJECT') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateProject($cloudId: ID!) {
						jira {
							canPerform  (cloudId: $cloudId, type: CREATE_PROJECT) @optIn(to: "JiraAction")
						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_PROJECT',
                resourceId: 'jira',
                permitted: response?.data?.jira?.canPerform || false
            };
        }
    };
    else if (product === 'confluence' && permissionId === 'CREATE_SPACE') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateConfluenceSpace($cloudId: ID) {
						siteOperations (cloudId: $cloudId) {
    						application
  						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_SPACE',
                resourceId: 'confluence',
                permitted: response?.data?.siteOperations?.application?.includes('create_space') || false
            };
        }
    };
};
const $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint = async ({ cloudId: cloudId, userId: userId, productPermissions: productPermissions })=>{
    const response = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: '/gateway/api/permissions/bulk/permitted',
        body: (0, $11f3ff053e659fe4$export$e16fe80afd1ad74c)(cloudId, userId, productPermissions)
    });
    if (!response.ok) {
        const errorBody = await response.json();
        const errorMessage = errorBody.message || errorBody.error || `HTTP error! status: ${response.status}`;
        throw new Error(`Failed to fetch product permissions with error ${errorMessage}`);
    }
    const bulkPermissions = await response.json();
    return bulkPermissions;
};
const $271938b51863a92c$var$fetchPermissionFromRestApi = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'rest') return;
    const res = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: endpoint.url
    });
    const responseData = await res.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$var$fetchPermissionFromGraphql = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'graphql') return;
    const response = await (0, $11f3ff053e659fe4$export$29429bc4d26dfcf8)({
        url: endpoint.url,
        query: endpoint.query,
        variables: endpoint.variables
    });
    const responseData = await response.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$export$dcb450c551529da1 = async ({ permissionsToCheck: permissionsToCheck, cloudId: cloudId, userId: userId })=>{
    const apiCallPromises = [];
    const permissions = [];
    const productKeys = Object.keys(permissionsToCheck);
    const errors = [];
    const productPermissions = [];
    productKeys.forEach((productKey)=>permissionsToCheck[productKey]?.forEach(async (permission)=>{
            const endpoint = $271938b51863a92c$export$544dab20dbe3f2e7(productKey, permission, cloudId);
            if (endpoint) {
                if (endpoint.type === 'rest') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromRestApi(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                    }
                })());
                else if (endpoint.type === 'graphql') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromGraphql(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                    }
                })());
                else if (endpoint.type === 'default') productPermissions.push({
                    product: endpoint.payload.product,
                    permissionId: endpoint.payload.permissionId
                });
            } else productPermissions.push({
                product: productKey,
                permissionId: permission
            });
        }));
    if (productPermissions.length > 0) apiCallPromises.push((async ()=>{
        try {
            const bulkPermissions = await $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint({
                cloudId: cloudId,
                userId: userId,
                productPermissions: productPermissions
            });
            permissions.push(...bulkPermissions);
        } catch (error) {
            errors.push(new Error(`Error fetching product permissions with error ${error}`));
        }
    })());
    await Promise.allSettled(apiCallPromises);
    return {
        permissions: permissions,
        errors: errors
    };
};


const $83cc7ad61bf4f552$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];


const $e2f95f239ab54f09$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $83cc7ad61bf4f552$export$69caceff42c0da80).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};


const $21a370a6c94ec1e0$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionsToCheck: permissionsToCheck })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionsToCheck.jira?.some((permissionId)=>permissions.jira?.[permissionId] === undefined) || permissionsToCheck.confluence?.some((permissionId)=>permissions.confluence?.[permissionId] === undefined) || permissionsToCheck.loom?.some((permissionId)=>permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const { permissions: permissions } = await (0, $271938b51863a92c$export$dcb450c551529da1)({
                    permissionsToCheck: permissionsToCheck,
                    cloudId: cloudId,
                    userId: userId
                });
                dispatch($21a370a6c94ec1e0$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($21a370a6c94ec1e0$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ getState: getState, setState: setState })=>{
            const newPermissions = (0, $e2f95f239ab54f09$export$7fe0bfa353103198)(permissions);
            const oldPermissions = getState().permissions;
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: {
                    jira: {
                        ...oldPermissions.jira,
                        ...newPermissions.jira
                    },
                    confluence: {
                        ...oldPermissions.confluence,
                        ...newPermissions.confluence
                    },
                    loom: {
                        ...oldPermissions.loom,
                        ...newPermissions.loom
                    }
                },
                permissionsResponse: permissions
            });
        }
};
const $21a370a6c94ec1e0$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $21a370a6c94ec1e0$var$actions,
    name: 'product-permissions'
});
const $21a370a6c94ec1e0$export$933ed92af1ed5de9 = (0, $9zUhf.createHook)($21a370a6c94ec1e0$var$Store);


const $5856de27861a3f68$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionsToCheck: permissionsToCheck, options: options })=>{
    const [state, { getPermissions: getPermissions }] = (0, $21a370a6c94ec1e0$export$933ed92af1ed5de9)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: options?.enabled ?? true,
            permissionsToCheck: permissionsToCheck || {
                jira: [
                    'manage',
                    'write'
                ],
                confluence: [
                    'manage',
                    'write'
                ],
                loom: [
                    'manage',
                    'write'
                ]
            }
        });
    }, [
        cloudId,
        options,
        getPermissions,
        userId,
        permissionsToCheck
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};
module.exports["useProductPermissions"] = $5856de27861a3f68$export$5814f9544ee53f3b;

});

parcelRegister("exlO1", function(module, exports) {
var $e21789de7867b609$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["CONFLUENCE_SPACE"] = "CONFLUENCE_SPACE";
    ContainerType["JIRA_PROJECT"] = "JIRA_PROJECT";
    ContainerType["LOOM_SPACE"] = "LOOM_SPACE";
    return ContainerType;
}({});
module.exports["ContainerType"] = $e21789de7867b609$export$7d7a98f44861e6f7;

});

parcelRegister("3PCpU", function(module, exports) {
class $1e07f84512b90a64$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = void 0;
        this.context = context;
    }
}
module.exports["ErrorWithContext"] = $1e07f84512b90a64$export$6e749dfbce027249;

});

parcelRegister("7iAiT", function(module, exports) {
$parcel$export(module.exports, "default", () => $17f32c43ffd1024a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fDXXi = parcelRequire("fDXXi");


var $2iK1S = parcelRequire("2iK1S");


var $cpl2G = parcelRequire("cpl2G");


var $iMEBP = parcelRequire("iMEBP");


var $erMpQ = parcelRequire("erMpQ");


var $dVp1j = parcelRequire("dVp1j");


var $dTRYM = parcelRequire("dTRYM");


var $8zu5m = parcelRequire("8zu5m");


var $7sG51 = parcelRequire("7sG51");


var $kLwto = parcelRequire("kLwto");








var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");








var $i4zsj = parcelRequire("i4zsj");

const $954d28cdad8a6bb0$var$DIALOG_WIDTH = 480;
const $954d28cdad8a6bb0$var$TeamCreateModal = (props)=>{
    const { extraAnalyticsAttrs: extraAnalyticsAttrs, isBlanketHidden: isBlanketHidden, onClose: onClose = (0, $dTRYM.VOID_FUNC) } = props;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    // Work-around:
    // When TeamCreateDialog renders inside PeopleMenu and the viewport is narrow,
    // the dialog is closed improperly when users click anywhere in the dialog
    const preventCloseDialog = (event)=>{
        event.stopPropagation();
    };
    const closeDialog = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.teamCreateDialog.closed', extraAnalyticsAttrs || {});
        onClose();
    }, [
        extraAnalyticsAttrs,
        onClose,
        fireEvent
    ]);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const innerSetLoading = (0, $42omo.useCallback)((isLoading)=>{
        setLoading(isLoading);
        (props.setIsLoading || (0, $dTRYM.VOID_FUNC))(isLoading);
    }, [
        props.setIsLoading
    ]);
    const customComponents = {
        ...props.customComponents,
        header: props.customComponents?.header || props.customComponents?.modalHeader || (0, $dh538.fg)('enable_team_creation_modal_header_prop_change') ? (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                ...props,
                hasCloseButton: false
            }) : (0, $9ot3w.default),
        title: props.customComponents?.title || props.customComponents?.modalTitle || (0, $d8eRd.default),
        body: props.customComponents?.body || props.customComponents?.modalBody || (0, $1DHa6.default),
        footer: props.customComponents?.footer || props.customComponents?.modalFooter || (0, $8o1lj.default)
    };
    const customMessages = {
        ...props.customMessages,
        title: props.customMessages?.title || props.customMessages?.modalTitle || undefined
    };
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        onClick: preventCloseDialog,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldScrollInViewport: true,
            onClose: closeDialog,
            width: $954d28cdad8a6bb0$var$DIALOG_WIDTH,
            isBlanketHidden: isBlanketHidden,
            shouldCloseOnOverlayClick: !isLoading,
            shouldCloseOnEscapePress: !isLoading,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4zsj.default), {
                ...props,
                onClose: closeDialog,
                setIsLoading: innerSetLoading,
                customComponents: customComponents,
                customMessages: customMessages
            })
        })
    }));
};
var $954d28cdad8a6bb0$export$2e2bcd8739ae039 = $954d28cdad8a6bb0$var$TeamCreateModal;









var $inPa6 = parcelRequire("inPa6");





var $hYSRS = parcelRequire("hYSRS");


var $8ftiF = parcelRequire("8ftiF");




/* TeamCreateInternal.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9YwaJ = parcelRequire("9YwaJ");


var $1Whri = parcelRequire("1Whri");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");














var $gdv5Z = parcelRequire("gdv5Z");





var $cQuKk = parcelRequire("cQuKk");


var $3jKGE = parcelRequire("3jKGE");





var $jQbDV = parcelRequire("jQbDV");





var $7C1yo = parcelRequire("7C1yo");

















var $7rus4 = parcelRequire("7rus4");

var $RMvle = parcelRequire("RMvle");











var $98DYt = parcelRequire("98DYt");

const $3bcb7900a35aed3c$var$SMART_USER_PICKER_ID = 'AddMemberToTeam';
const $3bcb7900a35aed3c$var$LOGGED_IN_USER = 'Context';
const $3bcb7900a35aed3c$export$acbf13d3bface7d6 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { onChange: onChange, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), cloudId: cloudId, initialValues: initialValues, teamId: teamId, filterUsers: filterUsers, extraAnalyticsAttrs: extraAnalyticsAttrs, showHelperMessages: showHelperMessages = true, isInvalid: isInvalid, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, inputId: inputId } = props;
    const [hasError, setError] = (0, $42omo.useState)(false);
    const [isMaximum, setIsMaximum] = (0, $42omo.useState)(false);
    const [isDisabled, setDisabled] = (0, $42omo.useState)(false);
    const [isOpen, setOpen] = (0, $42omo.useState)(false);
    const [query, setQuery] = (0, $42omo.useState)('');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleOnChange = (0, $42omo.useCallback)((value)=>{
        const selectedUsers = value || [];
        setDisabled(selectedUsers.length >= maxSelectedMembers);
        setIsMaximum(selectedUsers.length === maxSelectedMembers);
        const isError = selectedUsers.length > maxSelectedMembers;
        setError(isError);
        if (isError) fireEvent('track.memberPicker.error', extraAnalyticsAttrs ?? {});
        if (onChange) onChange(selectedUsers, {
            hasError: isError,
            isDisabled: isDisabled
        });
    }, [
        isDisabled,
        maxSelectedMembers,
        onChange,
        extraAnalyticsAttrs,
        fireEvent
    ]);
    const handleOnInputChange = (0, $42omo.useCallback)((query)=>{
        setQuery(query || '');
    }, [
        setQuery
    ]);
    const handleOnBlur = (0, $42omo.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleOnFocus = (0, $42omo.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    // convert InvitedUser type to (OptionalData | User) type of @atlaskit/user-picker
    const memoizedDefaultValue = (0, $42omo.useMemo)(()=>{
        if (!initialValues) return;
        return initialValues.map((user)=>({
                name: user.fullName,
                publicName: user.nickname,
                type: (0, $RMvle.UserType),
                ...user
            }));
    }, [
        initialValues
    ]);
    const propsWhenHasError = hasError ? {
        open: false,
        addMoreMessage: ''
    } : {};
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rus4.default), {
                forwardedRef: ref,
                ariaLabelledBy: ariaLabelledBy,
                "aria-describedby": ariaDescribedBy,
                disableInput: isDisabled,
                onChange: handleOnChange,
                onInputChange: handleOnInputChange,
                onBlur: handleOnBlur,
                onFocus: handleOnFocus,
                open: isOpen && query.length > 0,
                includeTeams: false,
                inputId: inputId,
                fieldId: $3bcb7900a35aed3c$var$SMART_USER_PICKER_ID,
                principalId: $3bcb7900a35aed3c$var$LOGGED_IN_USER,
                isMulti: true,
                placeholder: formatMessage((0, $7sG51.messages).userPickerPlaceholder),
                addMoreMessage: formatMessage((0, $7sG51.messages).userPickerPlaceholder),
                noOptionsMessage: ()=>formatMessage((0, $7sG51.messages).userPickerNoOption),
                productKey: 'people',
                siteId: cloudId,
                defaultValue: memoizedDefaultValue,
                debounceTime: (0, $dTRYM.DEBOUNCE_MS),
                width: "100%",
                containerId: teamId || '',
                searchQueryFilter: (0, $98DYt.CPUS_SEARCH_QUERY_FILTER),
                filterOptions: filterUsers,
                maxOptions: (0, $dTRYM.MAX_MEMBERS),
                bootstrapOptions: [],
                isInvalid: hasError || isInvalid,
                ...propsWhenHasError
            }),
            showHelperMessages && (hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageError, {
                    maxNumber: maxSelectedMembers
                })
            }) : isMaximum ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageMaximumError, {
                    maxNumber: maxSelectedMembers
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageInfo, {
                    maxNumber: maxSelectedMembers
                })
            }))
        ]
    });
});
var $3bcb7900a35aed3c$export$2e2bcd8739ae039 = $3bcb7900a35aed3c$export$acbf13d3bface7d6;



var $cEyfH = parcelRequire("cEyfH");


var $lKErE = parcelRequire("lKErE");


var $cIiie = parcelRequire("cIiie");


var $e0BNA = parcelRequire("e0BNA");








var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $1DWH0 = parcelRequire("1DWH0");





var $4noo5 = parcelRequire("4noo5");











var $ko87z = parcelRequire("ko87z");


var $8Hi1J = parcelRequire("8Hi1J");

function $fe890355bd728fcd$var$TeamNameInput(props) {
    const { intl: intl, onSubmit: onSubmit, onChange: onChange, isSubmittedOnce: isSubmittedOnce, initialTeamName: initialTeamName } = props;
    const inputRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        inputRef.current && inputRef.current.focus();
    }, []);
    const [name, setName] = (0, $42omo.useState)(initialTeamName);
    const handleTextChange = (0, $42omo.useCallback)((value)=>{
        setName(value || '');
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(value);
        if (isSubmittedOnce && teamNameValidationError === (0, $8Hi1J.ValidationError).REQUIRED) return teamNameValidationError;
        if (teamNameValidationError === (0, $8Hi1J.ValidationError).EXCEED_MAX_LENGTH) return teamNameValidationError;
        onChange(value?.trim() || '');
        return undefined;
    }, [
        onChange,
        isSubmittedOnce
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            onSubmit();
        }
    }, [
        onSubmit
    ]);
    const getErrorMsg = (error)=>{
        if (error === (0, $8Hi1J.ValidationError).REQUIRED) return intl.formatMessage((0, $7sG51.messages).teamNameFieldRequiredErrorMessage);
        return intl.formatMessage((0, $7sG51.messages).teamNameFieldTooLongErrorMessage);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.TeamNameWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
            name: "teamName",
            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $7sG51.messages).teamNameFieldLabel
            }),
            isRequired: true,
            validate: handleTextChange,
            defaultValue: initialTeamName,
            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                            ...fieldProps,
                            autoComplete: "off",
                            isRequired: true,
                            isDisabled: false,
                            name: "teamName",
                            onKeyDown: handleKeyDown,
                            placeholder: intl.formatMessage((0, $7sG51.messages).teamNameFieldPlaceholder),
                            testId: "team-name-input",
                            "aria-labelledby": "",
                            ref: inputRef,
                            value: name
                        }),
                        error ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ko87z.TeamNameErrorMsg), {
                            errorMsg: getErrorMsg(error)
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ko87z.TeamNameInfoMsg), {})
                    ]
                })
        })
    });
}
var $fe890355bd728fcd$export$2e2bcd8739ae039 = (0, $1DWH0.default)()((0, $gmMgo.default)($fe890355bd728fcd$var$TeamNameInput));





parcelRequire("42omo");




const $0ad787571fc2acbc$var$DEFAULT_WIDTH = 237;
const $0ad787571fc2acbc$var$DEFAULT_HEIGHT = 271;
const $0ad787571fc2acbc$var$WIDE_WIDTH = 300;
const $0ad787571fc2acbc$var$WIDE_HEIGHT = 343;
function $0ad787571fc2acbc$export$2e2bcd8739ae039({ label: label, wide: wide }) {
    const width = wide ? $0ad787571fc2acbc$var$WIDE_WIDTH : $0ad787571fc2acbc$var$DEFAULT_WIDTH;
    const height = wide ? $0ad787571fc2acbc$var$WIDE_HEIGHT : $0ad787571fc2acbc$var$DEFAULT_HEIGHT;
    return /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.SvgWrapper, {
        "data-testid": "create-team-internal-default-image-content",
        "aria-hidden": true,
        wide: wide,
        dangerouslySetInnerHTML: {
            __html: `<svg width="${width}" height="${height}" viewBox="0 0 237 271" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1331_7994)">
        <mask id="mask0_1331_7994" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="237" height="271">
        <path d="M236.312 0H0.444336V271H236.312V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_1331_7994)">
        <path d="M103.608 236.443L103.347 172.505L104.468 172.5L104.734 236.438L103.608 236.443Z" fill="url(#paint0_linear_1331_7994)"/>
        <path opacity="0.1" d="M187.193 131.307C192.741 128.611 201.272 128.064 206.443 133.255C209.319 136.141 210.102 139.751 210.358 141.631C212.408 141.07 215.535 140.577 218.285 142.061C221.484 143.792 221.707 146.87 225.07 150.273C226.617 151.834 229.179 153.82 233.451 155.13C210.407 155.13 187.357 155.13 164.313 155.13C163.491 151.273 164.782 147.271 167.696 144.695C171.882 140.998 177.135 142.24 177.575 142.356C178.194 140.669 180.663 134.483 187.193 131.307Z" fill="url(#paint1_linear_1331_7994)"/>
        <path opacity="0.1" d="M209.967 158.137C213.128 156.6 217.985 156.29 220.928 159.248C222.567 160.891 223.011 162.946 223.156 164.018C224.321 163.699 226.105 163.419 227.67 164.265C229.493 165.251 229.618 167.005 231.537 168.943C232.417 169.833 233.876 170.964 236.312 171.708C223.185 171.708 210.063 171.708 196.936 171.708C196.468 169.509 197.202 167.233 198.865 165.763C201.248 163.656 204.239 164.366 204.491 164.429C204.839 163.468 206.245 159.949 209.967 158.137Z" fill="url(#paint2_linear_1331_7994)"/>
        <path opacity="0.1" d="M26.7899 133.009C23.629 131.472 18.7717 131.162 15.8283 134.12C14.1898 135.763 13.7452 137.818 13.6002 138.891C12.4354 138.572 10.652 138.291 9.08602 139.137C7.26392 140.123 7.13826 141.877 5.2195 143.816C4.33986 144.705 2.88025 145.836 0.444336 146.58C13.5712 146.58 26.6932 146.58 39.8201 146.58C40.2889 144.381 39.5542 142.105 37.8916 140.635C35.5089 138.528 32.5172 139.239 32.2658 139.301C31.9179 138.34 30.5114 134.816 26.7899 133.009Z" fill="url(#paint3_linear_1331_7994)"/>
        <path opacity="0.1" d="M54.5275 174.134C61.4679 170.76 72.1347 170.074 78.6015 176.57C82.1973 180.18 83.1785 184.694 83.4975 187.043C86.059 186.342 89.9691 185.724 93.4103 187.584C97.4121 189.75 97.6876 193.602 101.897 197.855C103.831 199.807 107.035 202.292 112.38 203.93C83.5603 203.93 54.7402 203.93 25.9201 203.93C24.8906 199.107 26.5049 194.104 30.1539 190.88C35.3882 186.255 41.9565 187.811 42.5123 187.952C43.2711 185.84 46.3595 178.106 54.5275 174.134Z" fill="url(#paint4_linear_1331_7994)"/>
        <path opacity="0.1" d="M60.4284 47.8817C53.2753 44.4066 42.2799 43.701 35.615 50.3901C31.908 54.1116 30.8978 58.7611 30.5692 61.1825C27.9254 60.4576 23.8994 59.8244 20.3519 61.7383C16.2244 63.9713 15.944 67.9393 11.6039 72.323C9.6126 74.3384 6.30672 76.8951 0.801758 78.5819C30.5063 78.5819 60.2109 78.5819 89.9155 78.5819C90.9788 73.6086 89.3114 68.4516 85.556 65.1312C80.1622 60.3657 73.3909 61.9703 72.8206 62.1153C72.0328 59.9452 68.8478 51.9705 60.4284 47.8817Z" fill="url(#paint5_linear_1331_7994)"/>
        <path d="M105.073 236.487L103.956 236.347L111.114 178.924L112.23 179.059L105.073 236.487Z" fill="url(#paint6_linear_1331_7994)"/>
        <path d="M85.885 80.0035C84.7009 90.6702 92.3856 100.279 103.052 101.463L107.62 101.97C110.602 102.304 113.202 104.135 114.521 106.827L115.638 109.109L117.228 107.127C119.103 104.788 122.047 103.575 125.029 103.903C135.696 105.088 145.304 97.4028 146.488 86.7361C147.672 76.0693 139.987 66.461 129.321 65.2768L107.344 62.8361C96.6775 61.6471 87.0692 69.3367 85.885 80.0035Z" fill="url(#paint7_radial_1331_7994)"/>
        <path d="M85.8852 80.0031C85.8369 80.4236 85.8079 80.8441 85.7886 81.2646C86.9437 81.3709 88.1278 81.5691 89.3313 81.8929C98.1325 84.2708 101.09 91.3901 107.335 96.0927C108.775 97.1753 110.505 98.2193 112.613 99.0989C115.856 92.6273 122.782 88.4322 130.442 89.0411L145.758 90.2591C145.894 89.8193 146.015 89.3698 146.116 88.9106C141.752 86.4264 135.507 83.8117 128.001 83.8745C119.128 83.9518 116.73 87.7072 110.66 86.0494C102.067 83.7102 101.989 74.1888 92.874 71.5789C91.6802 71.2358 90.5009 71.0231 89.3506 70.8975C87.4995 73.5025 86.2622 76.6006 85.8852 80.0031Z" fill="url(#paint8_linear_1331_7994)"/>
        <path d="M101.627 101.245C99.7127 100.568 97.8036 99.8866 95.8896 99.21C97.6441 100.162 99.5677 100.858 101.627 101.245Z" fill="url(#paint9_linear_1331_7994)"/>
        <path d="M107.339 96.0928C101.095 91.3901 98.137 84.2709 89.3358 81.893C88.1324 81.5691 86.9483 81.371 85.7931 81.2646C85.4403 88.8479 89.5292 95.7303 95.8896 99.2053C97.8035 99.882 99.7126 100.563 101.627 101.24C102.095 101.327 102.569 101.404 103.052 101.458L107.62 101.965C108.891 102.105 110.089 102.521 111.153 103.159C111.481 101.728 111.979 100.37 112.617 99.0942C110.505 98.2194 108.775 97.1754 107.339 96.0928Z" fill="url(#paint10_linear_1331_7994)"/>
        <path d="M107.339 96.0928C101.095 91.3901 98.137 84.2709 89.3358 81.893C88.1324 81.5691 86.9483 81.371 85.7931 81.2646C85.4403 88.8479 89.5292 95.7303 95.8896 99.2053C97.8035 99.882 99.7126 100.563 101.627 101.24C102.095 101.327 102.569 101.404 103.052 101.458L107.62 101.965C108.891 102.105 110.089 102.521 111.153 103.159C111.481 101.728 111.979 100.37 112.617 99.0942C110.505 98.2194 108.775 97.1754 107.339 96.0928Z" fill="url(#paint11_linear_1331_7994)"/>
        <path d="M112.612 99.0949C118.214 101.424 126.474 102.551 138.934 100.047C142.114 97.6256 144.545 94.2327 145.758 90.2502L130.442 89.0322C122.781 88.4281 115.855 92.6281 112.612 99.0949Z" fill="url(#paint12_linear_1331_7994)"/>
        <path opacity="0.3" d="M112.612 99.0949C118.214 101.424 126.474 102.551 138.934 100.047C142.114 97.6256 144.545 94.2327 145.758 90.2502L130.442 89.0322C122.781 88.4281 115.855 92.6281 112.612 99.0949Z" fill="#57D9A3"/>
        <path d="M114.517 106.828L115.633 109.109L117.223 107.127C117.296 107.036 117.373 106.953 117.45 106.866C116.218 106.427 114.981 105.992 113.748 105.552C114.038 105.948 114.299 106.373 114.517 106.828Z" fill="url(#paint13_linear_1331_7994)"/>
        <path d="M114.517 106.828L115.633 109.109L117.223 107.127C117.296 107.036 117.373 106.953 117.45 106.866C116.218 106.427 114.981 105.992 113.748 105.552C114.038 105.948 114.299 106.373 114.517 106.828Z" fill="#DFE1E5"/>
        <path d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z" fill="url(#paint14_linear_1331_7994)"/>
        <path d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z" fill="url(#paint15_linear_1331_7994)"/>
        <path opacity="0.3" d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z" fill="#57D9A3"/>
        <g opacity="0.8">
        <g opacity="0.8">
        <path opacity="0.8" d="M102.452 74.6045L102.273 75.9459L133.149 80.0577L133.328 78.7163L102.452 74.6045Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M101.856 79.1006L101.677 80.442L132.553 84.5537L132.731 83.2124L101.856 79.1006Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M101.253 83.5947L101.074 84.9361L131.95 89.0479L132.128 87.7065L101.253 83.5947Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M100.656 88.0889L100.478 89.4303L120.68 92.1206L120.858 90.7792L100.656 88.0889Z" fill="#E3FCEF"/>
        </g>
        </g>
        <path d="M43.4788 173.859C45.7987 182.969 55.0638 188.474 64.1743 186.154L68.0747 185.163C70.6218 184.516 73.3187 185.217 75.2326 187.014L76.8517 188.542L77.5429 186.425C78.3597 183.926 80.3992 182.022 82.9415 181.374C92.052 179.054 97.557 169.789 95.237 160.679C92.9171 151.568 83.652 146.063 74.5415 148.383L55.7695 153.163C46.6638 155.478 41.1588 164.743 43.4788 173.859Z" fill="url(#paint16_radial_1331_7994)"/>
        <path d="M66.0304 180.432C71.5692 182.061 80.1625 182.041 93.1589 173.926C95.2275 170.63 96.17 166.638 95.6093 162.578C91.2643 161.892 85.3389 161.669 79.2056 164.043C71.951 166.846 71.1487 170.659 65.6582 171.181C57.8865 171.916 54.89 164.134 46.6108 164.806C45.5281 164.893 44.4938 165.082 43.5127 165.333C42.7974 168.04 42.7394 170.959 43.4789 173.868C43.5707 174.231 43.677 174.584 43.793 174.932C44.7742 174.661 45.8085 174.458 46.8911 174.352C54.8416 173.578 59.4621 178.499 66.0304 180.432Z" fill="url(#paint17_linear_1331_7994)"/>
        <path d="M75.2326 187.014L76.8517 188.542L77.5428 186.425C77.5767 186.328 77.6105 186.236 77.6443 186.14C76.4989 186.159 75.3486 186.183 74.2031 186.202C74.5656 186.444 74.9136 186.71 75.2326 187.014Z" fill="url(#paint18_linear_1331_7994)"/>
        <path d="M62.9369 186.415C61.1583 186.449 59.3797 186.483 57.606 186.517C59.3411 186.758 61.1342 186.734 62.9369 186.415Z" fill="url(#paint19_linear_1331_7994)"/>
        <path d="M57.6061 186.516C59.3847 186.482 61.1633 186.448 62.9371 186.415C63.3479 186.342 63.7636 186.26 64.1744 186.154L68.0747 185.163C70.1917 184.622 72.4198 185.018 74.208 186.207C75.3535 186.187 76.5038 186.163 77.6492 186.144C78.524 183.79 80.5008 182.002 82.9464 181.379C87.359 180.257 90.9211 177.502 93.1637 173.926C80.1673 182.045 71.574 182.06 66.0352 180.431C59.4621 178.503 54.8416 173.578 46.891 174.346C45.8036 174.453 44.7741 174.656 43.793 174.926C45.8374 181.248 51.3182 185.627 57.6061 186.516Z" fill="url(#paint20_linear_1331_7994)"/>
        <path d="M57.6061 186.516C59.3847 186.482 61.1633 186.448 62.9371 186.415C63.3479 186.342 63.7636 186.26 64.1744 186.154L68.0747 185.163C70.1917 184.622 72.4198 185.018 74.208 186.207C75.3535 186.187 76.5038 186.163 77.6492 186.144C78.524 183.79 80.5008 182.002 82.9464 181.379C87.359 180.257 90.9211 177.502 93.1637 173.926C80.1673 182.045 71.574 182.06 66.0352 180.431C59.4621 178.503 54.8416 173.578 46.891 174.346C45.8036 174.453 44.7741 174.656 43.793 174.926C45.8374 181.248 51.3182 185.627 57.6061 186.516Z" fill="url(#paint21_linear_1331_7994)"/>
        <path d="M81.9726 158.076L55.3887 164.237L55.6942 165.556L82.2782 159.394L81.9726 158.076Z" fill="#E3FCEF"/>
        <path d="M82.8594 161.945L56.2754 168.102L56.5807 169.42L83.1647 163.264L82.8594 161.945Z" fill="#E3FCEF"/>
        <path d="M83.7612 165.815L57.1772 171.977L57.4828 173.295L84.0668 167.133L83.7612 165.815Z" fill="#E3FCEF"/>
        <path d="M75.4735 171.812L58.0757 175.845L58.3813 177.163L75.779 173.131L75.4735 171.812Z" fill="#E3FCEF"/>
        <path d="M187.289 120.539C199.301 120.539 209.038 110.802 209.038 98.7902C209.038 86.7785 199.301 77.041 187.289 77.041C175.277 77.041 165.54 86.7785 165.54 98.7902C165.54 110.802 175.277 120.539 187.289 120.539Z" fill="url(#paint22_linear_1331_7994)"/>
        <path d="M166.028 94.208C164.085 103.164 168.015 112.27 175.535 117.093C176.086 115.575 176.448 113.966 176.584 112.279C177.207 104.425 172.78 97.3351 166.028 94.208Z" fill="#FFAB00"/>
        <path d="M178.333 94.885C179.612 94.885 180.648 93.8485 180.648 92.57C180.648 91.2914 179.612 90.2549 178.333 90.2549C177.055 90.2549 176.018 91.2914 176.018 92.57C176.018 93.8485 177.055 94.885 178.333 94.885Z" fill="#FF991F"/>
        <path d="M198.333 100.859C199.612 100.859 200.648 99.8222 200.648 98.5436C200.648 97.265 199.612 96.2285 198.333 96.2285C197.055 96.2285 196.018 97.265 196.018 98.5436C196.018 99.8222 197.055 100.859 198.333 100.859Z" fill="#FF991F"/>
        <path d="M175.825 100.327C177.483 103.759 180.465 106.538 184.375 107.804C188.285 109.07 192.33 108.553 195.685 106.746L175.825 100.327Z" fill="#FF991F"/>
        <path d="M127.595 14.1849C127.609 14.1269 127.788 14.1704 128.296 14.0399C128.576 13.9674 128.735 13.9239 128.851 13.8369C129.262 13.5228 129.083 12.6721 129.049 12.5078C129.852 12.5078 130.659 12.5078 131.461 12.5078C131.447 12.7301 131.432 13.0105 131.418 13.3343C131.403 13.7354 131.403 13.8224 131.461 13.9143C131.669 14.2767 132.268 14.1608 132.302 14.3154C132.341 14.4991 131.539 15.0017 130.562 15.1081C128.962 15.2869 127.542 14.3637 127.595 14.1849Z" fill="#9C7761"/>
        <path d="M127.46 17.3116C126.952 17.7659 125.314 16.6785 124.652 16.2435C123.525 15.4943 121.824 13.2566 120.36 11.0527C120.176 10.7772 120.06 10.4679 120.012 10.144C119.828 8.94542 119.388 6.06002 119.113 4.46508C119.862 3.99626 120.137 4.39742 120.713 4.35392C121.191 6.36934 121.602 8.08028 122.08 10.0957C122.283 10.3084 122.607 10.6564 123.028 11.0623C125.125 13.0971 126.053 13.3533 126.865 14.7114C127.382 15.562 127.89 16.925 127.46 17.3116Z" fill="#B08874"/>
        <path d="M128.59 9.6953C128.387 9.55997 128.063 9.37147 127.851 8.97515C127.551 8.42417 127.498 7.54937 127.962 7.21105C128.184 7.04673 128.469 7.06606 128.677 7.08056C129.127 7.10956 129.446 7.32221 129.586 7.42854C129.745 7.38988 129.973 7.34155 130.248 7.32221C130.722 7.28838 131.534 7.21105 132.21 7.69437C133.046 8.28885 133.191 9.22165 133.23 9.43914C133.433 10.7151 132.66 11.6479 132.515 11.8219C132.148 12.2665 131.843 12.629 131.418 12.6387C130.456 12.6629 130.374 10.8794 128.59 9.6953Z" fill="#172B4D"/>
        <path d="M132.119 10.5895C132.268 10.6427 132.215 11.3387 132.022 11.822C131.645 12.7693 130.625 13.1849 130.166 13.3396C129.731 13.2864 129.296 13.2333 128.866 13.1849C128.523 12.5373 128.049 11.4208 128.068 9.99988C128.073 9.53107 128.131 9.11058 128.209 8.75293C128.465 8.92209 128.871 9.15408 129.407 9.29908C130.442 9.58423 131.157 9.33774 131.389 9.73406C131.597 10.0869 131.22 10.6185 131.5 10.8554C131.582 10.9279 131.688 10.9375 131.751 10.9423C131.882 10.749 132.032 10.5605 132.119 10.5895Z" fill="#B08874"/>
        <path d="M128.344 11.3435C128.745 11.3435 129.069 11.0189 129.069 10.6185C129.069 10.2181 128.745 9.89355 128.344 9.89355C127.944 9.89355 127.619 10.2181 127.619 10.6185C127.619 11.0189 127.944 11.3435 128.344 11.3435Z" fill="#172B4D"/>
        <path d="M130.137 11.3961C130.567 11.3961 130.915 11.0477 130.915 10.618C130.915 10.1882 130.567 9.83984 130.137 9.83984C129.707 9.83984 129.359 10.1882 129.359 10.618C129.359 11.0477 129.707 11.3961 130.137 11.3961Z" fill="#172B4D"/>
        <path d="M128.803 10.6182H129.712" stroke="#172B4D" stroke-width="0.7343" stroke-miterlimit="10"/>
        <path d="M130.562 10.6182H131.471" stroke="#172B4D" stroke-width="0.7343" stroke-miterlimit="10"/>
        <path d="M125.038 12.7451C124.709 13.0496 124.381 13.3493 124.047 13.6538C123.535 14.1226 123.028 14.5817 122.52 15.036C122.636 15.355 122.863 15.8625 123.317 16.3603C123.694 16.7711 124.062 16.9935 124.328 17.153C125.038 17.5734 125.454 17.8248 125.942 17.7523C126.667 17.6459 126.778 16.9596 127.547 16.9113C128.03 16.8823 128.18 17.1433 128.378 17.0176C128.919 16.6745 128.581 14.3449 127.45 13.8567C127.228 13.7601 126.909 13.8181 126.329 13.6103C126.014 13.4991 125.826 13.3928 125.758 13.3493C125.415 13.1414 125.183 12.9094 125.038 12.7451Z" fill="#79E2F2"/>
        <path d="M126.865 13.7455C126.391 13.8131 126.121 14.6058 126.014 14.9634C125.628 16.2249 125.599 17.3413 125.589 18.1823C125.565 19.9416 125.618 20.5602 125.57 22.4403C125.56 22.8705 125.555 23.088 125.541 23.3586C125.488 24.5137 125.338 25.9975 124.951 27.7471C126.072 28.3174 128.054 29.1246 130.611 29.1439C131.66 29.1536 132.578 29.0279 133.332 28.8636C133.404 27.3798 133.511 25.8428 133.651 24.2576C133.704 23.6583 133.772 22.8995 133.873 22.0537C134.038 20.6714 134.323 18.7478 134.854 16.4182C134.753 16.1717 134.574 15.814 134.26 15.4564C134.202 15.3887 133.926 15.0842 133.448 14.7701C132.728 14.2964 132.027 14.1418 131.645 14.0789C131.017 14.8039 130.089 15.1036 129.306 14.8378C128.692 14.6299 128.363 14.1418 128.252 13.9533C128.102 13.934 127.87 13.905 127.585 13.8566C127.092 13.7745 127 13.7261 126.865 13.7455Z" fill="#79E2F2"/>
        <path d="M133.259 15.0887C134.129 14.8373 135.637 17.2201 136.362 18.9842C137.029 20.6033 137.208 22.1161 137.227 23.2712C137.232 23.7255 136.981 24.1363 136.575 24.3442C135.594 24.842 134.24 25.3785 132.578 25.6491C131.065 25.8956 129.76 25.8473 128.789 25.7361C128.76 25.3736 128.731 25.016 128.702 24.6535C129.963 24.4602 131.399 24.1508 132.936 23.6434C133.738 23.3824 134.482 23.0924 135.164 22.8024C134.84 21.9759 134.347 20.961 133.569 19.9267C133.216 19.4578 132.858 19.0519 132.515 18.7039C132.428 15.5382 133.027 15.1563 133.259 15.0887Z" fill="#B08874"/>
        <path d="M133.124 20.7144C133.443 20.4292 133.96 20.0378 134.685 19.7429C135.459 19.4288 136.15 19.3563 136.59 19.3418C136.155 18.1673 135.647 17.2877 135.256 16.6932C134.574 15.6492 134.115 15.2868 133.984 15.1853C133.525 14.8276 132.225 13.9721 131.679 14.3733C130.954 14.9049 131.863 17.4182 132.486 19.134C132.733 19.8154 132.965 20.3616 133.124 20.7144Z" fill="#79E2F2"/>
        <path d="M118.388 3.11218L119.113 4.4558L120.712 4.34464L120.964 2.96719C120.964 2.96719 121.186 1.56557 120.911 1.22242C120.862 1.15958 120.756 1.17408 120.674 1.23692C120.548 1.33358 120.49 1.80239 120.49 1.80239L120.287 2.28571C120.287 2.28571 120.181 0.579606 120.132 0.0914571C120.123 0.00446028 119.789 0.00446028 119.775 0.0914571C119.717 0.482943 119.664 1.86039 119.664 1.86039C119.664 1.86039 119.475 0.415279 119.34 0.0334592C119.311 -0.0535376 119.001 -0.000372879 118.982 0.0914571C118.91 0.482943 119.161 2.04889 119.161 2.04889C119.161 2.04889 118.885 0.84543 118.716 0.424945C118.687 0.347614 118.373 0.395946 118.383 0.482943C118.422 0.956592 118.649 2.32921 118.649 2.32921C118.649 2.32921 118.465 1.42541 118.325 0.971092C118.306 0.908261 118.088 1.03876 118.093 1.10642C118.132 1.58974 118.388 3.11218 118.388 3.11218Z" fill="#B08874"/>
        <path d="M86.5468 230.692L75.4209 187.962L76.5084 187.682L87.6343 230.407L86.5468 230.692Z" fill="url(#paint23_linear_1331_7994)"/>
        <path d="M86.5469 124.357L79.1812 75.6389L80.2928 75.4697L87.6585 124.188L86.5469 124.357Z" fill="url(#paint24_linear_1331_7994)"/>
        <path d="M142.457 234.123L141.543 233.466L165.255 200.484L166.168 201.142L142.457 234.123Z" fill="url(#paint25_linear_1331_7994)"/>
        <path d="M142.53 233.983L141.471 233.61L158.44 185.047L159.504 185.419L142.53 233.983Z" fill="url(#paint26_linear_1331_7994)"/>
        <path d="M141.969 234.133L140.853 234.017L146.087 182.524L147.203 182.636L141.969 234.133Z" fill="url(#paint27_linear_1331_7994)"/>
        <path d="M87.8421 230.435L84.4541 186.106L85.5754 186.019L88.9634 230.348L87.8421 230.435Z" fill="url(#paint28_linear_1331_7994)"/>
        <path d="M100.336 221.74C100.472 222.388 100.602 223.045 100.733 223.707C100.771 223.901 100.805 224.094 100.844 224.287C101.027 223.736 101.23 223.316 101.371 223.05C101.791 222.267 102.134 221.967 102.666 221.068C102.932 220.629 103.115 220.256 103.222 220.029C103.526 220.179 103.734 220.208 103.86 220.174C103.884 220.169 103.922 220.165 103.985 220.16C104.169 220.145 104.314 220.16 104.415 220.174C104.009 221.668 103.565 222.871 103.207 223.736C102.004 226.67 101.346 226.926 100.998 226.965C100.733 226.994 100.114 226.95 99.7224 226.54C99.5678 226.38 99.5146 226.206 99.4663 226.124C98.8379 225.022 98.664 223.983 98.606 223.35C99.1859 222.813 99.7611 222.277 100.336 221.74Z" fill="#E4B69D"/>
        <path d="M103.105 220.232C103.173 220.015 103.226 219.831 103.26 219.715C103.366 219.333 103.386 219.188 103.487 218.985C103.579 218.806 103.685 218.676 103.753 218.599L104.14 218.222H105.174L105.387 218.594V219.473V219.556C105.387 219.908 105.126 220.203 104.778 220.252L104.004 220.353C103.71 220.314 103.405 220.271 103.105 220.232Z" fill="#E4B69D"/>
        <path d="M125.782 177.223H124.656V236.419H125.782V177.223Z" fill="url(#paint29_linear_1331_7994)"/>
        <path d="M126.261 236.593L125.169 236.332L138.069 182.447L139.161 182.708L126.261 236.593Z" fill="url(#paint30_linear_1331_7994)"/>
        <path d="M88.0696 236.597C86.1992 236.597 84.6768 235.075 84.6768 233.204C84.6768 231.334 86.1992 229.812 88.0696 229.812C89.9401 229.812 91.4625 231.334 91.4625 233.204C91.4625 235.075 89.9401 236.597 88.0696 236.597ZM88.0696 230.933C86.8178 230.933 85.7981 231.953 85.7981 233.204C85.7981 234.456 86.8178 235.476 88.0696 235.476C89.3214 235.476 90.3412 234.456 90.3412 233.204C90.3412 231.953 89.3214 230.933 88.0696 230.933Z" fill="#EBECF0"/>
        <path d="M104.517 242.644C102.646 242.644 101.124 241.122 101.124 239.251C101.124 237.381 102.646 235.858 104.517 235.858C106.387 235.858 107.91 237.381 107.91 239.251C107.91 241.122 106.387 242.644 104.517 242.644ZM104.517 236.98C103.265 236.98 102.245 237.999 102.245 239.251C102.245 240.503 103.265 241.523 104.517 241.523C105.769 241.523 106.788 240.503 106.788 239.251C106.788 237.999 105.769 236.98 104.517 236.98Z" fill="#EBECF0"/>
        <path d="M125.222 242.644C123.352 242.644 121.829 241.122 121.829 239.251C121.829 237.381 123.352 235.858 125.222 235.858C127.092 235.858 128.615 237.381 128.615 239.251C128.615 241.122 127.092 242.644 125.222 242.644ZM125.222 236.98C123.97 236.98 122.95 237.999 122.95 239.251C122.95 240.503 123.97 241.523 125.222 241.523C126.474 241.523 127.494 240.503 127.494 239.251C127.494 237.999 126.474 236.98 125.222 236.98Z" fill="#EBECF0"/>
        <path d="M89.8868 221.764C89.4228 223.364 89.3407 224.635 89.3503 225.505C89.36 226.157 89.4228 226.563 89.4422 227.757C89.4615 228.961 89.418 229.816 89.4035 230.212C89.36 231.319 89.3793 233.011 89.6838 235.485C90.1091 235.553 90.5393 235.621 90.9646 235.693C91.0709 233.944 91.1193 232.112 91.0951 230.198C91.0854 229.57 91.0709 228.946 91.0468 228.337C91.2449 227.153 91.4093 225.858 91.5108 224.461C91.5833 223.422 91.6171 222.436 91.6171 221.513C91.0371 221.595 90.462 221.677 89.8868 221.764Z" fill="#EFC7B0"/>
        <path d="M91.2353 221.402C90.9839 220.755 90.6118 220.32 90.3701 220.078C89.7805 220.595 89.3262 223.379 89.3262 223.379C89.3262 223.379 90.3701 224.278 91.4963 224.128C91.7621 223.969 91.3561 223.205 91.6219 223.041C91.6703 222.683 91.5543 222.229 91.2353 221.402Z" fill="#FFAB00"/>
        <path d="M92.1198 216.714C92.0666 217.526 91.999 218.575 91.9458 219.807C94.2609 219.778 96.5808 219.744 98.8959 219.715C98.5479 219.387 97.9872 218.768 97.6634 217.835C97.0351 216.023 97.7698 214.423 97.9486 214.065C98.1806 214.089 98.4174 214.114 98.6494 214.143C98.6977 213.886 98.7606 213.379 98.5817 212.78C98.5286 212.591 98.3642 212.103 97.9727 211.673C97.1511 210.774 95.7398 210.585 94.6669 210.933C93.8452 211.199 93.3378 211.736 93.1686 211.929C92.5161 212.673 92.3373 213.529 92.1198 216.714Z" fill="#FF8F73"/>
        <path d="M92.0039 255.925C92.0281 256.278 92.0281 256.321 92.0377 257.061C92.0474 257.906 91.8976 258.095 92.0812 258.337C92.3084 258.641 92.8594 258.757 93.217 258.564C93.3088 258.515 93.4732 258.399 93.7777 257.249C93.9613 256.558 93.9806 256.21 93.9855 255.925C94.0096 255.026 93.5167 254.881 92.9947 254.881C92.4582 254.881 91.9652 255.326 92.0039 255.925Z" fill="#344563"/>
        <path d="M102.985 257.375C103.081 257.143 102.893 256.853 102.849 256.785C102.777 256.669 102.68 256.578 102.173 256.288C101.627 255.978 101.351 255.49 101.245 255.292C101.032 254.9 100.525 254.804 100.476 254.794C100.206 254.746 99.9205 254.804 99.6692 254.949C99.3502 255.128 99.4566 255.48 99.4517 255.848C99.4517 255.853 99.4517 255.853 99.4517 255.857C99.4421 256.307 99.4179 256.718 99.8335 256.882C99.8867 256.901 99.9447 256.925 100.003 256.94C100.264 257.017 100.317 256.988 100.568 257.051C101.192 257.215 101.235 257.52 101.723 257.66C102.202 257.81 102.849 257.699 102.985 257.375Z" fill="#344563"/>
        <path d="M94.261 250.087C94.058 251.914 93.8792 253.871 93.6762 255.142C93.6472 255.326 93.5409 255.485 93.3862 255.582C93.3862 255.582 93.3862 255.582 93.3814 255.582C93.2557 255.655 93.1929 255.693 93.1059 255.717C93.0721 255.727 92.7869 255.8 92.5356 255.626C92.4728 255.582 92.4341 255.539 92.4051 255.505C92.2746 252.764 92.1344 251.165 92.1393 251.034L92.1441 250.802C92.1489 250.585 92.1586 250.449 92.1683 249.976L94.261 250.087Z" fill="#36B37E"/>
        <path d="M92.1633 249.994C92.1778 248.453 92.1971 246.191 92.2116 243.436C92.2261 240.55 92.2358 239.105 92.2261 238.902C92.0811 235.785 91.5301 231.682 91.9361 229.966C92.0424 229.516 92.4436 228.255 92.5741 227.849C92.6127 227.728 92.6804 227.525 92.8012 227.269C92.9172 227.022 93.0381 226.815 93.1541 226.641C93.2749 226.689 93.4682 226.761 93.7147 226.834C93.9274 226.892 94.0917 226.921 94.1787 226.945C94.6765 227.061 95.6335 227.254 98.2144 227.665C98.3159 227.825 98.4705 228.076 98.6445 228.39C98.6445 228.39 99.2873 229.55 99.7658 230.952C100.186 232.194 100.81 236.017 100.757 241.208C100.935 243.383 101.051 245.703 101.076 248.148C101.085 249.134 101.08 250.101 101.066 251.048L99.1278 251.063C98.7654 247.689 98.1805 244.006 97.2767 240.082C96.7838 237.941 96.2376 235.915 95.6625 234.006C95.3241 237.559 95.0052 241.14 94.6958 244.746C94.546 246.529 94.3962 248.313 94.2512 250.086L92.1633 249.994Z" fill="#FFAB00"/>
        <path d="M98.7026 218.797C98.6881 218.792 98.6785 218.792 98.664 218.787C97.4557 218.536 96.8564 218.357 96.7307 218.193C96.3682 217.739 96.9385 217.047 96.5954 216.695C96.3682 216.463 95.909 216.545 95.5272 216.661C94.8651 216.279 94.5606 216.322 94.4011 216.429C93.8888 216.772 94.5703 218.048 93.9468 218.657C93.4538 219.135 92.4823 218.874 92.4388 219.126C92.4195 219.242 92.6128 219.372 92.7772 219.464C93.3475 220.116 94.3479 221.436 94.8409 223.388C95.2372 224.964 95.1406 226.308 95.0149 227.115C95.4064 227.294 96.1942 227.589 97.1947 227.497C97.736 227.448 98.1758 227.303 98.4851 227.168C98.4078 226.559 98.3595 225.689 98.5045 224.66C98.5963 224.012 98.6688 223.514 98.8621 223.234C98.3546 221.885 98.7413 220.3 98.7026 218.797Z" fill="#E4B69D"/>
        <path d="M98.4462 214.118C98.4027 214.278 98.3641 214.432 98.3206 214.592C98.3447 214.616 98.3834 214.664 98.4366 214.718C98.6009 214.892 98.7169 214.969 98.7024 215.051C98.6975 215.066 98.6927 215.08 98.683 215.09C98.596 215.196 98.2916 215.259 98.2287 215.355C98.2191 215.384 97.9967 216.332 97.9871 216.361C97.9822 216.37 97.9291 216.612 97.8759 216.82C97.8324 217.004 97.6826 217.149 97.4941 217.178C97.1509 217.231 96.7111 217.26 96.2133 217.211C95.5415 217.144 95.0099 216.95 94.6619 216.796C94.5169 216.366 94.5797 216.109 94.657 215.96C94.8987 215.486 95.4448 215.631 95.7348 215.133C95.9185 214.814 95.8943 214.505 96.165 214.379C96.2761 214.326 96.3293 214.355 96.5275 214.345C97.0156 214.316 97.1751 214.099 97.5714 214.022C97.7648 213.988 98.0547 213.973 98.4462 214.118Z" fill="#EFC7B0"/>
        <path d="M101.08 250.125C101.076 251.846 101.042 253.76 100.916 255.301C100.829 255.354 100.481 255.548 100.008 255.49H100.003C99.7997 255.466 99.645 255.292 99.6402 255.084C99.5822 253.407 99.2439 251.676 99.0747 250.241L101.08 250.125Z" fill="#36B37E"/>
        <path d="M101.187 255.5C101.187 255.5 101.346 255.795 101.535 255.974C101.612 256.046 101.583 256.114 101.525 256.162C101.414 256.264 101.24 256.264 101.119 256.172L100.544 255.732C100.631 255.732 100.781 255.722 100.94 255.65C101.051 255.606 101.129 255.548 101.187 255.5Z" fill="#57D9A3"/>
        <path d="M93.391 256.215L92.4243 256.182L92.5258 256.766H93.2025L93.391 256.215Z" fill="#57D9A3"/>
        <path d="M99.6544 219.218C99.2726 219.551 98.7796 220.054 98.3253 220.755C97.8806 221.441 97.6293 222.084 97.4795 222.567C97.5665 222.644 97.6535 222.736 97.7405 222.847C98.0111 223.2 98.1175 223.558 98.1658 223.8C98.9923 223.408 99.8767 222.915 100.708 222.524C100.665 222.098 100.529 221.721 100.394 221.204C100.191 220.412 99.9154 219.749 99.6544 219.218Z" fill="#FFAB00"/>
        <path d="M99.6498 219.207C99.6063 219.178 99.5386 219.135 99.4516 219.082C99.1375 218.893 98.7315 218.705 97.7214 218.434C97.4652 218.366 97.1269 218.279 96.7257 218.192C96.7064 218.444 96.6581 218.734 96.5711 219.048C96.3922 219.681 96.1071 220.164 95.8751 220.488C95.2564 219.869 94.9085 218.975 94.1013 218.294C92.9172 218.468 92.0472 218.942 91.6364 219.178C91.1434 219.454 90.7229 219.768 90.3701 220.077C90.6118 220.314 91.0323 220.802 91.2884 221.542C91.5542 222.31 91.5107 222.977 91.4624 223.311C91.3948 223.987 91.4624 224.504 91.5349 224.843C91.6702 225.486 91.8781 225.8 92.1922 226.684C92.4 227.274 92.5305 227.762 92.603 228.062C94.546 228.042 96.4889 228.028 98.4318 228.009C98.5478 227.549 98.6735 227.153 98.7846 226.839C99.0988 225.954 99.2003 225.679 99.3888 224.968C99.5241 224.456 99.5918 224.205 99.6256 223.881C99.6788 223.369 99.6159 223.161 99.5966 222.243C99.5918 221.977 99.5918 221.692 99.5966 221.121C99.6111 220.604 99.6208 219.956 99.6498 219.207Z" fill="#FFC400"/>
        <path d="M95.0778 218.396C95.1358 217.212 95.0343 217.154 95.0972 216.308C95.218 214.79 95.5998 214.312 95.334 214.046C94.928 213.65 93.4539 214.162 92.5404 215.133C91.0035 216.762 90.8295 219.904 92.1586 220.803C92.8884 221.296 94.1402 221.17 94.696 220.546C94.986 220.223 95.0198 219.609 95.0778 218.396Z" fill="#FF8F73"/>
        <path d="M134.438 254.601L133.245 256.119L131.393 257.057L131.384 257.235L134.999 257.081L135.192 256.448L135.381 257.061L135.772 257.086L136.202 254.311L134.226 254.205L134.438 254.601Z" fill="#A5ADBA"/>
        <path d="M132.128 231.542C132.273 235.36 132.544 239.41 132.989 243.664C133.385 247.433 133.878 251.015 134.439 254.398C134.903 254.451 135.367 254.509 135.831 254.562C135.594 252.561 135.381 250.502 135.197 248.39C134.999 246.109 134.845 243.886 134.729 241.725C134.854 238.753 134.975 235.776 135.101 232.803L132.128 231.542Z" fill="#B3BAC5"/>
        <path d="M138.092 234.863C139.053 234.863 139.832 234.084 139.832 233.123C139.832 232.162 139.053 231.383 138.092 231.383C137.132 231.383 136.353 232.162 136.353 233.123C136.353 234.084 137.132 234.863 138.092 234.863Z" fill="#A5ADBA"/>
        <path d="M134.458 231.668C134.448 232.432 134.41 233.519 134.279 234.824C134.24 235.187 134.211 235.438 134.202 235.534C133.912 237.966 134.366 241.818 134.511 243.33C134.666 244.983 134.84 246.66 135.028 248.357C135.284 250.657 135.57 252.91 135.869 255.114C136.333 255.08 136.802 255.051 137.266 255.017C137.735 253.321 138.146 251.073 138.097 248.429C138.073 247.168 137.947 246.027 137.778 245.017C138.01 244.292 138.32 243.277 138.648 242.05C139.368 239.358 139.857 237.477 139.939 235.075C139.968 234.23 139.953 233.181 139.813 231.972C138.03 231.871 136.246 231.769 134.458 231.668Z" fill="#C1C7D0"/>
        <path d="M136.203 254.311C136.72 254.306 137.232 254.297 137.749 254.292C137.658 254.456 137.571 254.65 137.503 254.872C137.266 255.655 137.416 256.351 137.527 256.713C137.542 256.829 137.556 256.95 137.571 257.066L136.889 257.095L135.415 257.158L135.43 256.844L135.729 256.38C135.647 255.684 135.565 254.993 135.483 254.297C135.729 254.297 135.966 254.302 136.203 254.311Z" fill="#A5ADBA"/>
        <path d="M128.871 219.517C128.856 219.44 128.721 218.512 129.219 218.125C129.605 217.821 129.968 218.14 130.49 217.821C130.823 217.613 130.968 217.299 131.254 216.666C131.577 215.95 131.548 215.665 131.722 215.24C131.906 214.786 132.302 214.172 133.279 213.601C133.221 213.427 133.163 213.162 133.24 212.876C133.438 212.127 134.366 211.852 134.632 211.774C135.594 211.489 136.454 211.828 136.85 211.992C138.798 212.789 139.518 214.732 139.576 214.897C140.108 216.409 139.687 217.729 139.397 218.647C139.117 219.541 138.745 220.716 137.677 221.591C135.391 223.456 132.09 222.156 131.655 221.982C131.08 221.76 129.103 220.982 128.871 219.517Z" fill="#7A869A"/>
        <path d="M132.5 222.789C132.873 222.929 132.911 223.91 132.887 225.22C132.863 226.752 132.728 228.13 132.554 229.309C132.94 229.347 133.327 229.391 133.723 229.425C134.622 229.512 135.507 229.584 136.382 229.647C136.179 228.671 135.884 226.564 136.696 224.118C137.329 222.219 138.363 220.923 139.011 220.227C139.325 220.077 139.378 219.971 139.373 219.903C139.344 219.497 137.213 219.295 135.758 219.28C134.579 219.27 133.989 219.265 133.279 219.464" fill="#8E572A"/>
        <path d="M134.207 213.398C133.931 213.93 133.757 214.863 133.709 215.332C133.704 215.414 133.709 215.453 133.588 215.578C133.467 215.709 133.279 215.805 133.351 215.902C133.428 215.999 133.694 216.071 133.747 216.163L134.042 217.768L134.738 217.806L135.816 217.864C136.362 217.589 136.478 217.429 136.459 217.333C136.42 217.154 135.917 217.27 135.507 216.902C135.478 216.878 135.11 216.545 135.12 216.091C135.125 215.772 135.313 215.772 135.313 215.511C135.309 215.245 135.091 215.022 134.414 214.206C134.371 214.152 134.342 214.109 134.323 214.065C134.274 213.964 134.269 213.877 134.265 213.78C134.25 213.688 134.236 213.558 134.207 213.398Z" fill="#8E572A"/>
        <path d="M131.21 221.909C130.703 223.427 130.572 224.645 130.553 225.481C130.538 226.109 130.582 226.501 130.553 227.646C130.524 228.806 130.451 229.623 130.422 230C130.34 231.059 130.297 232.682 130.49 235.075C130.896 235.157 131.302 235.239 131.713 235.321C131.882 233.649 131.998 231.89 132.046 230.053C132.061 229.449 132.07 228.85 132.07 228.265C132.307 227.134 132.515 225.897 132.665 224.563C132.776 223.572 132.844 222.625 132.877 221.735C132.322 221.793 131.766 221.851 131.21 221.909Z" fill="#8E572A"/>
        <path d="M133.559 219.319C133.1 219.575 132.554 219.957 132.037 220.523C130.572 222.123 130.398 224.051 130.374 224.761C130.524 224.877 130.775 225.037 131.118 225.134C131.568 225.264 131.954 225.216 132.157 225.177C132.085 224.583 132.017 223.988 131.945 223.394C132.481 222.036 133.023 220.677 133.559 219.319Z" fill="#DFE1E5"/>
        <path d="M139.296 223.055L143.554 227.545C143.017 228.034 142.452 228.599 141.872 229.247C141.258 229.938 140.736 230.61 140.296 231.233C140.306 231.615 140.321 231.992 140.33 232.374C140.717 232.156 141.142 231.992 141.737 231.663C142.336 231.325 143.09 230.88 143.834 230.175C144.26 229.774 144.859 229.111 145.391 228.121C145.526 227.869 145.545 227.57 145.444 227.304C144.96 226.076 144.153 224.496 142.776 222.954C142.109 222.205 141.437 221.61 140.818 221.132C140.311 221.77 139.803 222.413 139.296 223.055Z" fill="#8E572A"/>
        <path d="M143.017 223.224C142.756 222.736 140.606 220.237 139.852 219.957C139.533 221.011 139.218 222.059 138.899 223.113C139.025 223.186 139.209 223.292 139.421 223.442C139.726 223.654 139.939 223.848 140.214 224.099C140.349 224.22 140.741 224.602 140.741 224.602C140.741 224.602 142.766 223.553 143.017 223.224Z" fill="#DFE1E5"/>
        <path d="M140.301 231.233L138.88 230.929L137.648 231.248L137.658 232.606L139.262 232.789L140.495 232.287L140.301 231.233Z" fill="#8E572A"/>
        <path d="M134.651 217.439C134.487 217.656 134.598 217.859 134.555 218.27C134.521 218.565 134.41 218.98 134.038 219.464C134.279 219.599 134.767 219.831 135.42 219.846C136.261 219.865 136.87 219.517 137.102 219.367C136.981 219.324 136.778 219.227 136.652 219.024C136.618 218.966 136.517 218.787 136.57 218.202C136.614 217.704 136.749 217.613 136.667 217.453C136.531 217.187 136.063 217.173 135.724 217.168C135.347 217.158 134.874 217.144 134.651 217.439Z" fill="#8E572A"/>
        <path d="M139.383 224.853C139.475 224.587 140.195 222.63 140.195 222.63V222.625C140.5 221.987 140.814 221.45 141.089 221.025C140.794 220.672 140.297 220.16 139.538 219.783C138.972 219.498 138.431 219.377 137.711 219.29C137.687 219.285 137.663 219.285 137.638 219.28C137.305 219.561 136.976 219.846 136.643 220.126C136.652 220.44 136.715 220.561 136.744 220.605C136.875 220.822 137.092 220.924 137.223 220.972C136.976 221.131 136.324 221.504 135.43 221.484C134.734 221.47 134.212 221.223 133.956 221.078C134.158 220.817 134.289 220.576 134.371 220.358C134.101 220.01 133.825 219.662 133.554 219.314C133.284 219.793 132.912 220.498 132.525 221.383C132.003 222.576 131.742 223.176 131.723 223.775C131.684 224.921 132.095 225.133 132.457 226.636C132.578 227.153 132.51 227.748 132.365 228.937C132.264 229.763 132.066 230.909 131.621 232.257C133.269 232.75 134.642 232.929 135.599 232.992C136.744 233.069 137.315 232.987 137.653 232.6C138.03 232.17 137.904 231.61 138.378 231.266C138.726 231.015 139.17 231.044 139.465 231.097C138.774 227.729 139.011 225.907 139.383 224.853Z" fill="#DFE1E5"/>
        <path d="M129.92 235.433C129.92 235.433 129.9 235.863 129.847 236.341C129.794 236.82 130.06 237.695 130.258 238.052C130.456 238.41 130.63 238.676 130.867 238.758C131.104 238.835 131.007 238.651 131.167 238.637C131.326 238.622 131.452 238.526 131.452 238.526C131.452 238.526 131.452 237.956 131.452 237.496C131.452 237.037 131.452 236.858 131.452 236.858C131.452 236.858 131.592 237.83 131.693 237.844C131.79 237.859 131.848 237.757 131.848 237.757C131.848 237.757 132.046 237.071 131.93 236.414C131.814 235.756 131.22 235.307 131.22 234.959C131.22 234.611 129.92 235.433 129.92 235.433Z" fill="#8E572A"/>
        <path d="M135.884 233.77L135.217 237.197C135.067 237.97 134.39 238.531 133.603 238.531H97.32C96.5322 238.531 95.8556 237.97 95.7057 237.197L95.0388 233.77C94.8889 232.997 94.2123 232.437 93.4245 232.437H84.4977C83.444 232.437 82.6659 233.408 82.8882 234.437L89.7948 266.041C90.4279 268.937 92.9895 271 95.9571 271H134.714C137.677 271 140.243 268.937 140.876 266.041L147.783 234.437C148.005 233.413 147.227 232.437 146.174 232.437H137.513C136.715 232.437 136.034 232.997 135.884 233.77Z" fill="url(#paint31_linear_1331_7994)"/>
        <path d="M125.874 24.9388C126.585 24.4652 126.938 24.2235 127.199 24.1752C127.75 24.0737 127.75 24.354 128.895 24.4362C129.359 24.47 129.553 24.4362 129.698 24.6005C129.944 24.8712 129.896 25.4801 129.577 25.7121C129.417 25.8281 129.238 25.8233 128.958 25.8136C128.799 25.8088 128.692 25.7895 128.122 25.6493C127.523 25.5043 127.532 25.4995 127.479 25.4995C127.126 25.4995 126.972 25.6396 126.604 25.5961C126.459 25.5816 126.338 25.5381 126.266 25.5091C126.227 25.5333 126.121 25.5961 125.976 25.5961C125.821 25.5961 125.715 25.5333 125.676 25.5091C125.555 25.5043 125.411 25.485 125.386 25.4125C125.353 25.3158 125.565 25.1466 125.874 24.9388Z" fill="#B08874"/>
        <path d="M105.072 218.541C105.058 218.532 105.034 218.536 105.029 218.536C104.952 218.551 103.869 218.971 103.932 219.247C103.937 219.271 103.975 219.402 103.975 219.402C104.019 219.489 104.057 219.488 104.067 219.542C104.086 219.633 103.985 219.682 104.009 219.764C104.024 219.822 104.082 219.822 104.101 219.885C104.12 219.943 104.096 219.991 104.086 220.025C104.053 220.17 104.183 220.349 104.251 220.402C104.526 220.619 105.406 220.199 105.459 219.749C105.474 219.619 105.416 219.488 105.459 219.179C105.478 219.049 105.493 219.025 105.474 218.967C105.411 218.793 105.106 218.662 105.092 218.575C105.092 218.58 105.092 218.551 105.072 218.541Z" fill="#E4B69D"/>
        <path d="M169.175 145.043L168.136 144.613L177.507 122.124L178.546 122.554L169.175 145.043Z" fill="url(#paint32_linear_1331_7994)"/>
        <path d="M192.364 184.245C192.181 182.51 191.659 180.871 190.818 179.378C189.977 177.884 188.817 176.541 187.367 175.381C185.922 174.221 184.206 173.312 182.263 172.679C180.243 172.022 178.189 171.761 176.159 171.901C174.129 172.041 172.2 172.549 170.432 173.404C168.663 174.264 167.068 175.487 165.69 177.039C164.313 178.595 163.254 180.494 162.544 182.684C161.853 184.806 161.597 186.889 161.775 188.88C161.954 190.871 162.529 192.737 163.477 194.414C164.424 196.091 165.729 197.584 167.358 198.86C168.982 200.131 170.915 201.137 173.099 201.847C173.8 202.074 174.578 202.248 175.41 202.369C176.241 202.485 177.082 202.543 177.908 202.538C178.74 202.534 179.552 202.461 180.33 202.326C181.113 202.19 181.833 201.987 182.476 201.722C182.606 201.668 182.679 201.523 182.635 201.383L181.63 198.073C181.611 198 181.557 197.942 181.495 197.908C181.427 197.874 181.354 197.865 181.282 197.889C180.079 198.261 178.88 198.416 177.72 198.338C176.55 198.261 175.444 198.058 174.438 197.729C172.78 197.188 171.364 196.439 170.229 195.501C169.093 194.564 168.213 193.486 167.619 192.287C167.019 191.093 166.681 189.779 166.609 188.382C166.536 186.985 166.739 185.531 167.213 184.071C167.73 182.486 168.469 181.118 169.417 179.997C170.364 178.875 171.451 177.991 172.66 177.367C173.863 176.744 175.192 176.381 176.608 176.29C178.024 176.198 179.489 176.391 180.948 176.865C182.268 177.295 183.438 177.894 184.433 178.658C185.424 179.417 186.217 180.301 186.787 181.287C187.357 182.273 187.71 183.356 187.831 184.511C187.952 185.666 187.812 186.879 187.41 188.116C187.13 188.972 186.782 189.726 186.366 190.354C185.956 190.977 185.506 191.485 185.037 191.862C184.573 192.234 184.1 192.495 183.636 192.635C183.191 192.771 182.78 192.775 182.389 192.645C182.147 192.568 181.992 192.432 181.91 192.229C181.823 192.007 181.814 191.799 181.881 191.591C181.954 191.374 182.002 191.272 182.041 191.214L186.879 182.863C186.922 182.79 186.927 182.703 186.898 182.626C186.869 182.548 186.806 182.486 186.724 182.461L182.92 181.224C182.795 181.186 182.659 181.239 182.592 181.35L182.186 182.075C182.021 181.572 181.736 181.123 181.325 180.731C180.736 180.171 180.093 179.769 179.416 179.552C178.421 179.228 177.386 179.127 176.347 179.252C175.313 179.378 174.313 179.707 173.385 180.233C172.457 180.76 171.611 181.485 170.871 182.384C170.132 183.288 169.552 184.371 169.151 185.608C168.837 186.57 168.701 187.517 168.745 188.421C168.788 189.32 168.972 190.161 169.296 190.915C169.62 191.673 170.088 192.34 170.693 192.891C171.954 194.047 173.81 194.617 175.598 194.385C176.362 194.283 177.053 194.018 177.657 193.583C177.734 194.032 177.923 194.501 178.218 194.975C178.643 195.661 179.416 196.188 180.509 196.545L180.663 196.594C181.664 196.893 182.737 196.961 183.844 196.801C184.946 196.642 186.018 196.26 187.038 195.67C188.053 195.081 188.996 194.254 189.827 193.22C190.663 192.186 191.325 190.934 191.789 189.508C192.355 187.754 192.548 185.985 192.364 184.245ZM179.581 186.797C179.122 188.131 178.455 189.131 177.604 189.764C176.773 190.388 175.966 190.557 175.139 190.291C174.414 190.054 173.984 189.653 173.824 189.054C173.655 188.426 173.708 187.672 173.989 186.816C174.172 186.251 174.424 185.743 174.733 185.308C175.038 184.873 175.395 184.516 175.787 184.25C176.173 183.989 176.594 183.815 177.043 183.737C177.488 183.66 177.952 183.699 178.421 183.853C179.054 184.061 179.455 184.409 179.644 184.917C179.837 185.444 179.818 186.077 179.581 186.797Z" fill="url(#paint33_radial_1331_7994)"/>
        <path d="M119.558 116.064C117.706 102.458 105.179 92.9226 91.5736 94.7737L63.5364 98.5823C49.9311 100.433 40.3953 112.961 42.2464 126.566C44.0975 140.172 56.625 149.707 70.2304 147.856C74.0341 147.339 77.8329 148.804 80.3075 151.737L82.4051 154.222L83.7632 151.269C85.363 147.784 88.6399 145.358 92.4387 144.84L98.2627 144.048C111.873 142.202 121.404 129.669 119.558 116.064Z" fill="url(#paint34_linear_1331_7994)"/>
        <path opacity="0.5" d="M54.1503 111.463C51.7965 111.492 49.5249 111.153 47.3887 110.501C49.5491 111.777 51.9705 112.797 54.6722 113.367C65.2085 115.595 75.3147 110.124 81.0226 107.031C87.7455 103.391 87.2526 101.825 92.2404 99.9307C98.8763 97.4078 104.845 98.244 109.384 99.1913C104.405 95.6292 98.1175 93.8796 91.5734 94.7689L74.5993 97.0743C71.4868 105.378 63.5411 111.342 54.1503 111.463Z" fill="url(#paint35_linear_1331_7994)"/>
        <path opacity="0.5" d="M80.8538 131.429C70.709 129.442 63.0823 122.69 51.241 124.947C47.9593 125.576 45.0546 126.765 42.5269 128.19C43.2663 131.82 44.7694 135.126 46.8525 137.953C48.7761 136.938 50.8979 136.078 53.2371 135.508C64.9189 132.637 72.8839 138.944 83.0819 140.413C86.7647 136.17 92.3422 133.666 98.374 134.145L107.837 134.899C111.08 133.13 114.551 130.878 118.243 128.036C119.335 125.083 119.886 121.888 119.775 118.592C101.868 131.931 89.2587 133.072 80.8538 131.429Z" fill="url(#paint36_linear_1331_7994)"/>
        <path opacity="0.5" d="M113.971 135.386C115.798 133.207 117.243 130.722 118.238 128.035C114.546 130.877 111.076 133.129 107.833 134.898L113.971 135.386Z" fill="url(#paint37_linear_1331_7994)"/>
        <path d="M113.971 135.386C115.798 133.207 117.243 130.722 118.238 128.035C114.546 130.877 111.076 133.129 107.833 134.898L113.971 135.386Z" fill="url(#paint38_linear_1331_7994)"/>
        <path opacity="0.5" d="M53.2323 135.508C50.8978 136.083 48.7713 136.938 46.8477 137.953C52.0675 145.039 60.8928 149.127 70.2305 147.856C73.2995 147.441 76.3686 148.315 78.7417 150.21C79.1911 146.455 80.7571 143.086 83.077 140.408C72.8742 138.944 64.9092 132.637 53.2323 135.508Z" fill="url(#paint39_linear_1331_7994)"/>
        <path d="M53.2323 135.508C50.8978 136.083 48.7713 136.938 46.8477 137.953C52.0675 145.039 60.8928 149.127 70.2305 147.856C73.2995 147.441 76.3686 148.315 78.7417 150.21C79.1911 146.455 80.7571 143.086 83.077 140.408C72.8742 138.944 64.9092 132.637 53.2323 135.508Z" fill="url(#paint40_linear_1331_7994)"/>
        <path d="M45.8472 109.965C46.3498 110.163 46.8621 110.342 47.3841 110.501C46.925 110.23 46.4803 109.95 46.0453 109.66C45.9825 109.762 45.9148 109.863 45.8472 109.965Z" fill="#DFE1E5"/>
        <path opacity="0.5" d="M74.5949 97.0791L63.5318 98.5822C56.079 99.5972 49.8539 103.817 46.0454 109.66C46.4804 109.95 46.925 110.23 47.3842 110.501C49.5205 111.153 51.792 111.492 54.1458 111.463C63.5414 111.342 71.4872 105.378 74.5949 97.0791Z" fill="url(#paint41_linear_1331_7994)"/>
        <path d="M74.5949 97.0791L63.5318 98.5822C56.079 99.5972 49.8539 103.817 46.0454 109.66C46.4804 109.95 46.925 110.23 47.3842 110.501C49.5205 111.153 51.792 111.492 54.1458 111.463C63.5414 111.342 71.4872 105.378 74.5949 97.0791Z" fill="#0065FF"/>
        <path opacity="0.5" d="M107.832 134.898L98.3688 134.144C92.337 133.666 86.7595 136.165 83.0767 140.413C83.1008 140.418 83.1202 140.423 83.1443 140.423C89.2196 141.283 97.378 140.601 107.832 134.898Z" fill="url(#paint42_linear_1331_7994)"/>
        <path opacity="0.6" d="M107.832 134.898L98.3688 134.144C92.337 133.666 86.7595 136.165 83.0767 140.413C83.1008 140.418 83.1202 140.423 83.1443 140.423C89.2196 141.283 97.378 140.601 107.832 134.898Z" fill="#0065FF"/>
        <path opacity="0.5" d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z" fill="url(#paint43_linear_1331_7994)"/>
        <path d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z" fill="url(#paint44_linear_1331_7994)"/>
        <path d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z" fill="#0065FF"/>
        <g opacity="0.8">
        <g opacity="0.8">
        <path opacity="0.8" d="M97.4532 112.195L63.311 116.64L63.4957 118.058L97.6379 113.613L97.4532 112.195Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M98.1007 117.163L63.9585 121.608L64.1432 123.027L98.2854 118.582L98.1007 117.163Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M98.7477 122.131L64.6055 126.576L64.7902 127.995L98.9323 123.55L98.7477 122.131Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M84.0192 129.105L65.2563 131.548L65.441 132.966L84.2039 130.524L84.0192 129.105Z" fill="#B2D4FF"/>
        </g>
        </g>
        <path d="M82.4097 154.699C81.6074 164.781 89.1326 173.607 99.2146 174.409L103.531 174.752C106.348 174.975 108.857 176.627 110.176 179.126L111.297 181.243L112.738 179.329C114.439 177.072 117.175 175.84 119.992 176.062C130.074 176.864 138.9 169.339 139.702 159.257C140.504 149.175 132.979 140.35 122.897 139.548L102.124 137.895C92.0374 137.092 83.212 144.617 82.4097 154.699Z" fill="url(#paint45_radial_1331_7994)"/>
        <path d="M104.226 138.064L102.119 137.894C94.7535 137.31 88.0692 141.166 84.6812 147.218L87.4602 147.082C94.3861 146.734 100.413 143.245 104.226 138.064Z" fill="url(#paint46_linear_1331_7994)"/>
        <path d="M122.892 139.548L108.436 138.397C107.909 139.519 107.46 140.693 107.097 141.911C103.183 155.072 110.679 168.919 123.84 172.834C125.318 173.274 126.667 174.013 127.817 174.97C134.289 172.563 139.117 166.589 139.702 159.253C140.499 149.171 132.974 140.35 122.892 139.548Z" fill="#00C7E5"/>
        <g opacity="0.3">
        <g opacity="0.3">
        <path opacity="0.3" d="M97.8656 149.122L97.7368 150.392L126.944 153.354L127.072 152.084L97.8656 149.122Z" fill="#B3F5FF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M97.432 153.372L97.3032 154.642L126.51 157.604L126.639 156.334L97.432 153.372Z" fill="#B3F5FF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M97.0033 157.622L96.8745 158.892L126.081 161.854L126.21 160.584L97.0033 157.622Z" fill="#B3F5FF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M96.5721 161.878L96.4434 163.147L115.557 165.086L115.686 163.816L96.5721 161.878Z" fill="#B3F5FF"/>
        </g>
        </g>
        <path d="M187.879 164.163C191.794 151.003 184.298 137.156 171.137 133.241L144.018 125.174C130.857 121.259 117.01 128.756 113.096 141.916C109.181 155.077 116.677 168.924 129.838 172.839C133.516 173.931 136.377 176.831 137.426 180.523L138.315 183.651L140.77 181.514C143.665 178.996 147.648 178.131 151.326 179.228L156.961 180.905C170.117 184.82 183.959 177.324 187.879 164.163Z" fill="url(#paint47_linear_1331_7994)"/>
        <path opacity="0.5" d="M134.047 134.898L129.731 134.555C129.557 134.541 129.388 134.521 129.214 134.502C129.427 134.671 129.634 134.84 129.857 135C133.259 137.494 137.087 138.881 140.876 139.62L140.693 139.267C139.368 136.769 136.86 135.121 134.047 134.898Z" fill="url(#paint48_linear_1331_7994)"/>
        <path opacity="0.5" d="M150.504 136.208C147.687 135.986 144.951 137.218 143.25 139.475L142.887 139.959C148.054 140.679 152.993 140.321 156.478 140.07C164.1 139.519 164.298 137.89 169.624 138.219C176.71 138.654 181.809 141.868 185.549 144.603C182.48 139.306 177.468 135.125 171.137 133.241L164.52 131.273C160.886 134.695 155.874 136.633 150.504 136.208Z" fill="url(#paint49_linear_1331_7994)"/>
        <path d="M146.28 162.235C137.851 156.251 133.68 146.957 121.959 144.139C118.712 143.361 115.575 143.24 112.685 143.501C111.863 147.117 111.868 150.746 112.602 154.183C114.773 154.052 117.063 154.144 119.427 154.584C131.278 156.778 135.937 165.845 144.666 171.379C151.456 175.685 162.597 179.044 181.75 174.53C183.964 172.288 185.776 169.605 187.033 166.551C165.231 171.34 153.264 167.194 146.28 162.235Z" fill="url(#paint50_linear_1331_7994)"/>
        <path d="M144.666 171.374C135.937 165.84 131.283 156.778 119.427 154.579C117.064 154.139 114.773 154.042 112.603 154.178C114.444 162.786 120.804 170.147 129.838 172.834C133.516 173.926 136.377 176.826 137.426 180.519L138.315 183.646L140.77 181.509C143.665 178.991 147.648 178.126 151.326 179.223L156.961 180.9C166.077 183.612 175.516 180.847 181.76 174.525C162.602 179.04 151.456 175.681 144.666 171.374Z" fill="url(#paint51_linear_1331_7994)"/>
        <path d="M144.666 171.374C135.937 165.84 131.283 156.778 119.427 154.579C117.064 154.139 114.773 154.042 112.603 154.178C114.444 162.786 120.804 170.147 129.838 172.834C133.516 173.926 136.377 176.826 137.426 180.519L138.315 183.646L140.77 181.509C143.665 178.991 147.648 178.126 151.326 179.223L156.961 180.9C166.077 183.612 175.516 180.847 181.76 174.525C162.602 179.04 151.456 175.681 144.666 171.374Z" fill="url(#paint52_linear_1331_7994)"/>
        <path opacity="0.9" d="M123.52 128.069C122.269 128.872 121.089 129.78 119.997 130.795C122.588 132.796 125.739 134.125 129.214 134.497C126.826 132.617 124.966 130.404 123.52 128.069Z" fill="#0065FF"/>
        <path d="M141.809 141.384L142.887 139.954C142.22 139.862 141.548 139.751 140.876 139.615L141.809 141.384Z" fill="#DFE1E5"/>
        <path opacity="0.5" d="M123.521 128.069C124.966 130.403 126.826 132.617 129.214 134.497C129.388 134.516 129.557 134.536 129.731 134.55L134.047 134.893C136.865 135.116 139.373 136.768 140.693 139.267L140.876 139.62C141.548 139.751 142.22 139.862 142.887 139.958L143.249 139.475C144.951 137.218 147.686 135.986 150.504 136.208C155.874 136.633 160.89 134.7 164.52 131.273L144.018 125.174C136.807 123.028 129.398 124.313 123.521 128.069Z" fill="url(#paint53_linear_1331_7994)"/>
        <path opacity="0.8" d="M123.521 128.069C124.966 130.403 126.826 132.617 129.214 134.497C129.388 134.516 129.557 134.536 129.731 134.55L134.047 134.893C136.865 135.116 139.373 136.768 140.693 139.267L140.876 139.62C141.548 139.751 142.22 139.862 142.887 139.958L143.249 139.475C144.951 137.218 147.686 135.986 150.504 136.208C155.874 136.633 160.89 134.7 164.52 131.273L144.018 125.174C136.807 123.028 129.398 124.313 123.521 128.069Z" fill="#0065FF"/>
        <path d="M136.389 141.546L135.973 142.915L168.921 152.914L169.336 151.545L136.389 141.546Z" fill="#B2D4FF"/>
        <path d="M134.933 146.341L134.518 147.71L167.465 157.709L167.88 156.34L134.933 146.341Z" fill="#B2D4FF"/>
        <path d="M133.476 151.135L133.061 152.504L166.008 162.503L166.424 161.134L133.476 151.135Z" fill="#B2D4FF"/>
        <path d="M132.022 155.927L131.607 157.296L149.713 162.791L150.129 161.422L132.022 155.927Z" fill="#B2D4FF"/>
        <path d="M155.801 47.4806C156.565 36.3499 148.165 26.7029 137.029 25.9392L114.096 24.3636C102.965 23.6 93.3182 32 92.5546 43.1356C91.7909 54.2664 100.191 63.9134 111.327 64.677C114.439 64.8897 117.223 66.6828 118.707 69.4232L119.968 71.7431L121.534 69.6165C123.38 67.1032 126.387 65.7113 129.494 65.9288L134.26 66.2574C145.395 67.0162 155.038 58.6114 155.801 47.4806Z" fill="url(#paint54_linear_1331_7994)"/>
        <path opacity="0.5" d="M126.624 33.9578C132.568 32.1647 132.438 30.8404 136.715 30.1541C142.414 29.2406 147.024 30.8839 150.475 32.387C147.102 28.7331 142.38 26.3069 137.029 25.9396L114.096 24.364C107.997 23.9435 102.352 26.2827 98.3594 30.3039C100.061 32.039 102.12 33.5808 104.613 34.6731C112.632 38.1771 121.573 35.4802 126.624 33.9578Z" fill="url(#paint55_linear_1331_7994)"/>
        <path opacity="0.5" d="M103.758 50.2451C103.83 50.9314 103.85 51.6129 103.835 52.2895C111.211 53.464 116.068 58.4566 122.825 60.878C128.972 63.0868 138.407 63.7682 152.79 56.7843C154.148 54.6142 155.11 52.1638 155.56 49.5201C139.122 57.1952 128.895 56.0304 122.482 53.3431C115.13 50.2596 110.283 44.136 101.438 43.3965C102.68 45.4119 103.502 47.7318 103.758 50.2451Z" fill="url(#paint56_linear_1331_7994)"/>
        <path opacity="0.5" d="M122.825 60.8786C116.068 58.4571 111.215 53.4645 103.835 52.29C103.767 55.4896 102.757 58.5006 101.046 61.0187C103.97 63.0921 107.484 64.4116 111.322 64.6726C114.434 64.8852 117.218 66.6783 118.702 69.4187L119.963 71.7387L121.529 69.6121C123.376 67.0988 126.382 65.7069 129.49 65.9244L134.255 66.253C141.964 66.7847 148.957 62.9133 152.785 56.7897C138.407 63.7688 128.972 63.0873 122.825 60.8786Z" fill="url(#paint57_linear_1331_7994)"/>
        <path opacity="0.5" d="M122.825 60.8786C116.068 58.4571 111.215 53.4645 103.835 52.29C103.767 55.4896 102.757 58.5006 101.046 61.0187C103.97 63.0921 107.484 64.4116 111.322 64.6726C114.434 64.8852 117.218 66.6783 118.702 69.4187L119.963 71.7387L121.529 69.6121C123.376 67.0988 126.382 65.7069 129.49 65.9244L134.255 66.253C141.964 66.7847 148.957 62.9133 152.785 56.7897C138.407 63.7688 128.972 63.0873 122.825 60.8786Z" fill="url(#paint58_linear_1331_7994)"/>
        <path opacity="0.8" d="M101.438 43.3969C99.674 40.5357 97.0544 38.2883 93.9709 36.9736C93.1976 38.8924 92.7094 40.9562 92.5596 43.1311C92.5306 43.5806 92.5161 44.0252 92.5161 44.4699C94.7635 43.7497 97.2671 43.2809 99.9833 43.3244C100.476 43.3292 100.96 43.3582 101.438 43.3969Z" fill="#0052CC"/>
        <path opacity="0.5" d="M99.8282 52.0479C101.254 51.9947 102.578 52.0865 103.835 52.2895C103.849 51.6129 103.83 50.9314 103.758 50.2451C103.497 47.7318 102.68 45.4119 101.433 43.3965C100.959 43.3578 100.476 43.3288 99.9781 43.3192C97.2618 43.2757 94.7583 43.7493 92.5108 44.4646C92.5012 47.4757 93.1537 50.3514 94.3474 52.9468C96.0439 52.4587 97.8757 52.1204 99.8282 52.0479Z" fill="url(#paint59_linear_1331_7994)"/>
        <path opacity="0.6" d="M99.8282 52.0479C101.254 51.9947 102.578 52.0865 103.835 52.2895C103.849 51.6129 103.83 50.9314 103.758 50.2451C103.497 47.7318 102.68 45.4119 101.433 43.3965C100.959 43.3578 100.476 43.3288 99.9781 43.3192C97.2618 43.2757 94.7583 43.7493 92.5108 44.4646C92.5012 47.4757 93.1537 50.3514 94.3474 52.9468C96.0439 52.4587 97.8757 52.1204 99.8282 52.0479Z" fill="#0052CC"/>
        <path opacity="0.5" d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z" fill="url(#paint60_linear_1331_7994)"/>
        <path opacity="0.5" d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z" fill="url(#paint61_linear_1331_7994)"/>
        <path opacity="0.8" d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z" fill="#0052CC"/>
        <g opacity="0.8">
        <g opacity="0.8">
        <path opacity="0.8" d="M110.955 38.6885L110.869 39.8501L138.767 41.9202L138.854 40.7586L110.955 38.6885Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M110.653 42.752L110.566 43.9137L138.465 45.9838L138.551 44.8221L110.653 42.752Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M110.351 46.8096L110.265 47.9713L138.163 50.0414L138.25 48.8797L110.351 46.8096Z" fill="#B2D4FF"/>
        </g>
        <g opacity="0.8">
        <path opacity="0.8" d="M110.059 50.877L109.973 52.0387L125.306 53.1779L125.392 52.0163L110.059 50.877Z" fill="#B2D4FF"/>
        </g>
        </g>
        <path d="M171.427 93.183L131.171 78.6546C130.736 78.4999 130.514 78.0214 130.669 77.5864L145.197 37.3311C145.352 36.8961 145.83 36.6737 146.265 36.8284L186.521 51.3569C186.956 51.5115 187.178 51.99 187.023 52.425L172.495 92.6804C172.34 93.1154 171.862 93.3377 171.427 93.183Z" fill="url(#paint62_linear_1331_7994)"/>
        <path d="M170.286 89.3662L183.211 53.5568L147.402 40.6318L134.477 76.4412L170.286 89.3662Z" fill="#FAFBFC"/>
        <path d="M141.249 69.9406L152.133 64.8271L157.246 75.7114L141.249 69.9406Z" fill="#2684FF"/>
        <path d="M155.052 59.3747C156.504 59.3747 157.681 58.1975 157.681 56.7455C157.681 55.2934 156.504 54.1162 155.052 54.1162C153.6 54.1162 152.423 55.2934 152.423 56.7455C152.423 58.1975 153.6 59.3747 155.052 59.3747Z" fill="#FFAB00"/>
        <path d="M147.662 72.2553L163.355 64.8848L170.721 80.578L147.662 72.2553Z" fill="url(#paint63_linear_1331_7994)"/>
        <path d="M118.663 128.427L117.537 128.393L119.34 73.2031L120.466 73.237L118.663 128.427Z" fill="url(#paint64_linear_1331_7994)"/>
        <path d="M114.048 108.848C113.246 118.93 120.771 127.755 130.853 128.558L135.169 128.901C137.987 129.123 140.495 130.776 141.814 133.275L142.936 135.392L144.376 133.478C146.077 131.221 148.813 129.988 151.631 130.21C161.712 131.013 170.538 123.488 171.34 113.406C172.142 103.324 164.617 94.4983 154.535 93.6959L133.762 92.043C123.676 91.2407 114.85 98.7659 114.048 108.848Z" fill="url(#paint65_radial_1331_7994)"/>
        <path d="M153.177 111.298C144.821 111.631 142.675 115.242 136.904 113.859C128.736 111.907 128.383 102.941 119.722 100.752C118.794 100.515 117.876 100.365 116.977 100.269C115.348 102.753 114.299 105.672 114.048 108.847C114.014 109.249 114.004 109.645 113.995 110.041C115.087 110.109 116.208 110.259 117.354 110.529C125.715 112.511 128.712 119.128 134.734 123.376C139.809 126.957 148.561 129.925 164.617 126.169C167.778 123.603 170.079 120.002 170.978 115.822C166.768 113.521 160.586 110.998 153.177 111.298Z" fill="url(#paint66_linear_1331_7994)"/>
        <path d="M141.815 133.27L142.936 135.387L144.376 133.473C144.391 133.453 144.405 133.439 144.415 133.419C143.376 133.086 142.336 132.752 141.297 132.424C141.486 132.694 141.66 132.975 141.815 133.27Z" fill="url(#paint67_linear_1331_7994)"/>
        <path d="M134.734 123.371C128.712 119.122 125.715 112.506 117.354 110.524C116.213 110.254 115.087 110.104 113.995 110.036C113.85 119.615 121.167 127.783 130.853 128.552L135.169 128.895C137.653 129.093 139.896 130.403 141.297 132.423C142.336 132.757 143.376 133.09 144.415 133.419C146.116 131.196 148.832 129.983 151.626 130.205C156.507 130.592 161.089 129.026 164.617 126.164C148.562 129.92 139.809 126.952 134.734 123.371Z" fill="url(#paint68_linear_1331_7994)"/>
        <path d="M134.734 123.371C128.712 119.122 125.715 112.506 117.354 110.524C116.213 110.254 115.087 110.104 113.995 110.036C113.85 119.615 121.167 127.783 130.853 128.552L135.169 128.895C137.653 129.093 139.896 130.403 141.297 132.423C142.336 132.757 143.376 133.09 144.415 133.419C146.116 131.196 148.832 129.983 151.626 130.205C156.507 130.592 161.089 129.026 164.617 126.164C148.562 129.92 139.809 126.952 134.734 123.371Z" fill="url(#paint69_linear_1331_7994)"/>
        <path opacity="0.15" d="M123.613 94.353C123.613 95.7884 128.311 96.9532 134.106 96.9532C139.901 96.9532 144.598 95.7884 144.598 94.353C144.598 93.7344 143.719 93.164 142.254 92.7146L133.758 92.0379C130.113 91.7479 126.638 92.5502 123.642 94.1645C123.622 94.2273 123.613 94.2902 123.613 94.353Z" fill="url(#paint70_linear_1331_7994)"/>
        <g opacity="0.3">
        <g opacity="0.3">
        <path opacity="0.3" d="M129.491 103.342L129.377 104.467L158.584 107.429L158.698 106.304L129.491 103.342Z" fill="#E6FCFF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M129.06 107.59L128.946 108.715L158.153 111.677L158.267 110.552L129.06 107.59Z" fill="#E6FCFF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M128.633 111.846L128.519 112.972L157.725 115.934L157.84 114.809L128.633 111.846Z" fill="#E6FCFF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M128.2 116.094L128.085 117.219L147.199 119.157L147.313 118.032L128.2 116.094Z" fill="#E6FCFF"/>
        </g>
        </g>
        <path d="M66.3735 158.151L54.6821 109.756L55.7744 109.495L67.4658 157.885L66.3735 158.151Z" fill="url(#paint71_linear_1331_7994)"/>
        <path d="M50.3131 104.71C62.541 104.71 72.4538 94.7974 72.4538 82.5694C72.4538 70.3414 62.541 60.4287 50.3131 60.4287C38.0851 60.4287 28.1724 70.3414 28.1724 82.5694C28.1724 94.7974 38.0851 104.71 50.3131 104.71Z" fill="url(#paint72_linear_1331_7994)"/>
        <path d="M50.0232 60.4287C47.4616 60.4625 45.0063 60.9362 42.7251 61.7675C45.016 68.9351 52.0773 73.7634 59.8586 72.9611L63.6768 72.5648C66.1707 72.3086 68.6212 73.3429 70.1726 75.31L71.4872 76.9775L71.6515 76.6536C69.0368 67.1855 60.3033 60.2934 50.0232 60.4287Z" fill="#FFC400"/>
        <path d="M39.6511 81.849C40.9537 81.849 42.0096 80.793 42.0096 79.4904C42.0096 78.1878 40.9537 77.1318 39.6511 77.1318C38.3485 77.1318 37.2925 78.1878 37.2925 79.4904C37.2925 80.793 38.3485 81.849 39.6511 81.849Z" fill="#FF991F"/>
        <path d="M50.2939 95.2802C53.2888 95.2802 55.7167 92.8523 55.7167 89.8574C55.7167 86.8624 53.2888 84.4346 50.2939 84.4346C47.299 84.4346 44.8711 86.8624 44.8711 89.8574C44.8711 92.8523 47.299 95.2802 50.2939 95.2802Z" fill="#FF991F"/>
        <path d="M60.8879 81.0902C62.1905 81.0902 63.2465 80.0342 63.2465 78.7316C63.2465 77.429 62.1905 76.373 60.8879 76.373C59.5853 76.373 58.5293 77.429 58.5293 78.7316C58.5293 80.0342 59.5853 81.0902 60.8879 81.0902Z" fill="#FF991F"/>
        <path d="M49.3317 55.4846C50.2548 64.4066 58.2344 70.8878 67.1516 69.9647L70.9697 69.5684C73.4637 69.3122 75.9141 70.3465 77.4655 72.3136L78.7801 73.9811L79.7274 72.0816C80.8439 69.8391 83.0333 68.3263 85.5272 68.0653C94.4492 67.1422 100.93 59.1626 100.007 50.2454C99.0891 41.3234 91.1095 34.8422 82.1875 35.7653L63.8118 37.6647C54.8898 38.583 48.4086 46.5626 49.3317 55.4846Z" fill="url(#paint73_radial_1331_7994)"/>
        <path d="M52.4829 56.4173C60.0903 56.7992 63.7683 62.0866 69.6986 64.8222C74.7009 67.1276 82.811 68.3069 96.2036 62.4539C98.5042 59.7619 99.9252 56.3255 100.08 52.6233C96.0345 51.2555 90.1139 49.9699 83.5601 51.4488C76.3249 53.0825 75.0344 56.572 69.7856 56.3013C62.3522 55.9147 60.6026 48.1526 52.6956 47.6355C51.9319 47.5872 51.1876 47.592 50.4626 47.6403C49.4718 50.0424 49.0465 52.72 49.3317 55.4845C49.3703 55.8374 49.4187 56.1853 49.4767 56.5333C50.4385 56.4125 51.4438 56.3642 52.4829 56.4173Z" fill="url(#paint74_linear_1331_7994)"/>
        <path d="M77.0498 71.8398C77.1948 71.9945 77.335 72.1492 77.4655 72.3135L78.7801 73.9809L79.679 72.1782C78.8042 72.0622 77.9294 71.951 77.0498 71.8398Z" fill="url(#paint75_linear_1331_7994)"/>
        <path d="M79.7322 72.0812C80.8486 69.8386 83.0381 68.3258 85.532 68.0649C89.8528 67.6202 93.5937 65.5129 96.2084 62.4536C82.8157 68.3065 74.7057 67.1272 69.7034 64.8218C63.7731 62.0862 60.0951 56.7988 52.4877 56.4169C51.4485 56.3638 50.4432 56.4121 49.4814 56.5329C50.8927 64.9088 58.5871 70.8536 67.1563 69.9691L70.9745 69.5728C73.2557 69.336 75.5032 70.1866 77.0546 71.8395C77.9294 71.9507 78.809 72.0667 79.6838 72.1779L79.7322 72.0812Z" fill="url(#paint76_linear_1331_7994)"/>
        <path d="M79.7322 72.0812C80.8486 69.8386 83.0381 68.3258 85.532 68.0649C89.8528 67.6202 93.5937 65.5129 96.2084 62.4536C82.8157 68.3065 74.7057 67.1272 69.7034 64.8218C63.7731 62.0862 60.0951 56.7988 52.4877 56.4169C51.4485 56.3638 50.4432 56.4121 49.4814 56.5329C50.8927 64.9088 58.5871 70.8536 67.1563 69.9691L70.9745 69.5728C73.2557 69.336 75.5032 70.1866 77.0546 71.8395C77.9294 71.9507 78.809 72.0667 79.6838 72.1779L79.7322 72.0812Z" fill="url(#paint77_linear_1331_7994)"/>
        <path opacity="0.5" d="M60.4478 38.3749C61.1002 39.6461 66.4215 40.1004 72.7771 39.3851C79.0651 38.6746 84.1109 37.07 84.5555 35.6925C83.7774 35.6587 82.9848 35.6829 82.1873 35.765L63.8116 37.6645C62.6468 37.7853 61.5207 38.027 60.4478 38.3749Z" fill="#00B8D9"/>
        <g opacity="0.3">
        <g opacity="0.3">
        <path opacity="0.3" d="M87.8498 46.0254L61.9092 48.1414L62.0011 49.2686L87.9418 47.1527L87.8498 46.0254Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M88.154 49.8008L62.2134 51.9168L62.3053 53.044L88.246 50.9281L88.154 49.8008Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M88.4636 53.5801L62.5229 55.6961L62.6149 56.8233L88.5557 54.7074L88.4636 53.5801Z" fill="#E3FCEF"/>
        </g>
        <g opacity="0.3">
        <path opacity="0.3" d="M79.8074 58.082L62.8315 59.4667L62.9235 60.5939L79.8993 59.2092L79.8074 58.082Z" fill="#E3FCEF"/>
        </g>
        </g>
        <path d="M82.1585 31.0674H80.3848V33.1118H82.1585V31.0674Z" fill="url(#paint78_linear_1331_7994)"/>
        <path d="M70.6849 18.6756C71.2504 18.4098 72.3813 19.1445 72.9517 19.9033C73.1836 20.2126 73.609 20.7732 73.6138 21.5127C73.6186 22.0443 73.4011 22.5567 73.7153 23.0061C73.8023 23.1318 73.8845 23.185 73.9425 23.3445C74.0439 23.649 73.9473 24.0259 73.754 24.2628C73.667 24.3691 73.4591 24.5673 72.3378 24.6639C72.275 24.6687 72.2025 24.6736 72.13 24.6784C71.405 24.7267 70.7526 24.2289 70.6124 23.5136C69.8923 19.8888 70.2257 18.8931 70.6849 18.6756Z" fill="#091E42"/>
        <path d="M68.9688 22.9189L68.5483 24.5236L69.6503 26.4375L72.1587 26.2345L72.1249 24.6879C71.8397 24.7072 71.6271 24.6492 71.5062 24.6009C71.3081 24.5284 71.2404 24.4511 71.2162 24.4172C71.1341 24.3061 71.1341 24.1804 71.1341 24.0886C71.1389 23.7309 71.1776 23.3781 71.2114 23.1509C70.4671 23.0736 69.718 22.9963 68.9688 22.9189Z" fill="#CE9E79"/>
        <path d="M62.0963 37.3213C62.4926 37.36 62.8889 37.3938 63.2853 37.4276C63.6381 37.4808 63.8217 37.5678 63.8411 37.6789C63.8701 37.8529 63.5028 38.0994 62.7294 38.4184C62.6811 38.4667 62.4201 38.7181 62.0866 38.6697C62.019 38.6601 61.961 38.6407 61.9078 38.6117C62.077 38.4619 62.2461 38.3169 62.4153 38.1719C62.4153 38.1188 62.4008 38.0946 62.3863 38.0801C62.2461 37.9158 61.526 38.1091 61.0572 38.4329C60.975 38.4909 60.7769 38.6311 60.6125 38.5731C60.569 38.5586 60.54 38.5296 60.5207 38.5054L60.9412 38.0946C60.8784 38.1236 60.772 38.1623 60.6415 38.2154C60.4482 38.2928 60.3709 38.3218 60.2935 38.2879C60.25 38.2686 60.221 38.2348 60.2065 38.2106L60.9895 37.6354C61.0378 37.5919 61.1055 37.5388 61.2022 37.4856C61.2892 37.4421 61.3762 37.4083 61.5357 37.3793C61.6662 37.3551 61.8595 37.3261 62.0963 37.3213Z" fill="#D4B696"/>
        <path d="M73.0723 29.3711L74.5319 30.6422C74.8751 30.9419 75.3053 31.1304 75.7547 31.1787L79.1041 31.5412L79.0896 32.5078L75.1651 32.532C74.7011 32.5368 74.2468 32.3918 73.8698 32.126L72.3184 31.0385L73.0723 29.3711Z" fill="#CE9E79"/>
        <path d="M72.1735 29.4339C72.2025 29.6417 72.2895 30.1202 72.594 30.56C72.8308 30.9031 73.0967 31.0626 73.2417 31.1351C73.5316 30.763 73.7008 30.5407 73.9908 30.1733C73.7636 29.8157 73.6041 29.1149 73.5316 28.4092C73.4881 27.9791 73.5606 27.9211 73.5365 27.3169C73.5026 26.563 73.4736 25.9105 73.058 25.3692C72.9227 25.1903 72.652 24.91 72.1445 24.707C72.159 26.2826 72.1639 27.8583 72.1735 29.4339Z" fill="#57D9A3"/>
        <path d="M88.4854 43.6488C88.3163 43.557 88.1471 43.4651 87.9779 43.3733C87.7073 43.4748 87.224 43.6826 85.9094 43.0301C85.2714 42.716 84.8751 42.2617 84.6624 41.9717C83.9906 42.165 83.3188 42.3583 82.647 42.5517C82.8886 43.3975 83.1351 44.2433 83.3768 45.0891C83.6571 45.0069 83.9423 44.9247 84.2226 44.8426C84.2226 44.8232 84.1791 44.4173 84.4546 44.2143C84.7204 44.0113 85.1795 44.0741 85.4599 44.4269C86.7358 44.0983 87.2095 43.9919 88.4854 43.6488Z" fill="#172B4D"/>
        <path d="M80.0903 49.8303C80.0275 49.6466 79.9598 49.4678 79.897 49.2841C79.6312 49.1778 79.1333 49.0087 78.5969 47.6409C78.3359 46.9787 78.3455 46.3746 78.3842 46.0218C77.7559 45.7124 77.1276 45.4031 76.4993 45.0986C76.1126 45.8864 75.726 46.6791 75.3345 47.4669C75.6003 47.5974 75.8613 47.7279 76.1271 47.8535C76.1368 47.839 76.3784 47.5104 76.7216 47.5394C77.0551 47.5684 77.3547 47.9212 77.3257 48.3707C78.4954 48.9845 78.9158 49.2213 80.0903 49.8303Z" fill="#172B4D"/>
        <path d="M84.6622 41.9811C83.9904 42.1744 83.3137 42.3677 82.6419 42.5659C81.8396 41.5316 80.9407 40.1638 80.2012 38.4432C80.1722 38.3755 80.1432 38.303 80.1142 38.2354L80.2302 37.7182C80.2495 37.6651 80.467 36.9691 80.003 36.3939C79.8 36.1329 79.539 36.0073 79.3361 35.9445L74.1984 37.8584C73.8649 38.0034 73.5314 38.1097 73.2028 38.1919C71.5257 38.5882 69.9597 38.1725 69.1816 37.1527C68.9931 36.9063 68.6016 36.2924 68.6161 35.234C69.8099 34.7652 71.168 34.3157 72.6808 33.9387C75.2424 33.3055 77.4463 32.9962 79.365 32.9382C80.3848 32.8222 81.4191 33.3297 81.772 34.2577L84.6622 41.9811Z" fill="#36B37E"/>
        <path d="M80.2305 37.7181L80.1145 38.2353L78.3794 46.0215C77.7511 45.7121 77.1228 45.4077 76.4945 45.0983C76.3205 44.1607 76.1803 42.7784 76.4171 41.1448C76.6008 39.8882 76.9536 38.8636 77.2774 38.1096C75.9193 38.1386 74.5564 38.1628 73.1982 38.1918C73.5269 38.1144 73.8604 38.0033 74.1939 37.8583L79.3315 35.9443C79.5345 36.0072 79.7955 36.1328 79.9985 36.3938C80.4673 36.969 80.245 37.6649 80.2305 37.7181Z" fill="#57D9A3"/>
        <path d="M65.8418 29.0668C65.982 31.1257 66.1511 33.5761 66.3976 36.4084C68.3019 36.36 70.8731 35.9347 73.077 34.2141C73.2849 34.0498 73.483 33.8854 73.6667 33.7163C73.8938 33.6728 74.121 33.6245 74.3482 33.581C74.034 33.1363 73.6812 32.5032 73.4637 31.696C73.3622 31.319 73.2269 30.8261 73.2704 30.1881C73.338 29.1441 73.7875 29.0426 73.773 28.2307C73.7682 28.0373 73.8117 27.7473 72.9949 26.2056C72.7967 25.8286 72.5164 25.3114 72.1539 24.7121C71.9268 24.6589 71.6996 24.6106 71.4724 24.5575C71.7528 25.4613 71.7721 25.9977 71.5304 26.1717C71.1631 26.4327 70.2013 25.8576 68.6402 24.4463C68.3309 24.4995 67.2531 24.7266 66.4653 25.6981C65.2908 27.1239 65.7935 28.9073 65.8418 29.0668Z" fill="#79F2C0"/>
        <path d="M68.597 27.0896L66.2384 30.1393C65.4264 32.6912 64.6144 35.248 63.8025 37.7999C63.7058 37.7805 63.585 37.7515 63.4545 37.6935C63.2708 37.6162 63.1307 37.5147 63.034 37.4374C62.976 35.7989 63.1017 34.4311 63.2467 33.4162C63.382 32.4447 63.6768 30.7918 64.3969 28.9262C65.3539 26.4419 66.3109 25.9393 66.7797 25.4656C67.1422 25.0983 67.7028 25.0162 68.1668 25.2482C68.858 25.5865 69.0658 26.4806 68.597 27.0896Z" fill="#D4B696"/>
        <path d="M71.7866 19.3086C72.0428 19.8161 72.2023 20.715 72.2458 21.1645C72.2458 21.2419 72.2409 21.2805 72.3569 21.4013C72.4729 21.527 72.6518 21.6188 72.5793 21.7155C72.5068 21.8073 72.2506 21.875 72.1975 21.962L71.9075 23.4941L71.2405 23.5279L68.9834 23.6343C69.0366 23.5618 70.4333 21.8218 70.4672 21.7058C70.501 21.5898 70.559 21.3434 70.7088 21.3289C70.8587 21.3144 71.4628 20.2221 71.5788 20.0867C71.6948 19.9514 71.6948 19.9031 71.7286 19.6807C71.7673 19.4488 71.7866 19.3086 71.7866 19.3086Z" fill="#D4B696"/>
        <path d="M71.8205 18.9895C71.7818 19.8208 71.4628 20.309 71.1777 20.7343C70.965 21.0533 70.1579 22.2713 70.3705 23.6487C70.4865 24.3834 69.8969 25.0503 69.1574 25.0503C68.7224 25.0503 68.3261 25.0503 67.954 24.9392C67.6591 24.8522 67.1662 24.7072 66.7747 24.335C66.069 23.6584 66.1077 22.6241 66.127 22.0393C66.1319 21.8314 66.185 20.773 66.91 19.7387C67.0792 19.4922 67.2725 19.2795 67.4078 19.149C68.1425 18.4289 70.3899 17.6459 71.8205 18.9895Z" fill="#091E42"/>
        <path d="M68.3067 25.2343C67.8427 25.0024 67.1999 25.1039 66.6586 25.4518C65.112 26.4475 64.5659 27.8974 64.1695 28.7916C63.9375 29.3135 63.7587 29.8162 63.6089 30.3333C64.3339 30.7683 65.6146 31.4015 66.3106 31.7108C66.3106 31.7059 66.3106 31.7011 66.3155 31.6963C66.5378 30.8988 66.8664 30.14 67.2966 29.4344L68.732 27.0806C69.2057 26.4765 68.9979 25.5823 68.3067 25.2343Z" fill="#57D9A3"/>
        <path d="M79.0898 32.5078L79.4282 32.5996C79.5393 32.6286 79.6553 32.6382 79.7713 32.6286L80.2595 32.5754C80.2595 32.5754 80.3126 32.4401 80.3078 32.3918C80.303 32.3676 80.2546 32.2999 80.2546 32.2999C80.2546 32.2999 80.3126 32.1549 80.3078 32.1066C80.303 32.0631 80.2208 31.9568 80.2208 31.9568C80.2208 31.9568 80.3126 31.8118 80.3078 31.7538C80.3078 31.7199 80.2353 31.6281 80.2353 31.6281L80.1338 31.4541L79.868 31.401C79.7955 31.3865 79.7182 31.3865 79.6408 31.4058L79.0995 31.5363L79.0898 32.5078Z" fill="#CE9E79"/>
        <path d="M80.385 32.73C80.0322 32.73 79.7422 32.4448 79.7422 32.0871C79.7422 31.7295 80.0273 31.4443 80.385 31.4443" stroke="url(#paint79_linear_1331_7994)" stroke-width="0.5732" stroke-miterlimit="10"/>
        <path d="M80.0273 31.7246L79.7422 32.0871L79.8099 32.2611L79.8872 32.2369L79.8582 32.3529L79.9403 32.4931L80.0273 32.4544L80.0032 32.5704L80.1192 32.6477L80.2497 32.5172L80.0273 31.7246Z" fill="#CE9E79"/>
        <path d="M80.6895 31.0626C80.5107 30.7388 80.3367 30.2748 80.4817 29.8301C80.6363 29.3758 80.9988 29.3275 81.2791 28.849C81.6513 28.1965 81.2308 27.8437 81.4628 27.2009C81.8204 26.2053 83.0771 26.3841 83.7344 25.3498C83.9519 25.0067 84.1839 24.4073 84.0002 23.3634C85.4743 23.2716 86.9484 23.1797 88.4225 23.0879C88.6497 24.1947 88.4854 25.0502 88.3645 25.5045C87.9102 27.1816 86.4603 28.9988 84.7542 29.2018C83.9229 29.2985 82.9707 29.023 82.7242 29.4822C82.6034 29.7093 82.7532 29.922 82.6179 30.2941C82.4778 30.6856 82.1394 30.9224 81.8591 31.0674C81.4725 31.0674 81.081 31.0626 80.6895 31.0626Z" fill="url(#paint80_linear_1331_7994)"/>
        <path d="M142.307 59.4334L146.899 56.6592" stroke="#7A869A" stroke-width="1.5514" stroke-miterlimit="10"/>
        <path d="M141.679 60.9413C141.5 60.5063 141.321 60.0762 141.137 59.6412C141.302 59.5059 141.461 59.3754 141.625 59.24C141.635 59.1724 141.659 59.0516 141.737 58.9211C141.795 58.8244 141.872 58.7422 141.969 58.6746L142.867 58.0511C143.075 57.9061 143.336 57.8674 143.578 57.9399L144.951 58.3652L144.786 59.0564L144.487 59.3464C144.322 59.5107 144.1 59.5977 143.863 59.5977H143.273C143.264 60.0085 142.95 60.342 142.544 60.3758C142.259 60.574 141.969 60.7577 141.679 60.9413Z" fill="url(#paint81_linear_1331_7994)"/>
        <path d="M127.455 62.5026C128.204 62.5026 128.948 62.5026 129.697 62.5026C129.576 62.2175 129.427 61.7825 129.378 61.2412C129.33 60.7144 129.393 60.2745 129.456 59.9749C129.001 59.9507 128.542 59.9314 128.088 59.9072C128.073 59.9894 128.044 60.1054 128.006 60.2455C127.948 60.463 127.914 60.5694 127.856 60.6225C127.701 60.7675 127.401 60.6805 127.314 60.6515C127.363 61.275 127.406 61.8888 127.455 62.5026Z" fill="url(#paint82_linear_1331_7994)"/>
        <path d="M124.913 70.3372C123.332 70.7093 122.356 72.2946 122.733 73.8751C123.187 75.7842 125.671 76.5623 126.271 76.0548C126.744 75.6537 125.927 74.5517 126.57 73.6189C127.16 72.7586 128.31 73.0341 128.455 72.5169C128.644 71.8065 126.836 69.8829 124.913 70.3372Z" fill="#FFC400"/>
        <path d="M126.333 73.2851C125.691 72.7776 124.874 72.0188 124.1 70.9555C123.39 69.9792 122.94 69.0464 122.655 68.3214C122.984 66.4558 123.738 65.2185 124.207 64.5709C124.854 63.6767 125.425 63.2708 125.676 63.1064C126.585 62.512 128.006 62.0093 128.358 62.4395C128.716 62.8793 127.943 64.1939 127.281 64.9382C127.01 65.2427 126.831 65.3732 126.589 65.5858C126.019 66.0933 125.294 66.9246 124.666 68.2972C125.27 69.3799 125.874 70.4673 126.478 71.5499C126.435 72.1299 126.386 72.7099 126.333 73.2851Z" fill="url(#paint83_linear_1331_7994)"/>
        <path d="M126.715 70.6173C126.754 70.453 126.802 70.2742 126.875 70.0809C126.957 69.8537 127.054 69.6555 127.145 69.4912C127.257 69.525 127.435 69.5782 127.663 69.6217C127.856 69.6604 128.006 69.6749 128.088 69.6845C128.542 69.7522 129.417 69.8537 131.761 70.0325C131.872 70.1727 132.032 70.3853 132.201 70.6512C132.815 71.6226 133.037 72.5071 133.129 72.8889C134.719 79.4378 135.038 81.9994 135.038 81.9994C135.038 81.9994 136.164 88.2777 136.792 93.7923C136.773 93.8068 136.406 94.353 135.898 94.5511C135.715 94.6236 135.724 94.759 135.381 94.7928C134.704 92.8209 134.095 90.4816 133.757 87.8282C133.641 86.9099 133.564 86.0254 133.525 85.1796C132.974 84.3 132.206 82.9612 131.461 81.2455C130.451 78.9014 130.19 77.4611 129.934 77.4998C129.538 77.5578 129.828 80.8346 129.866 85.6195C129.891 88.4275 129.726 90.7474 129.712 92.2795C129.562 92.3665 129.233 92.6179 128.697 92.4294C128.16 92.2457 127.982 91.9992 127.982 91.9992C127.788 90.7039 127.653 89.2008 127.653 87.5334C127.653 86.1849 127.74 84.9476 127.875 83.8457C127.247 81.9366 126.884 80.2885 126.667 79.0657C126.667 79.0657 125.947 75.0203 126.338 72.3573C126.411 71.9368 126.638 70.9508 126.715 70.6173Z" fill="url(#paint84_linear_1331_7994)"/>
        <path d="M134.564 87.8716C135.072 87.8716 135.541 87.7508 135.952 87.543C136.246 89.4762 136.556 91.6898 136.797 93.7922C136.778 93.8067 136.411 94.3529 135.903 94.551C135.72 94.6235 135.729 94.7589 135.386 94.7927C134.709 92.8208 134.1 90.4815 133.762 87.8281C133.757 87.804 133.757 87.775 133.752 87.7508C134.018 87.8281 134.289 87.8716 134.564 87.8716Z" fill="url(#paint85_linear_1331_7994)"/>
        <path d="M128.939 87.625C129.262 87.625 129.572 87.5766 129.862 87.4848C129.876 88.3113 129.857 89.2151 129.78 90.1865C129.717 90.955 129.63 91.6751 129.523 92.3421C129.465 92.3904 129.369 92.4629 129.233 92.4968C129.18 92.5113 129.016 92.5499 128.707 92.4388C128.17 92.2551 127.991 92.0086 127.991 92.0086C127.798 90.7133 127.663 89.2102 127.663 87.5428C127.663 87.4751 127.663 87.4075 127.663 87.335C128.064 87.5186 128.499 87.625 128.939 87.625Z" fill="url(#paint86_linear_1331_7994)"/>
        <path d="M129.939 77.5046C129.683 77.5433 129.712 78.9304 129.78 81.202C129.606 81.173 129.33 81.1295 129.001 81.0715C128.47 80.9796 128.291 80.941 127.953 80.8926C127.735 80.8588 127.416 80.8153 127.025 80.7718C126.88 80.1435 126.764 79.5732 126.677 79.0754C126.677 79.0754 125.957 75.03 126.348 72.3669C126.411 71.932 126.643 70.946 126.72 70.6173C126.759 70.453 126.807 70.2742 126.88 70.0809C126.962 69.8537 127.058 69.6555 127.15 69.4912C127.261 69.525 127.44 69.5782 127.667 69.6217C127.861 69.6604 128.011 69.6749 128.093 69.6845C128.547 69.7522 129.422 69.8537 131.766 70.0325C131.877 70.1727 132.037 70.3853 132.206 70.6512C132.82 71.6226 133.042 72.5071 133.134 72.8889C134.013 76.5186 134.506 78.9207 134.767 80.3416C134.497 80.5011 134.192 80.6558 133.859 80.8008C133.003 81.173 132.206 81.3614 131.553 81.4533C131.524 81.3856 131.495 81.318 131.461 81.2503C130.456 78.911 130.195 77.4659 129.939 77.5046Z" fill="#5E6C84"/>
        <path d="M140.528 96.2133L139.262 95.8121C137.943 95.3965 136.986 94.2558 136.807 92.8832C136.773 92.6367 136.589 91.6024 136.507 91.1723C136.275 91.124 135.918 91.0805 135.497 91.1481C134.869 91.2496 134.429 91.5396 134.216 91.7039C134.468 92.2646 134.719 92.9364 134.917 93.7145C135.038 94.1978 135.197 94.9663 135.26 95.9233C135.28 96.2133 135.284 96.4549 135.284 96.6144L136.536 96.6048C136.604 96.5274 136.676 96.4501 136.744 96.3728C136.855 96.4453 136.966 96.5178 137.073 96.5951H140.248L140.528 96.2133Z" fill="#253858"/>
        <path d="M127.803 90.8056C127.948 90.7137 128.349 90.4769 128.91 90.4962C129.393 90.5107 129.741 90.7089 129.891 90.8056C129.837 91.0279 129.779 91.342 129.746 91.719C129.683 92.4005 129.654 92.792 129.891 93.0046C129.958 93.0626 130.152 93.2076 130.601 93.1303C130.649 93.1496 130.698 93.169 130.746 93.1883C130.142 93.9229 129.688 94.4836 129.417 94.8557C129.369 94.9234 129.233 95.1119 128.992 95.2037C128.919 95.2327 128.62 95.3487 128.373 95.1699C128.189 95.0394 128.146 94.8316 128.136 94.7736C128.025 93.4493 127.914 92.1298 127.803 90.8056Z" fill="#253858"/>
        <path d="M130.011 58.0605C130.045 58.249 130.118 58.539 130.296 58.8484C130.485 59.1818 130.717 59.3993 130.872 59.5202C130.775 59.6265 130.673 59.7328 130.577 59.8391C130.499 60.2838 130.417 60.7285 130.34 61.1779C130.127 61.2649 129.803 61.3761 129.393 61.4196C128.967 61.4631 128.407 61.5211 128.175 61.2118C128.049 61.0426 128.03 60.8154 128.059 60.54C128.083 60.2886 128.117 60.0856 128.151 59.9841C128.242 59.7087 128.373 59.5347 128.639 59.1963C128.948 58.8 129.127 58.5729 129.446 58.3554C129.663 58.2007 129.871 58.1137 130.011 58.0605Z" fill="url(#paint87_linear_1331_7994)"/>
        <path d="M131.631 65.0304C131.669 65.6394 131.737 66.2967 131.858 66.9975C132.08 68.3218 132.414 69.4769 132.766 70.4484C132.153 70.7432 131.181 71.1202 129.934 71.2458C128.494 71.386 127.329 71.125 126.643 70.9123C126.677 69.6896 126.565 67.969 125.908 66.0502C125.608 65.1754 125.251 64.4166 124.898 63.7883C125.12 63.5756 125.434 63.3098 125.845 63.0391C125.845 63.0391 125.937 62.9763 126.082 62.8893C126.082 62.8893 126.348 62.7298 126.619 62.5945C127.769 62.0193 129.876 61.826 129.876 61.826C132.027 61.7487 134.173 61.6762 136.324 61.5988C137.957 60.8787 139.596 60.1537 141.229 59.4336C141.563 59.8686 141.896 60.3036 142.23 60.7385C140.978 61.681 139.17 62.8361 136.812 63.7399C134.82 64.4939 133.032 64.8564 131.631 65.0304Z" fill="url(#paint88_linear_1331_7994)"/>
        <path d="M125.628 59.2351C124.768 60.7914 124.173 60.7092 124.019 61.6469C123.883 62.483 124.168 63.6671 125.096 64.165C126.145 64.7256 127.295 64.0345 127.358 63.9958C128.001 63.5946 128.267 62.9857 128.364 62.7633C128.89 61.5261 128.122 60.9654 128.668 60.0471C128.886 59.6798 129.108 59.6025 129.915 58.5537C130.031 58.4038 130.205 58.1718 130.224 57.8432C130.253 57.4227 130.017 57.1037 129.939 57.0022C129.466 56.4174 128.629 56.4512 128.378 56.4609C127.629 56.4899 127.097 56.8621 126.933 56.9829C126.208 57.5242 126.276 58.0607 125.628 59.2351Z" fill="#ECC19C"/>
        <path d="M124.125 74.8555C124.359 74.8555 124.55 74.6651 124.55 74.4302C124.55 74.1953 124.359 74.0049 124.125 74.0049C123.89 74.0049 123.699 74.1953 123.699 74.4302C123.699 74.6651 123.89 74.8555 124.125 74.8555Z" fill="#57D9A3"/>
        <path d="M123.699 73.2852C123.934 73.2852 124.125 73.0948 124.125 72.8599C124.125 72.625 123.934 72.4346 123.699 72.4346C123.464 72.4346 123.274 72.625 123.274 72.8599C123.274 73.0948 123.464 73.2852 123.699 73.2852Z" fill="#00B8D9"/>
        <path d="M125.391 75.4747C125.626 75.4747 125.816 75.2842 125.816 75.0493C125.816 74.8144 125.626 74.624 125.391 74.624C125.156 74.624 124.966 74.8144 124.966 75.0493C124.966 75.2842 125.156 75.4747 125.391 75.4747Z" fill="#EBECF0"/>
        <path d="M147.565 55.5859C147.503 55.6053 147.445 55.6294 147.382 55.6584C147.087 55.7889 146.686 55.9726 146.652 56.3157C146.623 56.6202 146.903 56.9441 147.208 57.0166C147.561 57.0987 147.865 56.8329 148.083 56.6299C147.58 56.4172 147.213 56.2577 147.565 55.5859Z" fill="#344563"/>
        <path d="M148.725 55.4945C148.421 55.451 148 55.4365 147.565 55.5863C147.213 56.263 147.575 56.4176 148.087 56.6303C148.097 56.6206 148.107 56.6158 148.112 56.6061C148.513 56.2291 148.662 55.77 148.725 55.4945Z" fill="#FFAB00"/>
        <path d="M130.277 56.838C130.099 57.6306 127.373 58.0366 126.802 57.2053C126.783 57.1763 126.604 56.9057 126.691 56.6398C126.798 56.316 127.233 56.2097 127.368 56.1759C127.846 56.0599 128.257 56.2435 128.417 56.3305C128.914 55.9535 129.485 55.8762 129.867 56.1179C130.099 56.258 130.34 56.5673 130.277 56.838Z" fill="#172B4D"/>
        <path d="M95.3774 119.635C96.8129 121.796 94.1933 127.117 90.6941 127.847C89.5728 128.083 87.7749 127.967 87.1901 126.938C86.8179 126.286 86.9436 125.28 87.3205 124.608C87.7555 123.825 88.3887 123.748 88.5627 122.926C88.6642 122.458 88.5047 122.255 88.7077 121.81C88.901 121.39 89.1426 121.341 89.4955 120.921C90.0175 120.297 89.858 119.944 90.2108 119.422C90.8101 118.543 92.0425 118.412 92.2939 118.383C93.4393 118.262 94.7926 118.755 95.3774 119.635Z" fill="#172B4D"/>
        <path d="M98.7024 147.73L98.3931 151.665L99.2099 151.945L99.611 151.476C99.6883 151.694 99.7657 151.916 99.843 152.133C100.244 152.356 100.814 152.622 101.535 152.796C102.308 152.984 102.975 152.999 103.453 152.974C103.362 152.849 103.217 152.66 103.014 152.443C102.888 152.307 102.675 152.09 102.361 151.839C101.549 151.191 101.245 151.264 101.013 150.858C100.887 150.63 100.882 150.408 100.877 149.968C100.877 149.543 100.926 148.91 101.182 148.146L98.7024 147.73Z" fill="#253858"/>
        <path d="M103.076 145.3L104.338 149.04L105.203 148.978L105.386 148.388C105.546 148.557 105.701 148.731 105.86 148.9C106.319 148.949 106.948 148.968 107.677 148.847C108.46 148.717 109.084 148.465 109.514 148.257C109.383 148.18 109.171 148.064 108.9 147.939C108.731 147.861 108.451 147.75 108.064 147.644C107.064 147.368 106.812 147.552 106.44 147.272C106.232 147.112 106.14 146.909 105.966 146.508C105.797 146.121 105.594 145.517 105.531 144.71L103.076 145.3Z" fill="#253858"/>
        <path d="M93.6518 127.673H91.9844V123.468H95.2903C95.5464 123.709 96.571 124.734 96.4985 126.17C96.4792 126.532 96.4405 127.276 95.8751 127.716C95.3144 128.141 94.4396 128.127 93.6518 127.673Z" fill="#172B4D"/>
        <path d="M104.57 128.442C104.401 128.698 104.183 128.828 103.835 129.036C103.468 129.254 103.289 129.365 103.125 129.302C102.738 129.162 102.535 128.152 102.927 127.586C103.159 127.253 103.449 127.296 103.792 126.794C103.937 126.586 104 126.412 104.14 126.397C104.348 126.378 104.531 126.716 104.584 126.803C104.812 127.224 104.923 127.905 104.57 128.442Z" fill="#B5917C"/>
        <path d="M95.7783 127.427C96.3099 128.113 96.8512 128.833 97.3925 129.597C98.0063 130.457 98.5718 131.303 99.0986 132.125C99.5916 131.632 100.089 131.124 100.592 130.597C101.491 129.655 101.887 129.365 102.695 128.447C103.357 128.969 103.086 128.751 103.748 129.273C103.057 130.283 102.748 130.694 101.902 131.772C101.269 132.579 100.636 133.343 100.017 134.053C99.6786 134.444 99.1131 134.556 98.6492 134.324C98.2625 134.13 97.8614 133.913 97.4505 133.671C96.6676 133.212 95.9812 132.743 95.3916 132.299L95.7783 127.427Z" fill="url(#paint89_linear_1331_7994)"/>
        <path d="M96.5225 139.205C95.9183 139.176 95.2368 139.113 94.4974 138.983C93.7192 138.848 93.0233 138.664 92.4191 138.476C92.2644 134.851 92.1146 131.226 91.96 127.601C92.0663 127.47 92.8348 126.547 94.1542 126.513C95.4157 126.484 96.2131 127.292 96.334 127.422C96.4016 131.351 96.4596 135.281 96.5225 139.205Z" fill="#253858"/>
        <path d="M95.6139 130.051C95.3819 129.2 94.8358 128.843 94.3621 127.567C94.1737 127.064 94.077 126.634 94.0238 126.349L90.6213 126.165C90.515 126.349 90.3313 126.595 90.0365 126.774C89.4662 127.117 88.978 126.948 88.2482 127.112C87.8954 127.19 87.4169 127.368 86.8853 127.799C87.0834 131.177 87.2816 134.56 87.4749 137.939H95.8266C94.947 135.271 95.0823 133.473 95.3916 132.293C95.5656 131.641 95.8556 130.94 95.6139 130.051Z" fill="#FF991F"/>
        <path d="M93.7239 126.513C93.4532 126.61 92.9651 126.75 92.3368 126.75C91.5586 126.75 90.9787 126.532 90.708 126.411C90.8433 126.194 90.9883 125.909 91.085 125.561C91.2107 125.116 91.2155 124.725 91.1865 124.444C92.0613 124.56 92.9409 124.681 93.8157 124.797C93.7867 125.367 93.7529 125.943 93.7239 126.513Z" fill="#9C7761"/>
        <path d="M94.6907 135.29C94.768 135.498 94.0962 136.024 95.4012 135.459C95.4833 135.425 95.8361 135.353 96.0295 135.019C96.2325 134.671 95.9666 134.4 96.1986 134.101C96.3243 133.941 96.4693 133.932 96.5466 133.729C96.5998 133.584 96.6046 133.395 96.537 133.361C96.4596 133.323 96.3485 133.516 96.0198 133.787C95.696 134.053 95.6428 133.999 95.4012 134.236C95.2997 134.338 95.2513 134.405 95.0338 134.618C94.9227 134.729 94.9082 134.739 94.8743 134.782C94.8019 134.889 94.6279 135.116 94.6907 135.29Z" fill="#B5917C"/>
        <path d="M95.0434 120.752C95.1207 121.027 95.1932 121.332 95.2464 121.665C95.3237 122.12 95.3575 122.54 95.3672 122.912C95.3962 122.98 95.4445 123.096 95.5219 123.236C95.749 123.662 96.0003 123.923 95.9182 124.014C95.9134 124.024 95.5895 124.116 95.5364 124.155C95.4155 124.232 95.401 125.179 95.1546 125.542C94.6567 126.281 92.0952 126.242 91.375 125.01C91.1769 124.667 91.1624 124.304 91.1865 124.043C91.2155 124.039 91.2687 124.024 91.3267 124.005C91.7375 123.855 91.9115 123.531 91.9115 123.531C91.9888 123.106 92.1532 122.816 92.2643 122.656C92.767 121.931 93.6611 121.641 93.9559 121.612C94.0043 121.607 94.2121 121.588 94.4731 121.501C94.5214 121.487 94.5697 121.467 94.6229 121.438C94.7727 121.366 94.9467 121.192 95.0434 120.752Z" fill="#B5917C"/>
        <path d="M94.043 136.397L97.6147 132.623L100.181 133.193L102.999 132.386L99.5673 135.899L94.043 136.397Z" fill="#172B4D"/>
        <path d="M97.7793 134.169C97.557 133.986 96.6773 134.29 96.6773 134.29L96.7111 134.783L96.4937 135.769C96.4937 135.769 97.4845 135.465 97.7019 135.223C97.7599 135.16 97.7889 134.967 97.7889 134.967C97.7889 134.967 97.9388 134.856 97.9774 134.817C98.0741 134.72 98.1466 134.445 98.0548 134.343C98.0209 134.305 97.8469 134.343 97.8469 134.343C97.8469 134.343 97.8131 134.198 97.7793 134.169Z" fill="#B5917C"/>
        <path d="M95.5605 134.715C95.8698 134.667 96.1066 134.575 96.2661 134.503C96.4498 134.42 96.59 134.329 96.7108 134.29C96.7833 134.266 96.851 134.261 96.9138 134.295C96.9911 134.333 97.0443 134.415 97.0588 134.493C97.0878 134.638 96.9573 134.686 96.9186 134.913C96.8848 135.097 96.9525 135.145 96.8896 135.242C96.822 135.343 96.7301 135.314 96.6528 135.421C96.5803 135.527 96.6431 135.595 96.5851 135.687C96.4885 135.851 96.1598 135.841 96.039 135.841C95.7587 135.841 95.3527 135.899 94.821 136.18C94.8017 136.054 94.792 135.885 94.8355 135.687C94.9515 135.169 95.3623 134.894 95.4735 134.826C95.5025 134.788 95.5315 134.754 95.5605 134.715Z" fill="#B5917C"/>
        <path d="M88.1657 140.138C89.1807 141.433 90.9061 141.945 92.4624 141.414L101.172 138.441C101.264 139.156 101.394 139.935 101.573 140.761C101.766 141.66 101.974 142.39 102.259 143.366C102.453 144.043 102.752 145.082 103.042 146.097C103.704 145.957 104.381 145.797 105.072 145.614C105.381 145.531 105.686 145.449 105.986 145.367C105.517 143.023 105.12 141.056 104.719 139.04C104.545 138.146 104.366 137.233 103.656 136.329C102.776 135.217 101.578 134.739 100.819 134.521L87.4746 137.939V138.122C87.4746 138.857 87.7163 139.562 88.1657 140.138Z" fill="url(#paint90_linear_1331_7994)"/>
        <path d="M90.5004 127.504H88.833V123.299C89.9785 123.086 91.1239 122.874 92.2694 122.661C92.1775 122.879 92.0664 123.246 92.1147 123.676C92.2355 124.744 93.236 125 93.352 126.001C93.4148 126.547 93.1973 127.185 92.7285 127.547C92.163 127.973 91.2882 127.958 90.5004 127.504Z" fill="#172B4D"/>
        <path d="M90.9839 139.205C90.3797 139.176 89.6983 139.113 88.9588 138.983C88.1807 138.848 87.4847 138.664 86.8805 138.476C86.7259 134.851 86.576 131.226 86.4214 127.601C86.5277 127.47 87.2962 126.547 88.6156 126.513C89.8771 126.484 90.6746 127.292 90.7954 127.422C90.8631 131.351 90.9211 135.281 90.9839 139.205Z" fill="#253858"/>
        <path d="M92.4624 141.418C93.516 141.472 94.6518 141.486 95.8649 141.433C96.6286 141.399 97.3632 141.346 98.0592 141.278C98.2477 141.278 98.4314 141.278 98.6199 141.278C98.528 141.849 98.4362 142.52 98.3734 143.274C98.3202 143.878 98.3009 144.4 98.2912 144.797C98.2815 145.145 98.2815 145.401 98.2815 145.502C98.2815 146.049 98.2622 146.943 98.18 148.46C98.47 148.629 98.9678 148.881 99.6396 148.973C100.423 149.079 101.051 148.924 101.384 148.818C101.708 146.339 102.032 143.859 102.356 141.38L102.39 139.485C102.375 139.369 102.235 138.422 101.288 137.929C100.722 137.634 100.166 137.653 99.9393 137.673C97.4454 138.915 94.9515 140.167 92.4624 141.418Z" fill="url(#paint91_linear_1331_7994)"/>
        <path opacity="0.49" d="M99.0454 138.112C97.2668 139.006 95.4882 139.896 93.7096 140.79C93.4438 141.027 93.1779 141.239 92.9121 141.433C93.7627 141.467 94.6665 141.471 95.6187 141.438C96.8753 140.669 98.1077 139.596 99.0454 138.112Z" fill="url(#paint92_linear_1331_7994)"/>
        <path d="M88.5961 127.702C89.3646 128.302 89.0408 130.08 88.7169 132.99C88.5961 134.073 88.5139 134.952 88.4656 135.513C90.5874 135.174 92.627 135.189 94.7487 134.846C94.8212 135.092 95.0629 135.677 95.029 136.011C92.5641 136.615 90.336 137.432 87.9871 137.852C87.1607 138.002 86.3777 137.427 86.2569 136.595C86.0974 135.474 86.02 134.498 85.9814 133.7C85.962 128.679 86.629 128.007 86.8852 127.799C86.9915 127.712 87.3975 127.383 87.9098 127.422C87.9098 127.427 88.2771 127.456 88.5961 127.702Z" fill="url(#paint93_linear_1331_7994)"/>
        <path d="M129.939 202.654L128.837 202.432L142.089 137.832L143.191 138.059L129.939 202.654Z" fill="url(#paint94_linear_1331_7994)"/>
        </g>
        </g>
        <defs>
        <linearGradient id="paint0_linear_1331_7994" x1="104.039" y1="236.443" x2="104.039" y2="172.5" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1331_7994" x1="198.762" y1="155.133" x2="198.762" y2="129.301" gradientUnits="userSpaceOnUse">
        <stop offset="0.0242" stop-color="#091E42" stop-opacity="0"/>
        <stop offset="0.5932" stop-color="#091E42"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1331_7994" x1="205.773" y1="180.543" x2="225.461" y2="160.855" gradientUnits="userSpaceOnUse">
        <stop offset="0.0228" stop-color="#091E42" stop-opacity="0.4"/>
        <stop offset="0.9989" stop-color="#091E42"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1331_7994" x1="30.9848" y1="155.414" x2="11.2965" y2="135.726" gradientUnits="userSpaceOnUse">
        <stop offset="0.0228" stop-color="#091E42" stop-opacity="0.4"/>
        <stop offset="0.9989" stop-color="#091E42"/>
        </linearGradient>
        <linearGradient id="paint4_linear_1331_7994" x1="68.9947" y1="203.928" x2="68.9947" y2="171.624" gradientUnits="userSpaceOnUse">
        <stop offset="0.0242" stop-color="#091E42" stop-opacity="0"/>
        <stop offset="0.5932" stop-color="#091E42"/>
        </linearGradient>
        <linearGradient id="paint5_linear_1331_7994" x1="45.5188" y1="78.5871" x2="45.5188" y2="45.2916" gradientUnits="userSpaceOnUse">
        <stop offset="0.0242" stop-color="#091E42" stop-opacity="0"/>
        <stop offset="0.5932" stop-color="#091E42"/>
        </linearGradient>
        <linearGradient id="paint6_linear_1331_7994" x1="108.094" y1="236.487" x2="108.094" y2="178.922" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <radialGradient id="paint7_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(124.431 90.5768) rotate(6.34399) scale(35.2995 28.2389)">
        <stop offset="0.0873" stop-color="#79F2C0" stop-opacity="0.4"/>
        <stop offset="1" stop-color="#79F2C0" stop-opacity="0.8"/>
        </radialGradient>
        <linearGradient id="paint8_linear_1331_7994" x1="76.465" y1="76.4303" x2="144.208" y2="98.3136" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint9_linear_1331_7994" x1="71.1423" y1="91.8379" x2="139.531" y2="112.796" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint10_linear_1331_7994" x1="73.8425" y1="84.5478" x2="141.585" y2="106.431" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint11_linear_1331_7994" x1="73.3061" y1="84.7769" x2="141.695" y2="105.735" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint12_linear_1331_7994" x1="76.1013" y1="77.5552" x2="143.844" y2="99.4385" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint13_linear_1331_7994" x1="70.5385" y1="93.8082" x2="138.928" y2="114.766" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint14_linear_1331_7994" x1="73.4529" y1="85.7543" x2="141.196" y2="107.638" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint15_linear_1331_7994" x1="72.7821" y1="86.4873" x2="141.171" y2="107.445" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <radialGradient id="paint16_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(78.3372 170.621) rotate(-14.2822) scale(30.9236 24.7398)">
        <stop offset="0.0873" stop-color="#79F2C0" stop-opacity="0.4"/>
        <stop offset="1" stop-color="#79F2C0" stop-opacity="0.8"/>
        </radialGradient>
        <linearGradient id="paint17_linear_1331_7994" x1="34.6456" y1="173.883" x2="96.9414" y2="170.92" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint18_linear_1331_7994" x1="35.1586" y1="189.906" x2="97.6963" y2="185.984" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint19_linear_1331_7994" x1="35.0454" y1="188.105" x2="97.5832" y2="184.182" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint20_linear_1331_7994" x1="35.0087" y1="181.52" x2="97.3046" y2="178.557" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint21_linear_1331_7994" x1="34.6609" y1="181.97" x2="97.1985" y2="178.047" gradientUnits="userSpaceOnUse">
        <stop stop-color="#57D9A3"/>
        <stop offset="0.6856" stop-color="#57D9A3" stop-opacity="0"/>
        <stop offset="1" stop-color="#57D9A3"/>
        </linearGradient>
        <linearGradient id="paint22_linear_1331_7994" x1="167.908" y1="108.68" x2="206.63" y2="88.8727" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFAB00"/>
        <stop offset="1" stop-color="#FFE380"/>
        </linearGradient>
        <linearGradient id="paint23_linear_1331_7994" x1="81.5274" y1="230.691" x2="81.5274" y2="187.681" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint24_linear_1331_7994" x1="83.4203" y1="124.357" x2="83.4203" y2="75.4714" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint25_linear_1331_7994" x1="153.857" y1="234.124" x2="153.857" y2="200.486" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="0.7744" stop-color="#F2F3F6" stop-opacity="0.4064"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint26_linear_1331_7994" x1="150.486" y1="233.98" x2="150.486" y2="185.048" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint27_linear_1331_7994" x1="144.027" y1="234.131" x2="144.027" y2="182.524" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint28_linear_1331_7994" x1="86.7072" y1="230.436" x2="86.7072" y2="186.02" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint29_linear_1331_7994" x1="125.22" y1="236.418" x2="125.22" y2="177.223" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint30_linear_1331_7994" x1="132.165" y1="236.593" x2="132.165" y2="182.447" gradientUnits="userSpaceOnUse">
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint31_linear_1331_7994" x1="92.3073" y1="269.974" x2="138.345" y2="223.936" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0065FF"/>
        <stop offset="0.1102" stop-color="#1171FF"/>
        <stop offset="0.3181" stop-color="#2B83FF"/>
        <stop offset="0.5325" stop-color="#3D90FF"/>
        <stop offset="0.7554" stop-color="#4897FF"/>
        <stop offset="1" stop-color="#4C9AFF"/>
        </linearGradient>
        <linearGradient id="paint32_linear_1331_7994" x1="167.265" y1="144.108" x2="179.417" y2="123.059" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FAFBFC" stop-opacity="0"/>
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <radialGradient id="paint33_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(176.852 186.99) rotate(18.0236) scale(15.1235 15.1235)">
        <stop stop-color="#B2D4FF" stop-opacity="0.6"/>
        <stop offset="1" stop-color="#B2D4FF"/>
        </radialGradient>
        <linearGradient id="paint34_linear_1331_7994" x1="42.0147" y1="124.384" x2="119.785" y2="124.384" gradientUnits="userSpaceOnUse">
        <stop offset="0.1315" stop-color="#2684FF"/>
        <stop offset="0.3901" stop-color="#1E7DFF" stop-opacity="0.9007"/>
        <stop offset="0.7916" stop-color="#086CFF" stop-opacity="0.7465"/>
        <stop offset="0.9127" stop-color="#0065FF" stop-opacity="0.7"/>
        </linearGradient>
        <linearGradient id="paint35_linear_1331_7994" x1="114.279" y1="87.721" x2="45.5177" y2="119.923" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint36_linear_1331_7994" x1="34.3342" y1="137.804" x2="127.32" y2="123.273" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint37_linear_1331_7994" x1="35.3545" y1="144.332" x2="128.341" y2="129.801" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint38_linear_1331_7994" x1="36.4144" y1="148.491" x2="128.947" y2="129.001" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#0065FF" stop-opacity="0"/>
        <stop offset="0.5761" stop-color="#0065FF" stop-opacity="0.5761"/>
        <stop offset="1" stop-color="#0065FF"/>
        </linearGradient>
        <linearGradient id="paint39_linear_1331_7994" x1="35.8527" y1="147.521" x2="128.839" y2="132.989" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint40_linear_1331_7994" x1="36.5325" y1="149.052" x2="129.065" y2="129.562" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#0065FF" stop-opacity="0"/>
        <stop offset="0.5761" stop-color="#0065FF" stop-opacity="0.5761"/>
        <stop offset="1" stop-color="#0065FF"/>
        </linearGradient>
        <linearGradient id="paint41_linear_1331_7994" x1="111.14" y1="81.0167" x2="42.3784" y2="113.218" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint42_linear_1331_7994" x1="35.6671" y1="146.335" x2="128.653" y2="131.804" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint43_linear_1331_7994" x1="36.8145" y1="153.675" x2="129.801" y2="139.144" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint44_linear_1331_7994" x1="38.1148" y1="156.564" x2="130.648" y2="137.074" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#0065FF" stop-opacity="0"/>
        <stop offset="0.5761" stop-color="#0065FF" stop-opacity="0.5761"/>
        <stop offset="1" stop-color="#0065FF"/>
        </linearGradient>
        <radialGradient id="paint45_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(119.043 163.523) rotate(4.54811) scale(33.2698 26.615)">
        <stop offset="0.0873" stop-color="#00C7E5" stop-opacity="0.8"/>
        <stop offset="0.2511" stop-color="#10CAE7" stop-opacity="0.8"/>
        <stop offset="0.5699" stop-color="#39D4EB" stop-opacity="0.8"/>
        <stop offset="1" stop-color="#79E2F2" stop-opacity="0.8"/>
        </radialGradient>
        <linearGradient id="paint46_linear_1331_7994" x1="37.9431" y1="137.777" x2="107" y2="143.703" gradientUnits="userSpaceOnUse">
        <stop offset="0.5004" stop-color="#00C7E5"/>
        <stop offset="1" stop-color="#00C7E5" stop-opacity="0.1"/>
        </linearGradient>
        <linearGradient id="paint47_linear_1331_7994" x1="113.809" y1="139.836" x2="184.689" y2="171.847" gradientUnits="userSpaceOnUse">
        <stop offset="0.1315" stop-color="#2684FF"/>
        <stop offset="0.3901" stop-color="#1E7DFF" stop-opacity="0.9007"/>
        <stop offset="0.7916" stop-color="#086CFF" stop-opacity="0.7465"/>
        <stop offset="0.9127" stop-color="#0065FF" stop-opacity="0.7"/>
        </linearGradient>
        <linearGradient id="paint48_linear_1331_7994" x1="194.727" y1="136.239" x2="118.805" y2="137.279" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint49_linear_1331_7994" x1="194.747" y1="137.662" x2="118.825" y2="138.702" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint50_linear_1331_7994" x1="101.095" y1="149.561" x2="191.823" y2="174.586" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0065FF"/>
        <stop offset="0.8609" stop-color="#0065FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint51_linear_1331_7994" x1="98.0634" y1="160.552" x2="188.791" y2="185.578" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0065FF"/>
        <stop offset="0.8609" stop-color="#0065FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint52_linear_1331_7994" x1="98.1001" y1="162.348" x2="190.453" y2="182.679" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0065FF"/>
        <stop offset="0.8609" stop-color="#0065FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint53_linear_1331_7994" x1="194.659" y1="131.29" x2="118.738" y2="132.33" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint54_linear_1331_7994" x1="92.7266" y1="41.352" x2="154.61" y2="54.1357" gradientUnits="userSpaceOnUse">
        <stop offset="0.1315" stop-color="#0065FF"/>
        <stop offset="0.9127" stop-color="#0065FF"/>
        </linearGradient>
        <linearGradient id="paint55_linear_1331_7994" x1="155.833" y1="22.2844" x2="95.8211" y2="36.604" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#2684FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#2684FF"/>
        </linearGradient>
        <linearGradient id="paint56_linear_1331_7994" x1="84.392" y1="51.3362" x2="160.773" y2="55.0528" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint57_linear_1331_7994" x1="83.939" y1="60.6435" x2="160.32" y2="64.3601" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint58_linear_1331_7994" x1="84.3234" y1="62.1236" x2="161.163" y2="61.8256" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#0065FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#0065FF"/>
        </linearGradient>
        <linearGradient id="paint59_linear_1331_7994" x1="84.5781" y1="47.5065" x2="160.959" y2="51.2231" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint60_linear_1331_7994" x1="84.1799" y1="55.6941" x2="160.561" y2="59.4107" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2684FF"/>
        <stop offset="0.8609" stop-color="#2684FF" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint61_linear_1331_7994" x1="84.3021" y1="56.5928" x2="161.141" y2="56.2949" gradientUnits="userSpaceOnUse">
        <stop offset="0.1391" stop-color="#0065FF" stop-opacity="0"/>
        <stop offset="1" stop-color="#0065FF"/>
        </linearGradient>
        <linearGradient id="paint62_linear_1331_7994" x1="132.419" y1="61.9916" x2="185.281" y2="67.9929" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C1C7D0"/>
        <stop offset="1" stop-color="#F4F5F7"/>
        </linearGradient>
        <linearGradient id="paint63_linear_1331_7994" x1="147.858" y1="70.5411" x2="171.557" y2="73.2315" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00B8D9"/>
        <stop offset="1" stop-color="#79E2F2"/>
        </linearGradient>
        <linearGradient id="paint64_linear_1331_7994" x1="119.001" y1="128.428" x2="119.001" y2="73.2022" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FAFBFC" stop-opacity="0"/>
        <stop offset="0.4449" stop-color="white"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <radialGradient id="paint65_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(142.692 113.686) scale(25.4439)">
        <stop offset="0.0873" stop-color="#00C7E5" stop-opacity="0.8"/>
        <stop offset="0.2053" stop-color="#10CBE7" stop-opacity="0.8"/>
        <stop offset="0.4351" stop-color="#39D6ED" stop-opacity="0.8"/>
        <stop offset="0.7505" stop-color="#7AE6F7" stop-opacity="0.8"/>
        <stop offset="1" stop-color="#B3F5FF" stop-opacity="0.8"/>
        </radialGradient>
        <linearGradient id="paint66_linear_1331_7994" x1="104.404" y1="105.753" x2="168.86" y2="124.372" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint67_linear_1331_7994" x1="99.9647" y1="122.429" x2="165.006" y2="140.152" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint68_linear_1331_7994" x1="102.119" y1="113.663" x2="166.576" y2="132.281" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint69_linear_1331_7994" x1="102.216" y1="114.165" x2="167.258" y2="131.888" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint70_linear_1331_7994" x1="123.612" y1="94.469" x2="144.596" y2="94.469" gradientUnits="userSpaceOnUse">
        <stop offset="0.5004" stop-color="#008DA6"/>
        <stop offset="1" stop-color="#008DA6" stop-opacity="0.1"/>
        </linearGradient>
        <linearGradient id="paint71_linear_1331_7994" x1="61.0754" y1="158.149" x2="61.0754" y2="109.493" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FAFBFC" stop-opacity="0"/>
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint72_linear_1331_7994" x1="34.871" y1="98.428" x2="65.7682" y2="66.7041" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFAB00"/>
        <stop offset="1" stop-color="#FFE380"/>
        </linearGradient>
        <radialGradient id="paint73_radial_1331_7994" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(82.673 57.2788) rotate(-5.90044) scale(29.4953 23.5976)">
        <stop offset="0.0873" stop-color="#00C7E5" stop-opacity="0.4"/>
        <stop offset="1" stop-color="#00C7E5" stop-opacity="0.8"/>
        </radialGradient>
        <linearGradient id="paint74_linear_1331_7994" x1="40.1605" y1="54.3856" x2="99.3537" y2="60.2567" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint75_linear_1331_7994" x1="39.237" y1="69.6718" x2="98.7972" y2="74.6685" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint76_linear_1331_7994" x1="39.4396" y1="61.6521" x2="98.6328" y2="67.5232" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint77_linear_1331_7994" x1="39.8723" y1="62.0992" x2="99.4325" y2="67.096" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00C7E5"/>
        <stop offset="0.6856" stop-color="#00C7E5" stop-opacity="0"/>
        <stop offset="1" stop-color="#00C7E5"/>
        </linearGradient>
        <linearGradient id="paint78_linear_1331_7994" x1="80.3834" y1="32.0909" x2="82.1577" y2="32.0909" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F4F5F7"/>
        <stop offset="1" stop-color="#C1C7D0"/>
        </linearGradient>
        <linearGradient id="paint79_linear_1331_7994" x1="79.6031" y1="32.086" x2="80.3836" y2="32.086" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F4F5F7"/>
        <stop offset="1" stop-color="#C1C7D0"/>
        </linearGradient>
        <linearGradient id="paint80_linear_1331_7994" x1="84.4836" y1="31.0648" x2="84.4835" y2="23.0833" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F4F5F7" stop-opacity="0.4"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint81_linear_1331_7994" x1="141.141" y1="59.4263" x2="144.952" y2="59.4263" gradientUnits="userSpaceOnUse">
        <stop offset="0.3771" stop-color="#F1DBCB"/>
        <stop offset="1" stop-color="#EFC7B0"/>
        </linearGradient>
        <linearGradient id="paint82_linear_1331_7994" x1="129.695" y1="61.2074" x2="127.315" y2="61.2074" gradientUnits="userSpaceOnUse">
        <stop offset="0.3771" stop-color="#F1DBCB"/>
        <stop offset="1" stop-color="#EFC7B0"/>
        </linearGradient>
        <linearGradient id="paint83_linear_1331_7994" x1="128.455" y1="67.7819" x2="122.661" y2="67.7819" gradientUnits="userSpaceOnUse">
        <stop stop-color="#253858"/>
        <stop offset="1" stop-color="#344563"/>
        </linearGradient>
        <linearGradient id="paint84_linear_1331_7994" x1="136.798" y1="82.1444" x2="126.228" y2="82.1444" gradientUnits="userSpaceOnUse">
        <stop offset="0.3771" stop-color="#F1DBCB"/>
        <stop offset="1" stop-color="#EFC7B0"/>
        </linearGradient>
        <linearGradient id="paint85_linear_1331_7994" x1="136.798" y1="91.1722" x2="133.754" y2="91.1722" gradientUnits="userSpaceOnUse">
        <stop stop-color="#253858"/>
        <stop offset="1" stop-color="#344563"/>
        </linearGradient>
        <linearGradient id="paint86_linear_1331_7994" x1="129.867" y1="89.9247" x2="127.661" y2="89.9247" gradientUnits="userSpaceOnUse">
        <stop stop-color="#253858"/>
        <stop offset="1" stop-color="#344563"/>
        </linearGradient>
        <linearGradient id="paint87_linear_1331_7994" x1="130.869" y1="59.759" x2="128.042" y2="59.759" gradientUnits="userSpaceOnUse">
        <stop offset="0.3771" stop-color="#F1DBCB"/>
        <stop offset="1" stop-color="#EFC7B0"/>
        </linearGradient>
        <linearGradient id="paint88_linear_1331_7994" x1="142.221" y1="65.3555" x2="124.892" y2="65.3555" gradientUnits="userSpaceOnUse">
        <stop stop-color="#253858"/>
        <stop offset="1" stop-color="#344563"/>
        </linearGradient>
        <linearGradient id="paint89_linear_1331_7994" x1="95.3898" y1="130.936" x2="103.745" y2="130.936" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF991F"/>
        <stop offset="1" stop-color="#FFC400"/>
        </linearGradient>
        <linearGradient id="paint90_linear_1331_7994" x1="93.187" y1="145.2" x2="102.876" y2="135.511" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF991F"/>
        <stop offset="1" stop-color="#FFC400"/>
        </linearGradient>
        <linearGradient id="paint91_linear_1331_7994" x1="92.4626" y1="143.329" x2="102.385" y2="143.329" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF991F"/>
        <stop offset="1" stop-color="#FFC400"/>
        </linearGradient>
        <linearGradient id="paint92_linear_1331_7994" x1="90.1812" y1="139.73" x2="100.611" y2="139.731" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC400"/>
        <stop offset="1" stop-color="#FFF0B2"/>
        </linearGradient>
        <linearGradient id="paint93_linear_1331_7994" x1="85.9794" y1="132.65" x2="95.0319" y2="132.65" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF991F"/>
        <stop offset="1" stop-color="#FFC400"/>
        </linearGradient>
        <linearGradient id="paint94_linear_1331_7994" x1="116.693" y1="181.399" x2="155.335" y2="159.089" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FAFBFC" stop-opacity="0"/>
        <stop offset="0.4449" stop-color="#EBECF0"/>
        <stop offset="1" stop-color="#FAFBFC" stop-opacity="0"/>
        </linearGradient>
        <clipPath id="clip0_1331_7994">
        <rect width="237" height="271" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        `
        }
    });
}


const $d8520d9637758d56$var$style = {
    requiredFieldSummary: "_11c81o8v _otyrv77o _syazazsu"
};
const $d8520d9637758d56$var$LEARN_MORE_LINK = `${(0, $cQuKk.getAtlassianContextUrl)('support')}/atlassian-account/docs/what-is-an-atlassian-team/`;
function $d8520d9637758d56$var$TeamLearnMoreLink() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__people-and-tea') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        rel: "noreferrer",
        href: $d8520d9637758d56$var$LEARN_MORE_LINK,
        children: formatMessage((0, $7sG51.messages).learnMore)
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        href: $d8520d9637758d56$var$LEARN_MORE_LINK,
        children: formatMessage((0, $7sG51.messages).learnMore)
    });
}
function $d8520d9637758d56$var$TeamCreateDialog(props) {
    const { proposedMembers: proposedMembers = [], cloudId: cloudId, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), extraAnalyticsAttrs: extraAnalyticsAttrs, enableMembershipSettingsChoice: enableMembershipSettingsChoice, initialMembershipSettings: initialMembershipSettings = enableMembershipSettingsChoice ? (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY : (0, $jQbDV.TeamMembershipSettings).OPEN, createTeamAndAddMembers: createTeamAndAddMembers = (0, $dTRYM.VOID_FUNC), setIsLoading: setIsLoading = (0, $dTRYM.VOID_FUNC), onClose: onClose = (0, $dTRYM.VOID_FUNC), customMessages: customMessages = {}, imageProportion: imageProportion, descriptionProportion: descriptionProportion, customComponents: customComponents = {}, currentUser: currentUser, orgId: orgId, enableTeamPermissionCheck: enableTeamPermissionCheck, prepopulatedFields: prepopulatedFields = {} } = props;
    const { modalTitle: modalTitle = null, descriptionContent: descriptionContent = null, submitButtonLabel: submitButtonLabel = null, imageContent: imageContent = null } = customMessages;
    const Header = customComponents.modalHeader ?? (0, $9ot3w.default);
    const Title = customComponents.modalTitle ?? (0, $d8eRd.default);
    const Body = customComponents.modalBody ?? (0, $1DHa6.default);
    const Footer = customComponents.modalFooter ?? (0, $8o1lj.default);
    const { members: proposedMembersNext, membershipSettings: initialMembershipSettingsNext, teamName: initialTeamName } = prepopulatedFields;
    const [teamName, setTeamName] = (0, $42omo.useState)(initialTeamName || '');
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const [membershipSettings, setMembershipSettings] = (0, $42omo.useState)(initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings);
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    const [isSubmittedOnce, setIsSubmittedOnce] = (0, $42omo.useState)(false);
    const [isMemberPickerInvalid, setIsMemberPickerInvalid] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { loading: loading, permissions: permissions } = (0, $3jKGE.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: !!enableTeamPermissionCheck,
        attributes: {
            userId: currentUser?.id
        }
    });
    const userPickerRef = (0, $42omo.useRef)(null);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { triggerAnalyticsForSubmitTeamCreateDialog: triggerAnalyticsForSubmitTeamCreateDialogNext } = (0, $dVp1j.default)();
    (0, $cEyfH.useContainerPermissionsAnalyticsEvent)(cloudId, currentUser?.id);
    const proposedMembersWithCurrentUser = (0, $42omo.useMemo)(()=>{
        const members = [
            ...proposedMembersNext ? proposedMembersNext : proposedMembers,
            ...currentUser && currentUser.id ? [
                currentUser
            ] : []
        ];
        const uniqueMembers = members.filter((member, index, self)=>index === self.findIndex((m)=>m.id === member.id));
        return uniqueMembers;
    }, [
        proposedMembersNext,
        proposedMembers,
        currentUser
    ]); // did mount
    (0, $42omo.useEffect)(()=>{
        setSelectedMembers(proposedMembersWithCurrentUser);
        fireEvent('screen.teamCreateDialog.viewed', {
            proposedMembersLength: (proposedMembersNext ? proposedMembersNext : proposedMembers).length,
            ...extraAnalyticsAttrs
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        setIsFetching(!!props.isFetching);
        setIsLoading(!!props.isFetching || loading); // when isFetching prop change from true --> false, that means the creating team finishes
        if (props.isFetching === false && isFetching === true) onClose();
    }, [
        props.isFetching,
        isFetching,
        setIsLoading,
        onClose,
        loading
    ]);
    const handleSelectedChange = (0, $42omo.useCallback)((users, data)=>{
        setSelectedMembers(users.map((user)=>({
                id: user.id,
                email: user.email,
                fullName: user.name,
                avatarUrl: user.avatarUrl
            })));
        setIsMemberPickerInvalid(data.hasError || users.length === 0);
    }, [
        setIsMemberPickerInvalid,
        setSelectedMembers
    ]);
    const canTeamBeCreated = (0, $42omo.useCallback)(()=>{
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
        return !isMemberPickerInvalid && !teamNameValidationError && !isFetching;
    }, [
        isFetching,
        isMemberPickerInvalid,
        teamName
    ]);
    const handleSubmit = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsForSubmitTeamCreateDialogNext({
            canCreateTeam: canTeamBeCreated(),
            numberOfMembers: selectedMembers.length,
            numberOfSuggestedMembers: 0,
            // As we don't have suggested members in this version
            ...extraAnalyticsAttrs
        });
        setIsSubmittedOnce(true);
        if (!canTeamBeCreated()) {
            const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
            const inviteMembersValidationError = selectedMembers.length === 0;
            if (inviteMembersValidationError) userPickerRef.current?.focus?.();
            return {
                teamName: teamNameValidationError,
                inviteMembers: inviteMembersValidationError
            };
        }
        if (canTeamBeCreated()) {
            setIsFetching(true); // outsource creating a new team + invite members logic to outside
            // to reduce complexity of current file
            createTeamAndAddMembers(teamName, selectedMembers, membershipSettings);
        }
    }, [
        canTeamBeCreated,
        createTeamAndAddMembers,
        extraAnalyticsAttrs,
        membershipSettings,
        selectedMembers,
        teamName,
        triggerAnalyticsForSubmitTeamCreateDialogNext
    ]);
    if (!permissions.canCreateTeams) return /*#__PURE__*/ (0, $l998X.jsx)(Body, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cIiie.default), {
            onAction: onClose
        })
    });
    return (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                    children: modalTitle ?? formatMessage((0, $7sG51.messages).modalTitle)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(Body, {
                children: /*#__PURE__*/ (0, $l998X.jsxs)($e0BNA.IllustratedDialogContent, {
                    "data-test-selector": "create-team-content-dialog",
                    "data-testid": "create-team-content-dialog",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.ImageSection, {
                            imageProportion: imageProportion,
                            children: imageContent ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $0ad787571fc2acbc$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)($e0BNA.TeamDataSection, {
                            descriptionProportion: descriptionProportion,
                            children: [
                                descriptionContent ?? /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.DescriptionParagraph, {
                                    children: formatMessage((0, $7sG51.messages).formTextWithMention, {
                                        learnMoreLink: /*#__PURE__*/ (0, $l998X.jsx)($d8520d9637758d56$var$TeamLearnMoreLink, {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($d8520d9637758d56$var$style.requiredFieldSummary),
                                    children: [
                                        formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fe890355bd728fcd$export$2e2bcd8739ae039), {
                                    onChange: setTeamName,
                                    onSubmit: handleSubmit,
                                    isSubmittedOnce: isSubmittedOnce,
                                    initialTeamName: teamName
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.UserPickerWrapper, {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: "inviteMembers",
                                        label: formatMessage((0, $7sG51.messages).invitationsFieldLabel),
                                        id: "inviteMembers",
                                        isRequired: true,
                                        children: ({ fieldProps: fieldProps, error: error })=>{
                                            // oxlint-disable-next-line no-unused-vars
                                            const { value: value, ...memberPickerProps } = fieldProps;
                                            const fieldIsInvalid = isSubmittedOnce ? isMemberPickerInvalid : !!error;
                                            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3bcb7900a35aed3c$export$2e2bcd8739ae039), {
                                                        ...memberPickerProps,
                                                        ref: userPickerRef,
                                                        cloudId: cloudId,
                                                        onChange: handleSelectedChange,
                                                        initialValues: proposedMembersWithCurrentUser,
                                                        maxSelectedMembers: maxSelectedMembers,
                                                        extraAnalyticsAttrs: extraAnalyticsAttrs,
                                                        showHelperMessages: !fieldIsInvalid,
                                                        isInvalid: fieldIsInvalid,
                                                        ariaLabelledBy: `${fieldProps.id}-label`,
                                                        ariaDescribedBy: fieldIsInvalid ? `${fieldProps.id}-error` : `${fieldProps.id}-helper`,
                                                        inputId: fieldProps.id
                                                    }),
                                                    fieldIsInvalid && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                        testId: "invitation-field-empty-error",
                                                        children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessage, {
                                                            maxSelectedMembers: maxSelectedMembers
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                }),
                                enableMembershipSettingsChoice && /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                    onChange: setMembershipSettings,
                                    defaultValue: initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9YwaJ.default), {
                        appearance: "subtle",
                        onClick: onClose,
                        children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9YwaJ.default), {
                        appearance: "primary",
                        isLoading: isFetching,
                        type: "submit",
                        children: submitButtonLabel ?? formatMessage((0, $7sG51.messages).submitButtonLabel)
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                            children: modalTitle ?? formatMessage((0, $7sG51.messages).modalTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)(Body, {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)($e0BNA.IllustratedDialogContent, {
                            "data-test-selector": "create-team-content-dialog",
                            "data-testid": "create-team-content-dialog",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.ImageSection, {
                                    imageProportion: imageProportion,
                                    children: imageContent ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $0ad787571fc2acbc$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)($e0BNA.TeamDataSection, {
                                    descriptionProportion: descriptionProportion,
                                    children: [
                                        descriptionContent ?? /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.DescriptionParagraph, {
                                            children: formatMessage((0, $7sG51.messages).formTextWithMention, {
                                                learnMoreLink: /*#__PURE__*/ (0, $l998X.jsx)($d8520d9637758d56$var$TeamLearnMoreLink, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                            xcss: (0, $1Whri.cx)($d8520d9637758d56$var$style.requiredFieldSummary),
                                            children: [
                                                formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fe890355bd728fcd$export$2e2bcd8739ae039), {
                                            onChange: setTeamName,
                                            onSubmit: handleSubmit,
                                            isSubmittedOnce: isSubmittedOnce,
                                            initialTeamName: teamName
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.UserPickerWrapper, {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: "inviteMembers",
                                                label: formatMessage((0, $7sG51.messages).invitationsFieldLabel),
                                                id: "inviteMembers",
                                                isRequired: true,
                                                children: ({ fieldProps: fieldProps, error: error })=>{
                                                    // oxlint-disable-next-line no-unused-vars
                                                    const { value: value, ...memberPickerProps } = fieldProps;
                                                    const fieldIsInvalid = isSubmittedOnce ? isMemberPickerInvalid : !!error;
                                                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $3bcb7900a35aed3c$export$2e2bcd8739ae039), {
                                                                ...memberPickerProps,
                                                                ref: userPickerRef,
                                                                cloudId: cloudId,
                                                                onChange: handleSelectedChange,
                                                                initialValues: proposedMembersWithCurrentUser,
                                                                maxSelectedMembers: maxSelectedMembers,
                                                                extraAnalyticsAttrs: extraAnalyticsAttrs,
                                                                showHelperMessages: !fieldIsInvalid,
                                                                isInvalid: fieldIsInvalid,
                                                                ariaLabelledBy: `${fieldProps.id}-label`,
                                                                ariaDescribedBy: fieldIsInvalid ? `${fieldProps.id}-error` : `${fieldProps.id}-helper`,
                                                                inputId: fieldProps.id
                                                            }),
                                                            fieldIsInvalid && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                                testId: "invitation-field-empty-error",
                                                                children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessage, {
                                                                    maxSelectedMembers: maxSelectedMembers
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            })
                                        }),
                                        enableMembershipSettingsChoice && /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                            onChange: setMembershipSettings,
                                            defaultValue: initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $9YwaJ.default), {
                                appearance: "subtle",
                                onClick: onClose,
                                children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $9YwaJ.default), {
                                appearance: "primary",
                                isLoading: isFetching,
                                type: "submit",
                                children: submitButtonLabel ?? formatMessage((0, $7sG51.messages).submitButtonLabel)
                            })
                        ]
                    })
                ]
            })
    });
}
var $d8520d9637758d56$export$2e2bcd8739ae039 = $d8520d9637758d56$var$TeamCreateDialog;


function $8149c7d0e0b719ba$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId, orgId: orgId, product: product, onCreateTeamSuccess: onCreateTeamSuccess = (0, $dTRYM.VOID_FUNC), onCreateTeamFailed: onCreateTeamFailed = (0, $dTRYM.VOID_FUNC) } = props;
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    // need a state to keep sync status of 2 requests: Create team and Invite members
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { loading: isCreatingTeam, error: errorCreateTeam, data: teamData, createTeam: createTeam } = (0, $8ftiF.useCreateTeamService)(cloudId, product, undefined, orgId);
    // This function is used to create teams
    const handleCreateTeamWithMembers = (0, $42omo.useCallback)((teamName, requestedMembers, membershipSettings)=>{
        if (isCreatingTeam) return;
        setSelectedMembers(requestedMembers);
        setIsFetching(true);
        const memberIds = requestedMembers.map((member)=>member.id);
        return createTeam(teamName, membershipSettings, memberIds);
    }, [
        createTeam,
        isCreatingTeam
    ]);
    const isFinishedCreateTeam = !errorCreateTeam && !isCreatingTeam && teamData;
    // call callbacks for creating teams
    (0, $hYSRS.useOnceWhen)(!!(isFinishedCreateTeam || errorCreateTeam), ()=>{
        // always call onCreateTeamSuccess when creating team successfully, though inviting members can fail
        // since users can work around by re-inviting members in the team profile page.
        if (isFinishedCreateTeam) {
            const successfullyInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>teamData.memberIds?.includes(m.id)) : selectedMembers;
            const failedInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>!teamData.memberIds?.includes(m.id)) : undefined;
            onCreateTeamSuccess(teamData, successfullyInvitedMembers, failedInvitedMembers);
            setIsFetching(false);
        }
        if (errorCreateTeam) {
            onCreateTeamFailed(errorCreateTeam, selectedMembers);
            // no need to invite anyone to team as members already invited
            setIsFetching(false);
        }
    }, [
        errorCreateTeam,
        isFinishedCreateTeam,
        onCreateTeamFailed,
        onCreateTeamSuccess,
        selectedMembers,
        teamData,
        setIsFetching,
        createAnalyticsEvent,
        product
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8520d9637758d56$export$2e2bcd8739ae039), {
        ...props,
        createTeamAndAddMembers: handleCreateTeamWithMembers,
        isFetching: isFetching
    });
}


const $17f32c43ffd1024a$export$71dc9c3955cb220f = (0, $2iK1S.withMandatoryPeopleMenuConfiguration)((props)=>{
    const { product: product, onCreateTeamSuccess: onCreateTeamSuccess = (0, $dTRYM.VOID_FUNC), onCreateTeamFailed: onCreateTeamFailed = (0, $dTRYM.VOID_FUNC), addFlag: addFlag = (0, $dTRYM.VOID_FUNC), pushRoute: pushRoute = (0, $dTRYM.VOID_FUNC), disableSuccessFlag: disableSuccessFlag, extraAnalyticsAttrs: extraAnalyticsAttrs, initialMembershipSettings: initialMembershipSettings, enableMembershipSettingsChoice: enableMembershipSettingsChoice } = props;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { triggerAnalyticsForCreateTeamSuccess: triggerAnalyticsForCreateTeamSuccessNext, triggerAnalyticsForCreateTeamFailed: triggerAnalyticsForCreateTeamFailedNext } = (0, $dVp1j.default)();
    const handleOnClickTeamLinkInFlag = (0, $42omo.useCallback)((event, teamData, invitedMembers)=>{
        event.preventDefault();
        fireEvent('ui.teamCreateDialog.clicked.teamLinkSuccessFlag', {
            teamId: teamData.id,
            numberOfMembers: invitedMembers.length,
            ...extraAnalyticsAttrs
        });
        // redirect to team page
        pushRoute((0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
            remoteConfigResources: props.remoteConfig.resources,
            teamId: teamData.id,
            ref: product,
            src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
            orgId: props.orgId
        }));
    }, [
        extraAnalyticsAttrs,
        product,
        props.orgId,
        props.remoteConfig.resources,
        pushRoute,
        fireEvent
    ]);
    const handleCreateTeamSuccess = (0, $42omo.useCallback)((teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers)=>{
        triggerAnalyticsForCreateTeamSuccessNext({
            numberOfMembers: invitedMembers.length,
            numberOfSuggestedMembers: numberOfSuggestedMembers || 0,
            teamId: teamData.id,
            defaultTeamType: initialMembershipSettings || null,
            chosenTeamType: teamData.membershipSettings,
            teamTypeChoiceEnabled: enableMembershipSettingsChoice || null,
            ...extraAnalyticsAttrs
        });
        onCreateTeamSuccess(teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers);
        if (failedInvitedMembers && failedInvitedMembers.length > 0) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
        if (!disableSuccessFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamTitle, {
                teamName: teamData.displayName
            }),
            description: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamDesc),
            appearance: 'success',
            id: 'create.team.success',
            actions: [
                {
                    content: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamAction),
                    onClick: (event)=>handleOnClickTeamLinkInFlag(event, teamData, invitedMembers),
                    href: (0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
                        remoteConfigResources: props.remoteConfig.resources,
                        teamId: teamData.id,
                        ref: product,
                        src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
                        orgId: props.orgId
                    })
                }
            ]
        });
    }, [
        initialMembershipSettings,
        enableMembershipSettingsChoice,
        extraAnalyticsAttrs,
        onCreateTeamSuccess,
        disableSuccessFlag,
        addFlag,
        formatMessage,
        props.remoteConfig.resources,
        props.orgId,
        product,
        handleOnClickTeamLinkInFlag,
        triggerAnalyticsForCreateTeamSuccessNext
    ]);
    const handleCreateTeamFailed = (0, $42omo.useCallback)((error, invitedMembers)=>{
        if ((0, $cpl2G.isSeriousError)(error)) triggerAnalyticsForCreateTeamFailedNext({
            numberOfMembers: invitedMembers.length,
            errorMessage: error.message,
            errorStack: error.stack || null,
            errorStatus: error.status,
            traceId: error.traceId || null,
            ...extraAnalyticsAttrs
        });
        onCreateTeamFailed(error, invitedMembers);
        if (addFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
    }, [
        onCreateTeamFailed,
        addFlag,
        extraAnalyticsAttrs,
        formatMessage,
        triggerAnalyticsForCreateTeamFailedNext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8149c7d0e0b719ba$export$2e2bcd8739ae039), {
        ...props,
        onCreateTeamSuccess: handleCreateTeamSuccess,
        onCreateTeamFailed: handleCreateTeamFailed
    });
});
const $17f32c43ffd1024a$export$73ae34c57cc42bde = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iMEBP.LazyIntlProvider), {
        fetchLanguageFile: (0, $kLwto.fetchLanguageFile),
        children: /*#__PURE__*/ (0, $l998X.jsx)($17f32c43ffd1024a$export$71dc9c3955cb220f, {
            ...props
        })
    });
var $17f32c43ffd1024a$export$2e2bcd8739ae039 = (0, $954d28cdad8a6bb0$export$2e2bcd8739ae039);

});

parcelRegister("iMEBP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");

const $c185de2fb66b56b0$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $c185de2fb66b56b0$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $c185de2fb66b56b0$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $c185de2fb66b56b0$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $c185de2fb66b56b0$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $8C5kA.default)();
    const { messages: messages } = $c185de2fb66b56b0$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $1e2E5.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};
module.exports["LazyIntlProvider"] = $c185de2fb66b56b0$export$b4f1ecc6daf5eb10;

});

parcelRegister("erMpQ", function(module, exports) {
function $6add25e4d38bca26$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $6add25e4d38bca26$export$d479c7e8f449d360(originQuery) {
    return $6add25e4d38bca26$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $6add25e4d38bca26$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $6add25e4d38bca26$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src, containers: containers }) {
    const params = {
        ref: ref,
        src: src,
        requestedContainers: containers && containers.length > 0 ? containers.join(',') : undefined
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}
module.exports["constructProductOriginParams"] = $6add25e4d38bca26$export$d479c7e8f449d360;
module.exports["getPeopleDirectoryHomePageWithOrgId"] = $6add25e4d38bca26$export$873f5b458fb2c7bd;
module.exports["getPeopleProfilePage"] = $6add25e4d38bca26$export$8d1c08ae3a193cc5;
module.exports["getTeamProfilePageLinkWithOrgId"] = $6add25e4d38bca26$export$143be302a1686103;
module.exports["trimLastForwardSlash"] = $6add25e4d38bca26$export$41ba1f3da3359c4;

});

parcelRegister("3lZRK", function(module, exports) {

let $2713528b3831c9f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2713528b3831c9f6$var$load("48eS0").then(()=>parcelRequire('ypOne'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7mqs9", function(module, exports) {

let $55bf1b7f686c086e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55bf1b7f686c086e$var$load("lak6L").then(()=>parcelRequire('b3xxh'));

});

parcelRegister("9QXth", function(module, exports) {

let $72c71a29467c0ffb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72c71a29467c0ffb$var$load("inCHL").then(()=>parcelRequire('8KrTk'));

});

parcelRegister("gwBdZ", function(module, exports) {

let $c07c8285b27c853e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c07c8285b27c853e$var$load("lLx4a").then(()=>parcelRequire('2JrnR'));

});

parcelRegister("4gfKl", function(module, exports) {

let $31a4def8cb892837$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31a4def8cb892837$var$load("auTAr").then(()=>parcelRequire('88hCk'));

});

parcelRegister("5Jjgo", function(module, exports) {

let $42c019073de7d257$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42c019073de7d257$var$load("9pxVf").then(()=>parcelRequire('7DuAp'));

});

parcelRegister("d6SYh", function(module, exports) {

let $98b67a0f10790a1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98b67a0f10790a1a$var$load("4cEzx").then(()=>parcelRequire('igYJ8'));

});

parcelRegister("3oCoP", function(module, exports) {

let $27916651a2909578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27916651a2909578$var$load("iUIL3").then(()=>parcelRequire('aIz3E'));

});

parcelRegister("iWlgX", function(module, exports) {

let $dc9e2511c533211d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc9e2511c533211d$var$load("lADZV").then(()=>parcelRequire('l27r9'));

});

parcelRegister("bt9tU", function(module, exports) {

let $8599c1f4dcea2e37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8599c1f4dcea2e37$var$load("1QHKh").then(()=>parcelRequire('l1BWk'));

});

parcelRegister("7iYB2", function(module, exports) {

let $551937ffa78c83a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $551937ffa78c83a1$var$load("2Tjcq").then(()=>parcelRequire('jqujB'));

});

parcelRegister("7XDBL", function(module, exports) {

let $5cbcc474efe5950b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cbcc474efe5950b$var$load("4WVVc").then(()=>parcelRequire('lHEzk'));

});

parcelRegister("2qcAk", function(module, exports) {

let $1c37c59193b5b826$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c37c59193b5b826$var$load("1QNch").then(()=>parcelRequire('7cv4i'));

});

parcelRegister("iAkHQ", function(module, exports) {

let $d87ba69802196301$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d87ba69802196301$var$load("jQCyA").then(()=>parcelRequire('ctrbZ'));

});

parcelRegister("7fKvu", function(module, exports) {

let $547e0265011c56a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $547e0265011c56a2$var$load("aQwae").then(()=>parcelRequire('4w9rV'));

});

parcelRegister("QhOo0", function(module, exports) {

let $09d2ac78e93fafff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d2ac78e93fafff$var$load("cS1j1").then(()=>parcelRequire('7MhCX'));

});

parcelRegister("ax0PZ", function(module, exports) {

let $7aada2c812f4ec72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aada2c812f4ec72$var$load("48pzM").then(()=>parcelRequire('bgdNn'));

});

parcelRegister("79QiG", function(module, exports) {

let $5361f173491caa0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5361f173491caa0e$var$load("c4a0F").then(()=>parcelRequire('7WlOv'));

});

parcelRegister("fCW89", function(module, exports) {

let $b6077f26741f40f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6077f26741f40f8$var$load("cBmO4").then(()=>parcelRequire('ab9yn'));

});

parcelRegister("6ytYa", function(module, exports) {

let $4c5d2a5856125022$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c5d2a5856125022$var$load("9e3Ob").then(()=>parcelRequire('3rV3A'));

});

parcelRegister("d21At", function(module, exports) {

let $97ccb17b6c28f40d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97ccb17b6c28f40d$var$load("7Hoje").then(()=>parcelRequire('2lDN4'));

});

parcelRegister("86pAZ", function(module, exports) {

let $0185b8ba00cd75ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0185b8ba00cd75ac$var$load("4dj0m").then(()=>parcelRequire('ifesT'));

});

parcelRegister("fBNxQ", function(module, exports) {

let $b5d0be470396825e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5d0be470396825e$var$load("j5HYK").then(()=>parcelRequire('lv5RJ'));

});

parcelRegister("e9b8w", function(module, exports) {

let $a4ca8b6726837ddc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4ca8b6726837ddc$var$load("1VsiM").then(()=>parcelRequire('aWXF5'));

});

parcelRegister("jRB0q", function(module, exports) {

let $e75fac26cd1722bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e75fac26cd1722bb$var$load("8CqFM").then(()=>parcelRequire('1szz9'));

});

parcelRegister("8DFjK", function(module, exports) {

let $64a20405f6d7df00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64a20405f6d7df00$var$load("5bAmA").then(()=>parcelRequire('aBbj7'));

});

parcelRegister("7iUnH", function(module, exports) {

let $5515f2ffc8852585$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5515f2ffc8852585$var$load("i0Evx").then(()=>parcelRequire('84bj3'));

});

parcelRegister("5hoEo", function(module, exports) {

let $3d81a95ceac97d91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d81a95ceac97d91$var$load("j8OKz").then(()=>parcelRequire('gt5E9'));

});

parcelRegister("h5TZH", function(module, exports) {

let $c71e568d58ce4b9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c71e568d58ce4b9e$var$load("2s1Lz").then(()=>parcelRequire('gqrqX'));

});

parcelRegister("eKtdF", function(module, exports) {

let $abcc06ea6070f8b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcc06ea6070f8b8$var$load("iI3rq").then(()=>parcelRequire('65XvS'));

});

parcelRegister("i4zsj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");





var $kt8c2 = parcelRequire("kt8c2");

const $171125cd3846f2ee$export$86e2cef2561044ac = (key, defaultValue)=>{
    const storageClient = (0, $42omo.useMemo)(()=>new (0, $kt8c2.default)(key), [
        key
    ]);
    const [value, setValue] = (0, $42omo.useState)(()=>storageClient.getItem(key) ?? defaultValue);
    (0, $42omo.useEffect)(()=>{
        const loadedValue = storageClient.getItem(key) ?? undefined;
        if (loadedValue !== undefined) setValue(loadedValue);
    }, [
        key,
        storageClient
    ]);
    (0, $42omo.useEffect)(()=>{
        storageClient.setItemWithExpiry(key, value);
    }, [
        key,
        storageClient,
        value
    ]);
    return [
        value,
        setValue
    ];
};
function $171125cd3846f2ee$export$6fe28cddb1ee55a2(key, initialValue = [], maxLength = 100) {
    const [records, setRecords] = $171125cd3846f2ee$export$86e2cef2561044ac(key, initialValue);
    const putRecord = (record)=>{
        if (!records) {
            setRecords([
                record
            ]);
            return;
        }
        //just to keep storage limited somehow
        if (maxLength > 0 && records.length > maxLength - 1) records.shift();
        if (records.find((elem)=>JSON.stringify(elem) === JSON.stringify(record)) === undefined) setRecords([
            ...records,
            record
        ]);
    };
    const removeRecord = (query)=>{
        if (!records) return;
        const filtered = records.filter((elem)=>JSON.stringify(elem).indexOf(`"${query}"`) === -1);
        setRecords(filtered);
    };
    const actions = {
        putRecord: putRecord,
        removeRecord: removeRecord
    };
    return {
        records: records,
        actions: actions
    };
}



var $dh538 = parcelRequire("dh538");


var $fDXXi = parcelRequire("fDXXi");


var $iMEBP = parcelRequire("iMEBP");


var $3jKGE = parcelRequire("3jKGE");


var $2z5wT = parcelRequire("2z5wT");


var $fcfcA = parcelRequire("fcfcA");


var $bte6P = parcelRequire("bte6P");


var $dVp1j = parcelRequire("dVp1j");


var $jQbDV = parcelRequire("jQbDV");

const $4bb8c488d8cc97f2$export$20a8aefa6064b33c = (selectedMembers)=>{
    const newUsersWhoNeedInvite = [];
    const existingUsers = [];
    selectedMembers.forEach((selectedMember)=>{
        if (!selectedMember.email && selectedMember.fullName === selectedMember.id) {
            newUsersWhoNeedInvite.push(selectedMember);
            return;
        }
        existingUsers.push(selectedMember);
    });
    return {
        newUsersWhoNeedInvite: newUsersWhoNeedInvite,
        existingUsers: existingUsers
    };
};



var $dTRYM = parcelRequire("dTRYM");


var $cF2M0 = parcelRequire("cF2M0");


var $7C1yo = parcelRequire("7C1yo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");


var $7gpC4 = parcelRequire("7gpC4");





var $bfgIy = parcelRequire("bfgIy");



var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");


var $7sG51 = parcelRequire("7sG51");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1s5hv = parcelRequire("1s5hv");




var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");




const $ecbc41255aa486d7$var$DEFAULT_MENU_SKELETON_HEIGHT = 40;
const $ecbc41255aa486d7$var$DEFAULT_CONTENT_HEIGHT = 9;
const $ecbc41255aa486d7$var$menuSkeletonStyles = {
    wrapper: "_4t3i1ylp _1bsb1osq _19bv1b66 _u5f31b66"
}; // Copied from @atlassian/universal-create/skeleton-item to avoid circular dependency
const $ecbc41255aa486d7$export$fbc0ea7debdb77e = ({ testId: testId, contentHeight: contentHeight = $ecbc41255aa486d7$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $ecbc41255aa486d7$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $7sG51.messages).skeletonItemLoading)
            })
        ]
    });
};



var $exlO1 = parcelRequire("exlO1");

const $41c5083138e861f6$export$829a4041f4d056e0 = 'create-team-dialog-create-container-section';
const $41c5083138e861f6$var$styles = {
    stack: "_19pku2gc",
    checkboxContainer: "_19pku2gc",
    label: "_80omtlke",
    button: "_y3gn1e5h _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhk1j28"
};
const $41c5083138e861f6$var$chevronProps = {
    size: 'small',
    label: ''
};
const $41c5083138e861f6$var$productConfig = [
    {
        key: (0, $exlO1.ContainerType).JIRA_PROJECT,
        product: 'jira',
        label: (0, $7sG51.messages).createContainersJira
    },
    {
        key: (0, $exlO1.ContainerType).CONFLUENCE_SPACE,
        product: 'confluence',
        label: (0, $7sG51.messages).createContainersConfluence
    },
    {
        key: (0, $exlO1.ContainerType).LOOM_SPACE,
        product: 'loom',
        label: (0, $7sG51.messages).createContainersLoom
    }
];
function $41c5083138e861f6$export$8d43a29ab91fdd94({ cloudId: cloudId, userId: userId, onChange: onChange }) {
    const [hasSeenThis] = (0, $171125cd3846f2ee$export$86e2cef2561044ac)($41c5083138e861f6$export$829a4041f4d056e0, false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(hasSeenThis ? false : true);
    const [selectedContainers, setSelectedContainers] = (0, $42omo.useState)([]);
    const { data: productPermissions, loading: loading } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT'
            ],
            loom: [
                'write'
            ],
            confluence: [
                'CREATE_SPACE'
            ]
        }
    });
    const containers = (0, $42omo.useMemo)(()=>{
        const checkPermission = (container)=>{
            if (!productPermissions) return false;
            const product = $41c5083138e861f6$var$productConfig.find((p)=>p.key === container)?.product;
            if (!product) return false;
            return productPermissions ? (0, $iBtX5.hasProductPermission)(productPermissions, product) : false;
        };
        return $41c5083138e861f6$var$productConfig.filter((product)=>checkPermission(product.key)).map((product)=>({
                value: product.key,
                label: product.label
            }));
    }, [
        productPermissions
    ]);
    const handleChange = (event)=>{
        const { value: value, checked: checked } = event.target;
        const container = value;
        setSelectedContainers((prev)=>{
            const newContainers = checked ? [
                ...prev,
                container
            ] : prev.filter((item)=>item !== container);
            onChange(newContainers);
            return newContainers;
        });
    };
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ecbc41255aa486d7$export$fbc0ea7debdb77e), {
        testId: "create-container-skeleton"
    });
    if (!containers || containers.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($41c5083138e861f6$var$ExperimentCheck, {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $41c5083138e861f6$var$styles.stack,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    xcss: $41c5083138e861f6$var$styles.button,
                    onClick: ()=>setIsOpen(!isOpen),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: "team-spaces",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "baseline",
                            space: "space.050",
                            xcss: $41c5083138e861f6$var$styles.label,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $7sG51.messages).createContainersLabel
                                }),
                                isOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                    ...$41c5083138e861f6$var$chevronProps
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...$41c5083138e861f6$var$chevronProps
                                })
                            ]
                        })
                    })
                }),
                isOpen ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $7sG51.messages).createContainersInfo
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $41c5083138e861f6$var$styles.checkboxContainer,
                            children: containers.map((product)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...product.label
                                        })
                                    }),
                                    value: product.value,
                                    name: `container-${product.value}`,
                                    onChange: handleChange,
                                    isChecked: selectedContainers.includes(product.value)
                                }, product.value))
                        })
                    ]
                }) : null
            ]
        })
    });
}
function $41c5083138e861f6$var$ExperimentCheck({ children: children }) {
    const enrolledInExperiment = (0, $42omo.useMemo)(()=>{
        if ((0, $c6GJD.default).initializeCalled()) return (0, $c6GJD.default).getExperimentValue('teams_app_auto_container_create_universal_create', 'isEnabled', false, {
            fireExperimentExposure: true
        });
        return false;
    }, []);
    if (enrolledInExperiment) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
}






var $kLwto = parcelRequire("kLwto");




parcelRequire("42omo");





var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");





var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $7hXDW = parcelRequire("7hXDW");


var $bPdpL = parcelRequire("bPdpL");


var $1dKyn = parcelRequire("1dKyn");


var $8TTLA = parcelRequire("8TTLA");





var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $a502B = parcelRequire("a502B");









var $cIiie = parcelRequire("cIiie");


var $lKErE = parcelRequire("lKErE");




/**
 * @generated SignedSource<<649d487df2c8cc2beb16bf9a639b6ce7>>
 * @relayHash e42e4dd054a2dadff7b10b8b3f62c00e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64
const $839cace667c4b7e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scopeId"
        }
    ], v1 = [
        {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "scopeId",
                            "variableName": "scopeId"
                        }
                    ],
                    "concreteType": "TeamTypeConnection",
                    "kind": "LinkedField",
                    "name": "typesWithinScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TeamType",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "verified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "default"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TeamTypeSelectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TeamTypeSelectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64",
            "metadata": {},
            "name": "TeamTypeSelectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$839cace667c4b7e6$var$node.hash = "00cbedec6c8ea92e377a6a929a99eb1c";
var $839cace667c4b7e6$export$2e2bcd8739ae039 = $839cace667c4b7e6$var$node;






var $lAJUP = parcelRequire("lAJUP");





var $irOoi = parcelRequire("irOoi");





var $cO3Oi = parcelRequire("cO3Oi");







var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");


var $iE25L = parcelRequire("iE25L");


var $d4Pk4 = parcelRequire("d4Pk4");


var $gWF6I = parcelRequire("gWF6I");




/* TeamTypeOption.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


















const $32ed8126703433b8$var$messages = (0, $cgtv4.defineMessages)({
    teamTypeDefault: {
        id: "people-teams.team-type-select.team-type-default",
        defaultMessage: "Default type"
    }
});
const $32ed8126703433b8$var$styles = {
    optionWrapper: "_1bsb1osq _80omtlke",
    textWrapper: "_1ul91ris"
};
const $32ed8126703433b8$export$bdc70bcc84ddfbb2 = (props)=>{
    const { data: data } = props;
    const teamTypeData = data.data;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $32ed8126703433b8$var$styles.optionWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.025",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    maxLines: 1,
                                    color: "color.text",
                                    children: teamTypeData?.name
                                })
                            }),
                            teamTypeData?.verified && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                                size: "small",
                                spacing: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.025",
                        children: [
                            teamTypeData?.default && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $32ed8126703433b8$var$styles.textWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            color: "color.text.subtlest",
                                            size: "small",
                                            maxLines: 1,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...$32ed8126703433b8$var$messages.teamTypeDefault
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: "\u2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: teamTypeData?.description
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $a7416767fbec7e86$var$styles = {
    menu: "_1ul91mjv"
};
const $a7416767fbec7e86$var$TeamTypeSingleValue = (props)=>{
    const { data: data } = props;
    const isVerified = data?.data?.verified;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    children: data.label
                }),
                isVerified && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                    size: "small",
                    spacing: "none"
                })
            ]
        })
    });
};
const $a7416767fbec7e86$var$TeamTypeSelectInternal = ({ cloudId: cloudId, onChange: onChange })=>{
    const scopeId = (0, $d4Pk4.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $839cace667c4b7e6$export$2e2bcd8739ae039), {
        scopeId: scopeId
    });
    const teamTypeOptions = (0, $42omo.useMemo)(()=>{
        const nodes = data?.team?.typesWithinScope?.nodes;
        if (!nodes) return [];
        return [
            ...nodes
        ].filter((node)=>node !== null).sort((a, b)=>{
            // Temporart sort for a quick win in FE. Replace it with the backend sort once the type search API is ready.
            const aDefault = a.default;
            const bDefault = b.default; // Priority 1: default === 'VERIFIED'
            const aIsVerifiedDefault = aDefault === 'VERIFIED';
            const bIsVerifiedDefault = bDefault === 'VERIFIED';
            if (aIsVerifiedDefault && !bIsVerifiedDefault) return -1;
            if (!aIsVerifiedDefault && bIsVerifiedDefault) return 1;
             // Priority 2: default has a value
            const aHasDefault = !!aDefault;
            const bHasDefault = !!bDefault;
            if (aHasDefault && !bHasDefault) return -1;
            if (!aHasDefault && bHasDefault) return 1;
             // Priority 3: other types (maintain original order)
            return 0;
        }).map((node)=>({
                label: node.name,
                value: node.id,
                data: {
                    name: node.name,
                    verified: node.verified ?? false,
                    default: !!node.default,
                    description: node.description ?? ''
                }
            }));
    }, [
        data
    ]);
    const defaultTeamType = (0, $42omo.useMemo)(()=>{
        const nodes = data?.team?.typesWithinScope?.nodes;
        if (!nodes) return undefined;
         // Verified default team type is the one we need
        return nodes.find((node)=>node.default === 'VERIFIED') ?? nodes[0];
    }, [
        data
    ]);
    // This will help with the check for MEMBERSHIP CONTROL section after the default team type is populated
    (0, $42omo.useEffect)(()=>{
        if (defaultTeamType) onChange({
            id: defaultTeamType.id,
            name: defaultTeamType.name,
            verified: defaultTeamType.verified ?? false
        });
        else // Suspense will make sure the component is always rendered after the data is loaded,
        // so it's safe to check the undefined default team type and call onChange with an empty value, to hide the field
        onChange({
            id: '',
            name: '',
            verified: false
        });
    }, [
        onChange,
        defaultTeamType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamType",
        isRequired: true,
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypeSelectLabel
        }),
        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                inputId: "team-create-team-type-select",
                options: teamTypeOptions,
                defaultValue: defaultTeamType && {
                    label: defaultTeamType.name,
                    value: defaultTeamType.id,
                    data: {
                        name: defaultTeamType.name,
                        verified: defaultTeamType.verified ?? false,
                        default: !!defaultTeamType.default,
                        description: defaultTeamType.description ?? ''
                    }
                },
                components: {
                    Option: (0, $32ed8126703433b8$export$bdc70bcc84ddfbb2),
                    SingleValue: $a7416767fbec7e86$var$TeamTypeSingleValue,
                    Menu: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Menu, {
                            ...props,
                            xcss: $a7416767fbec7e86$var$styles.menu
                        })
                },
                onChange: (newValue)=>{
                    if (onChange && newValue) {
                        const newTeamType = {
                            id: newValue.value ?? '',
                            name: newValue.label ?? '',
                            verified: newValue.data?.verified ?? false
                        };
                        onChange(newTeamType);
                    }
                },
                isRequired: true
            })
    });
};
const $a7416767fbec7e86$export$21f6ad0eb38fd35d = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        onError: (error)=>{
            (0, $iE25L.logException)(error, 'TeamTypeSelectErrorBoundary');
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                name: "teamType",
                isRequired: true,
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7sG51.messages).teamTypeSelectLabel
                }),
                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                        isLoading: true
                    })
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($a7416767fbec7e86$var$TeamTypeSelectInternal, {
                    ...props
                })
            })
        })
    });
};


















var $7rus4 = parcelRequire("7rus4");

var $RMvle = parcelRequire("RMvle");








var $dsjDS = parcelRequire("dsjDS");





var $98DYt = parcelRequire("98DYt");

const $4790735d6db9ca3b$var$SMART_USER_PICKER_ID = 'AddMemberToTeam';
const $4790735d6db9ca3b$var$LOGGED_IN_USER = 'Context';
function $4790735d6db9ca3b$export$acbf13d3bface7d6(props) {
    const { onChange: onChange, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), cloudId: cloudId, initialValues: initialValues, value: value, teamId: teamId, filterUsers: filterUsers, extraAnalyticsAttrs: extraAnalyticsAttrs, showHelperMessages: showHelperMessages = true, isInvalid: isInvalid, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, inputId: inputId, currentUserEmail: currentUserEmail, allowEmailInvites: allowEmailInvites, bootstrapOptions: bootstrapOptions } = props;
    const [hasError, setError] = (0, $42omo.useState)(false);
    const [isMaximum, setIsMaximum] = (0, $42omo.useState)(false);
    const [isDisabled, setDisabled] = (0, $42omo.useState)(false);
    const [isOpen, setOpen] = (0, $42omo.useState)(false);
    const [query, setQuery] = (0, $42omo.useState)('');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [removedInitialValues, setRemovedInitialValues] = (0, $42omo.useState)(new Set());
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleOnChange = (0, $42omo.useCallback)((value)=>{
        const selectedUsers = value || [];
        if (initialValues?.length) {
            const currentIds = new Set(selectedUsers.map((user)=>user.id));
            initialValues.forEach((initUser)=>{
                if (!currentIds.has(initUser.id)) setRemovedInitialValues((prev)=>new Set([
                        ...prev,
                        initUser.id
                    ]));
            });
        }
        setDisabled(selectedUsers.length >= maxSelectedMembers);
        setIsMaximum(selectedUsers.length === maxSelectedMembers);
        const isError = selectedUsers.length > maxSelectedMembers;
        setError(isError);
        fireEvent('track.memberPicker.error', extraAnalyticsAttrs || {});
        if (onChange) onChange(selectedUsers, {
            hasError: isError,
            isDisabled: isDisabled
        });
    }, [
        isDisabled,
        maxSelectedMembers,
        onChange,
        extraAnalyticsAttrs,
        initialValues,
        fireEvent
    ]);
    const handleOnInputChange = (0, $42omo.useCallback)((query)=>{
        setQuery(query || '');
    }, [
        setQuery
    ]);
    const handleOnBlur = (0, $42omo.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleOnFocus = (0, $42omo.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    // convert InvitedUser type to (OptionalData | User) type of @atlaskit/user-picker
    const memoizedValue = (0, $42omo.useMemo)(()=>{
        const valueUsers = value || [];
        if (initialValues?.length) {
            const uniqueInitialUsers = initialValues.filter((initUser)=>!valueUsers.some((valUser)=>valUser.id === initUser.id) && !removedInitialValues.has(initUser.id));
            const allUsers = [
                ...valueUsers,
                ...uniqueInitialUsers
            ];
            if (!allUsers.length) return undefined;
            return allUsers.map((user)=>({
                    name: user.fullName,
                    publicName: user.nickname,
                    type: (0, $RMvle.UserType),
                    ...user
                }));
        }
        // If no initial values, just use current values
        if (valueUsers.length) return valueUsers.map((user)=>({
                name: user.fullName,
                publicName: user.nickname,
                type: (0, $RMvle.UserType),
                ...user
            }));
    }, [
        value,
        initialValues,
        removedInitialValues
    ]);
    const propsWhenHasError = hasError ? {
        open: false,
        addMoreMessage: ''
    } : {};
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rus4.default), {
                ariaLabelledBy: ariaLabelledBy,
                "aria-describedby": ariaDescribedBy,
                disableInput: isDisabled,
                onChange: handleOnChange,
                onInputChange: handleOnInputChange,
                onBlur: handleOnBlur,
                onFocus: handleOnFocus,
                open: allowEmailInvites ? undefined : isOpen && query.length > 0,
                includeTeams: false,
                inputId: inputId,
                fieldId: $4790735d6db9ca3b$var$SMART_USER_PICKER_ID,
                principalId: $4790735d6db9ca3b$var$LOGGED_IN_USER,
                isMulti: true,
                placeholder: formatMessage((0, $7sG51.messages).userPickerPlaceholderNext),
                addMoreMessage: allowEmailInvites ? formatMessage((0, $7sG51.messages).enterMore) : '',
                noOptionsMessage: ()=>formatMessage(allowEmailInvites ? (0, $7sG51.messages).userPickerNoOptionWithEmailSuggestion : (0, $7sG51.messages).userPickerNoOption),
                allowEmail: allowEmailInvites ? true : undefined,
                suggestEmailsForDomain: allowEmailInvites ? (0, $dsjDS.getUserDomain)(currentUserEmail) : undefined,
                productKey: "people",
                siteId: cloudId,
                value: memoizedValue,
                debounceTime: (0, $dTRYM.DEBOUNCE_MS),
                width: "100%",
                containerId: teamId || '',
                searchQueryFilter: (0, $98DYt.CPUS_SEARCH_QUERY_FILTER),
                filterOptions: filterUsers,
                maxOptions: (0, $dTRYM.MAX_MEMBERS),
                bootstrapOptions: (0, $dh538.fg)('jira_team_experience_improvements_feature_gate') ? bootstrapOptions : [],
                showClearIndicator: true,
                //@eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: {
                    multiValue: (style)=>({
                            ...style,
                            borderRadius: "var(--ds-radius-small, 4px)",
                            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`
                        }),
                    control: (style, state)=>({
                            ...style,
                            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                            borderColor: isInvalid && !state.isFocused ? "var(--ds-border-danger, #E2483D)" : style.borderColor,
                            ':hover': {
                                ...style[':hover'],
                                borderColor: isInvalid && !state.isFocused ? "var(--ds-border-danger, #E2483D)" : style.borderColor
                            },
                            borderWidth: `var(--ds-border-width, ${isInvalid ? '2px' : '1px'})`,
                            minHeight: '40px',
                            '.fabric-user-picker__clear-indicator': {
                                opacity: 1
                            }
                        })
                },
                ...propsWhenHasError
            }),
            showHelperMessages && (hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageError, {
                    maxNumber: maxSelectedMembers
                })
            }) : isMaximum ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageMaximumError, {
                    maxNumber: maxSelectedMembers
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageInfo, {
                    maxNumber: maxSelectedMembers
                })
            }))
        ]
    });
}
var $4790735d6db9ca3b$export$2e2bcd8739ae039 = $4790735d6db9ca3b$export$acbf13d3bface7d6;


/* TeamMemberSuggestions.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $g5gZt = parcelRequire("g5gZt");









var $9hlns = parcelRequire("9hlns");








var $asH6r = parcelRequire("asH6r");





var $5vWho = parcelRequire("5vWho");

const $2fd8093a26d06330$var$DISPLAY_USER_COUNT = 12;
const $2fd8093a26d06330$var$convertAvatarResolution = (avatarUrl, size = 96)=>{
    if (!avatarUrl) return '';
    return avatarUrl.replace(/\/\d+$/, `/${size}`);
};
const $2fd8093a26d06330$var$transformCollaborators = (data)=>{
    if (!data) return [];
    return data.recommendedEntities.filter((user)=>user.expand.account_status === 'active').map((user)=>{
        const { expand: expand } = user;
        return {
            id: (0, $5vWho.parseUserAriToUserId)(user.id),
            name: expand.nickname ? expand.nickname : expand.name,
            picture: $2fd8093a26d06330$var$convertAvatarResolution(expand.picture, 96),
            jobTitle: expand.extended_profile?.job_title,
            location: expand.extended_profile?.location
        };
    });
};
const $2fd8093a26d06330$var$fetchCollaborators = async (accountId, cloudId, maxNumberOfResults)=>{
    return (0, $asH6r.teamsClient).getRecommendedUsers({
        accountId: accountId,
        cloudId: cloudId,
        maxNumberOfResults: maxNumberOfResults
    });
};
const $2fd8093a26d06330$export$7958c2847bf0a62a = (accountId, cloudId)=>{
    const [data, setData] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const maxResultsToFetchRef = (0, $42omo.useRef)($2fd8093a26d06330$var$DISPLAY_USER_COUNT);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const loadCollaborators = (0, $42omo.useCallback)(async (isRefetch = false)=>{
        if (!accountId || !cloudId) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(undefined);
            if (isRefetch) maxResultsToFetchRef.current += $2fd8093a26d06330$var$DISPLAY_USER_COUNT;
            const collaborators = await $2fd8093a26d06330$var$fetchCollaborators(accountId, cloudId, maxResultsToFetchRef.current);
            const newUsers = $2fd8093a26d06330$var$transformCollaborators(collaborators);
            setData((prevData)=>{
                if (isRefetch) {
                    const existingIds = new Set(prevData.map((user)=>user.id));
                    const uniqueNewUsers = newUsers.filter((user)=>!existingIds.has(user.id));
                    return [
                        ...prevData,
                        ...uniqueNewUsers
                    ];
                }
                return newUsers;
            });
            fireEvent('operational.teamSuggestionsRecommendedUsers.succeeded', {
                recommendedUsers: newUsers.length
            });
        } catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            setError(error);
            (0, $iE25L.logException)(error, 'useTeamCollabQuery.fetchCollaborators', {
                accountId: accountId,
                cloudId: cloudId
            });
            fireEvent('operational.teamSuggestionsRecommendedUsers.failed', {
                recommendedUsers: 0,
                errors: [
                    error?.message ?? 'Failed to fetch recommended users'
                ]
            });
        } finally{
            setLoading(false);
        }
    }, [
        accountId,
        cloudId,
        fireEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        loadCollaborators(false);
    }, [
        loadCollaborators
    ]);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        await loadCollaborators(true);
    }, [
        loadCollaborators
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        refetch: refetch
    };
};








const $52b323c549eba27b$var$ENTRY_DURATION = 0.36;
const $52b323c549eba27b$var$EXIT_DURATION = 0.12;
const $52b323c549eba27b$var$MAX_SUGGESTED_USERS = 2;
const $52b323c549eba27b$var$styles = {
    container: "_19pkv77o _1bsb1osq _kqswh2mm",
    entry: "_16jlidpf _1o9zkb7n _i0dl1wug _v5644ql6 _p12f1ssb _tzy4idpf _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    base: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _v5644ql6 _p12f1ssb _tzy4kb7n _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    exit: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _v564f3tm _p12fidpf _tzy4idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    recommendedUsersTitleContainer: "_syazazsu _1pfhu2gc _6rth1b66"
};
const $52b323c549eba27b$var$SuggestedMemberPill = ({ user: user, onClick: onClick })=>{
    const [animationState, setAnimationState] = (0, $42omo.useState)('entry');
    const handleUserPillClick = ()=>{
        setAnimationState('exit');
        setTimeout(()=>{
            onClick(user);
        }, $52b323c549eba27b$var$EXIT_DURATION * 1000);
    };
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>setAnimationState('base'));
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: animationState === 'entry' ? $52b323c549eba27b$var$styles.entry : animationState === 'exit' ? $52b323c549eba27b$var$styles.exit : $52b323c549eba27b$var$styles.base,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            spacing: "compact",
            appearance: "default",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            onClick: handleUserPillClick,
            children: user.name
        })
    });
};
const $52b323c549eba27b$var$transformTeamUserToUserPickerUser = (user)=>({
        id: (0, $5vWho.parseUserAriToUserId)(user.id),
        name: user.name,
        publicName: user.name,
        avatarUrl: user.picture,
        type: 'user',
        email: ''
    });
const $52b323c549eba27b$export$ff316c7db48f6ec0 = ({ onSuggestedUserClick: onSuggestedUserClick, currentPickedUsers: currentPickedUsers, initialValues: initialValues = [], cloudId: cloudId = '', accountId: accountId = '' })=>{
    const { data: teamUsers, loading: isLoading, refetch: refetch } = (0, $2fd8093a26d06330$export$7958c2847bf0a62a)(accountId, cloudId);
    const previousSuggestionCountRef = (0, $42omo.useRef)(0);
    const hasTriggeredRefetchRef = (0, $42omo.useRef)(false);
    const suggestedUsers = teamUsers.map($52b323c549eba27b$var$transformTeamUserToUserPickerUser);
    const filteredSuggestedUsers = suggestedUsers.filter((user)=>!currentPickedUsers.some((pickedUser)=>pickedUser.id === user.id) && !initialValues.some((initialUser)=>initialUser.id === user.id)).slice(0, $52b323c549eba27b$var$MAX_SUGGESTED_USERS);
    (0, $42omo.useEffect)(()=>{
        const currentCount = filteredSuggestedUsers.length;
        const previousCount = previousSuggestionCountRef.current;
        if (previousCount > 1 && currentCount === 1 && !hasTriggeredRefetchRef.current && !isLoading) {
            hasTriggeredRefetchRef.current = true;
            refetch().then(()=>{
                hasTriggeredRefetchRef.current = false;
            }).catch(()=>{
                hasTriggeredRefetchRef.current = false;
            });
        }
        if (currentCount !== previousCount) previousSuggestionCountRef.current = currentCount;
    }, [
        filteredSuggestedUsers.length,
        refetch,
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $52b323c549eba27b$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small"
        })
    });
    if (!filteredSuggestedUsers.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $52b323c549eba27b$var$styles.recommendedUsersTitleContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7sG51.messages).recommendedUsersTitle
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                wrap: "nowrap",
                justifyContent: "start",
                alignItems: "center",
                direction: "row",
                xcss: $52b323c549eba27b$var$styles.container,
                children: filteredSuggestedUsers.map((user)=>/*#__PURE__*/ (0, $l998X.jsx)($52b323c549eba27b$var$SuggestedMemberPill, {
                        user: user,
                        onClick: onSuggestedUserClick
                    }, user.id))
            })
        ]
    });
};











var $gmMgo = parcelRequire("gmMgo");


var $1DWH0 = parcelRequire("1DWH0");





var $4noo5 = parcelRequire("4noo5");








var $ko87z = parcelRequire("ko87z");


var $8Hi1J = parcelRequire("8Hi1J");

function $2f9c3dda74688bd3$var$TeamNameInput(props) {
    const { intl: intl, onSubmit: onSubmit, onChange: onChange, isSubmittedOnce: isSubmittedOnce, initialTeamName: initialTeamName } = props;
    const inputRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        inputRef.current && inputRef.current.focus();
    }, []);
    const [name, setName] = (0, $42omo.useState)(initialTeamName);
    const handleTextChange = (0, $42omo.useCallback)((value)=>{
        setName(value || '');
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(value);
        if (isSubmittedOnce && teamNameValidationError === (0, $8Hi1J.ValidationError).REQUIRED) return teamNameValidationError;
        if (teamNameValidationError === (0, $8Hi1J.ValidationError).EXCEED_MAX_LENGTH) return teamNameValidationError;
        onChange(value?.trim() || '');
        return undefined;
    }, [
        onChange,
        isSubmittedOnce
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            onSubmit();
        }
    }, [
        onSubmit
    ]);
    const getErrorMsg = (error)=>{
        if (error === (0, $8Hi1J.ValidationError).REQUIRED) return intl.formatMessage((0, $7sG51.messages).teamNameFieldRequiredErrorMessage);
        return intl.formatMessage((0, $7sG51.messages).teamNameFieldTooLongErrorMessage);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamName",
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamNameFieldLabelNext
        }),
        isRequired: true,
        validate: handleTextChange,
        defaultValue: initialTeamName,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        ...fieldProps,
                        autoComplete: "off",
                        isRequired: true,
                        isDisabled: false,
                        name: "teamName",
                        onKeyDown: handleKeyDown,
                        testId: "team-name-input",
                        "aria-labelledby": "",
                        ref: inputRef,
                        value: name
                    }),
                    error ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ko87z.TeamNameErrorMsg), {
                        errorMsg: getErrorMsg(error)
                    }) : null
                ]
            })
    });
}
var $2f9c3dda74688bd3$export$2e2bcd8739ae039 = (0, $1DWH0.default)()((0, $gmMgo.default)($2f9c3dda74688bd3$var$TeamNameInput));


const $d03d138c620dc77f$var$headerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150'
});
const $d03d138c620dc77f$var$footerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $d03d138c620dc77f$var$recaptchaWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $d03d138c620dc77f$var$fieldStyles = (0, $ecnYn.xcss)({
    gap: 'space.0'
});
function $d03d138c620dc77f$var$EmptyWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
}
function $d03d138c620dc77f$var$DefaultHeader({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d03d138c620dc77f$var$headerStyles,
        children: children
    });
}
function $d03d138c620dc77f$var$DefaultFooter({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $d03d138c620dc77f$var$footerStyles,
        children: children
    });
}
function $d03d138c620dc77f$var$FormWrapper(props) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { handleSubmit: handleSubmit, onClose: onClose = (0, $dTRYM.VOID_FUNC), isFetching: isFetching, canCreateTeams: canCreateTeams, showTeamTypePicker: showTeamTypePicker, showTeamTypeSelect: showTeamTypeSelect, onGoBack: onGoBack, teamNameInputProps: teamNameInputProps, memberPickerProps: memberPickerProps, customInputFieldProps: customInputFieldProps, teamTypePickerProps: teamTypePickerProps, teamTypeSelectProps: teamTypeSelectProps, cloudId: cloudId, currentUserId: currentUserId, customMessages: customMessages = {}, customComponents: customComponents = {}, showCreateContainers: showCreateContainers = false, createContainersProps: createContainersProps, handleSuggestedMemberSelection: handleSuggestedMemberSelection, headless: headless } = props;
    const Header = customComponents?.header || customComponents?.modalHeader || $d03d138c620dc77f$var$DefaultHeader;
    const Title = customComponents?.title || customComponents?.modalTitle || $d03d138c620dc77f$var$EmptyWrapper;
    const Body = customComponents?.body || customComponents?.modalBody || $d03d138c620dc77f$var$EmptyWrapper;
    const Footer = customComponents?.footer || customComponents?.modalFooter || $d03d138c620dc77f$var$DefaultFooter;
    const customTitle = customMessages?.title || customMessages?.modalTitle;
    const submitButtonLabel = customMessages?.submitButtonLabel || formatMessage((0, $7sG51.messages).submitButtonLabelNext);
    if (!canCreateTeams) return /*#__PURE__*/ (0, $l998X.jsx)(Body, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cIiie.default), {
            onAction: onClose
        })
    });
    const platformisationFormsEnabled = (0, $dh538.fg)('navx_uc_platformisation_forms_enabled');
    const isTeamMemberSuggestionsEnabled = (0, $c6GJD.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false);
    const hideHeader = headless && platformisationFormsEnabled;
    return (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            !hideHeader && /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                    children: (0, $dh538.fg)('enable_close_button_in_team_modals') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.100",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        spacing: "compact",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                ...iconProps,
                                                LEGACY_size: "small"
                                            }),
                                        label: formatMessage((0, $7sG51.messages).backButton),
                                        onClick: onGoBack
                                    }) : null,
                                    customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                        alignBlock: "baseline",
                                        space: "space.050",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                LEGACY_size: "medium",
                                                label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                                as: "h2",
                                                size: "small",
                                                children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                onClick: onClose
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.100",
                        children: [
                            onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                spacing: "compact",
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                        ...iconProps,
                                        LEGACY_size: "small"
                                    }),
                                label: formatMessage((0, $7sG51.messages).backButton),
                                onClick: onGoBack
                            }) : null,
                            customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                alignBlock: "baseline",
                                space: "space.050",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                        LEGACY_size: "medium",
                                        label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                        as: "h2",
                                        size: "small",
                                        children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        testId: "create-team-content-dialog",
                        space: "space.100",
                        xcss: platformisationFormsEnabled ? $d03d138c620dc77f$var$fieldStyles : undefined,
                        children: [
                            !hideHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: [
                                    formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                ]
                            }),
                            customComponents.customInputField && (()=>{
                                return /*#__PURE__*/ (0, $l998X.jsx)(customComponents.customInputField, {
                                    ...customInputFieldProps()
                                });
                            })(),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2f9c3dda74688bd3$export$2e2bcd8739ae039), {
                                ...teamNameInputProps
                            }),
                            customComponents.memberPicker ? /*#__PURE__*/ (0, $l998X.jsx)(customComponents.memberPicker, {
                                ...memberPickerProps()
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                name: "inviteMembers",
                                label: formatMessage((0, $7sG51.messages).invitationsFieldLabelNext),
                                id: "inviteMembers",
                                isRequired: true,
                                defaultValue: memberPickerProps().initialValues || [],
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { showErrorMessage: showErrorMessage, ...props } = memberPickerProps(error);
                                    const suggestedMembersCloudId = cloudId;
                                    const suggestedMembersAccountId = currentUserId;
                                    const handleSuggestedUserClick = (selectedUser)=>{
                                        const currentValue = fieldProps.value || [];
                                        const isUserAlreadySelected = currentValue.some((user)=>user.id === selectedUser.id);
                                        if (isUserAlreadySelected) return;
                                        const newInvitedUser = {
                                            id: selectedUser.id,
                                            email: selectedUser.email || '',
                                            fullName: selectedUser.name,
                                            nickname: selectedUser.publicName,
                                            avatarUrl: selectedUser.avatarUrl
                                        };
                                        const newValue = [
                                            ...currentValue,
                                            newInvitedUser
                                        ];
                                        if (handleSuggestedMemberSelection) handleSuggestedMemberSelection(newInvitedUser);
                                        fieldProps.onChange(newValue);
                                    };
                                    // Convert InvitedUser[] to UserPickerUser[] for SuggestedTeamMembers
                                    const userPickerUsers = (fieldProps.value || []).map((user)=>({
                                            id: user.id,
                                            name: user.fullName,
                                            publicName: user.nickname,
                                            avatarUrl: user.avatarUrl,
                                            type: 'user',
                                            email: user.email
                                        }));
                                    const initialUserPickerUsers = (props.initialValues || []).map((user)=>({
                                            id: user.id,
                                            name: user.fullName,
                                            publicName: user.nickname,
                                            avatarUrl: user.avatarUrl,
                                            type: 'user',
                                            email: user.email
                                        }));
                                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $4790735d6db9ca3b$export$2e2bcd8739ae039), {
                                                ...fieldProps,
                                                ...props,
                                                value: fieldProps.value,
                                                ariaLabelledBy: `${fieldProps.id}-label`,
                                                ariaDescribedBy: `${fieldProps.id}-helper`,
                                                inputId: fieldProps.id,
                                                onChange: (users, meta)=>{
                                                    const invitedUsers = users.map((user)=>({
                                                            id: user.id,
                                                            email: user.email || '',
                                                            fullName: user.name,
                                                            nickname: user.publicName,
                                                            avatarUrl: user.avatarUrl
                                                        }));
                                                    fieldProps.onChange(invitedUsers);
                                                    // Also call the original onChange from memberPickerProps
                                                    if (props.onChange) props.onChange(users, meta);
                                                },
                                                initialValues: props.initialValues
                                            }),
                                            isTeamMemberSuggestionsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $52b323c549eba27b$export$ff316c7db48f6ec0), {
                                                currentPickedUsers: userPickerUsers,
                                                onSuggestedUserClick: handleSuggestedUserClick,
                                                initialValues: initialUserPickerUsers,
                                                cloudId: suggestedMembersCloudId,
                                                accountId: suggestedMembersAccountId
                                            }),
                                            showErrorMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                testId: "invitation-field-empty-error",
                                                children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessageNext)
                                            }) : null
                                        ]
                                    });
                                }
                            }),
                            showTeamTypeSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a7416767fbec7e86$export$21f6ad0eb38fd35d), {
                                ...teamTypeSelectProps
                            }) : null,
                            showTeamTypePicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                ...teamTypePickerProps
                            }) : null,
                            showCreateContainers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $41c5083138e861f6$export$8d43a29ab91fdd94), {
                                ...createContainersProps
                            }) : null
                        ]
                    }),
                    memberPickerProps()?.allowEmailInvites ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $d03d138c620dc77f$var$recaptchaWrapperStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: (0, $dh538.fg)('jsm_ux_uplift') ? 'subtle' : 'default',
                        onClick: onClose,
                        children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "primary",
                        isLoading: isFetching,
                        type: "submit",
                        children: submitButtonLabel
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                            children: (0, $dh538.fg)('enable_close_button_in_team_modals') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                alignBlock: "center",
                                space: "space.100",
                                spread: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                        alignBlock: "center",
                                        space: "space.100",
                                        children: [
                                            onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                spacing: "compact",
                                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                        ...iconProps,
                                                        LEGACY_size: "small"
                                                    }),
                                                label: formatMessage((0, $7sG51.messages).backButton),
                                                onClick: onGoBack
                                            }) : null,
                                            customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                                alignBlock: "baseline",
                                                space: "space.050",
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                        LEGACY_size: "medium",
                                                        label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                                        as: "h2",
                                                        size: "small",
                                                        children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                        onClick: onClose
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        spacing: "compact",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                ...iconProps,
                                                LEGACY_size: "small"
                                            }),
                                        label: formatMessage((0, $7sG51.messages).backButton),
                                        onClick: onGoBack
                                    }) : null,
                                    customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                        alignBlock: "baseline",
                                        space: "space.050",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                LEGACY_size: "medium",
                                                label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                                as: "h2",
                                                size: "small",
                                                children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)(Body, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                                testId: "create-team-content-dialog",
                                space: "space.100",
                                xcss: platformisationFormsEnabled ? $d03d138c620dc77f$var$fieldStyles : undefined,
                                children: [
                                    !hideHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: [
                                            formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                        ]
                                    }),
                                    customComponents.customInputField && (()=>{
                                        return /*#__PURE__*/ (0, $l998X.jsx)(customComponents.customInputField, {
                                            ...customInputFieldProps()
                                        });
                                    })(),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2f9c3dda74688bd3$export$2e2bcd8739ae039), {
                                        ...teamNameInputProps
                                    }),
                                    customComponents.memberPicker ? /*#__PURE__*/ (0, $l998X.jsx)(customComponents.memberPicker, {
                                        ...memberPickerProps()
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: "inviteMembers",
                                        label: formatMessage((0, $7sG51.messages).invitationsFieldLabelNext),
                                        id: "inviteMembers",
                                        isRequired: true,
                                        defaultValue: memberPickerProps().initialValues || [],
                                        children: ({ fieldProps: fieldProps, error: error })=>{
                                            const { showErrorMessage: showErrorMessage, ...props } = memberPickerProps(error);
                                            const suggestedMembersCloudId = cloudId;
                                            const suggestedMembersAccountId = currentUserId;
                                            // Handle suggested user selection
                                            const handleSuggestedUserClick = (selectedUser)=>{
                                                const currentValue = fieldProps.value || [];
                                                // Check if user is already selected
                                                const isUserAlreadySelected = currentValue.some((user)=>user.id === selectedUser.id);
                                                if (isUserAlreadySelected) return;
                                                // Create new invited user
                                                const newInvitedUser = {
                                                    id: selectedUser.id,
                                                    email: selectedUser.email || '',
                                                    fullName: selectedUser.name,
                                                    nickname: selectedUser.publicName,
                                                    avatarUrl: selectedUser.avatarUrl
                                                };
                                                // Merge with existing selection
                                                const newValue = [
                                                    ...currentValue,
                                                    newInvitedUser
                                                ];
                                                if (handleSuggestedMemberSelection) handleSuggestedMemberSelection(newInvitedUser);
                                                // Update form field value
                                                fieldProps.onChange(newValue);
                                            };
                                            // Convert InvitedUser[] to UserPickerUser[] for SuggestedTeamMembers
                                            const userPickerUsers = (fieldProps.value || []).map((user)=>({
                                                    id: user.id,
                                                    name: user.fullName,
                                                    publicName: user.nickname,
                                                    avatarUrl: user.avatarUrl,
                                                    type: 'user',
                                                    email: user.email
                                                }));
                                            // Convert initialValues to UserPickerUser[]
                                            const initialUserPickerUsers = (props.initialValues || []).map((user)=>({
                                                    id: user.id,
                                                    name: user.fullName,
                                                    publicName: user.nickname,
                                                    avatarUrl: user.avatarUrl,
                                                    type: 'user',
                                                    email: user.email
                                                }));
                                            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4790735d6db9ca3b$export$2e2bcd8739ae039), {
                                                        ...fieldProps,
                                                        ...props,
                                                        value: fieldProps.value,
                                                        ariaLabelledBy: `${fieldProps.id}-label`,
                                                        ariaDescribedBy: `${fieldProps.id}-helper`,
                                                        inputId: fieldProps.id,
                                                        onChange: (users, meta)=>{
                                                            const invitedUsers = users.map((user)=>({
                                                                    id: user.id,
                                                                    email: user.email || '',
                                                                    fullName: user.name,
                                                                    nickname: user.publicName,
                                                                    avatarUrl: user.avatarUrl
                                                                }));
                                                            fieldProps.onChange(invitedUsers);
                                                            // Also call the original onChange from memberPickerProps
                                                            if (props.onChange) props.onChange(users, meta);
                                                        },
                                                        initialValues: props.initialValues
                                                    }),
                                                    isTeamMemberSuggestionsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $52b323c549eba27b$export$ff316c7db48f6ec0), {
                                                        currentPickedUsers: userPickerUsers,
                                                        onSuggestedUserClick: handleSuggestedUserClick,
                                                        initialValues: initialUserPickerUsers,
                                                        cloudId: suggestedMembersCloudId,
                                                        accountId: suggestedMembersAccountId
                                                    }),
                                                    showErrorMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                        testId: "invitation-field-empty-error",
                                                        children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessageNext)
                                                    }) : null
                                                ]
                                            });
                                        }
                                    }),
                                    showTeamTypeSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a7416767fbec7e86$export$21f6ad0eb38fd35d), {
                                        ...teamTypeSelectProps
                                    }) : null,
                                    showTeamTypePicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                        ...teamTypePickerProps
                                    }) : null,
                                    showCreateContainers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $41c5083138e861f6$export$8d43a29ab91fdd94), {
                                        ...createContainersProps
                                    }) : null
                                ]
                            }),
                            memberPickerProps()?.allowEmailInvites ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $d03d138c620dc77f$var$recaptchaWrapperStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: (0, $dh538.fg)('jsm_ux_uplift') ? 'subtle' : 'default',
                                onClick: onClose,
                                children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "primary",
                                isLoading: isFetching,
                                type: "submit",
                                children: submitButtonLabel
                            })
                        ]
                    })
                ]
            })
    });
}
var $d03d138c620dc77f$export$2e2bcd8739ae039 = $d03d138c620dc77f$var$FormWrapper;



var $cEyfH = parcelRequire("cEyfH");





var $inPa6 = parcelRequire("inPa6");





var $hYSRS = parcelRequire("hYSRS");


var $8ftiF = parcelRequire("8ftiF");











var $g6zY9 = parcelRequire("g6zY9");


var $cpl2G = parcelRequire("cpl2G");


var $erMpQ = parcelRequire("erMpQ");








var $8zu5m = parcelRequire("8zu5m");




function $2d52b5011f6e7de7$var$useTeamCreateConfiguration(props) {
    const { product: product, onCreateTeamSuccess: onCreateTeamSuccess = (0, $dTRYM.VOID_FUNC), onCreateTeamFailed: onCreateTeamFailed = (0, $dTRYM.VOID_FUNC), addFlag: addFlag = (0, $dTRYM.VOID_FUNC), pushRoute: pushRoute = (0, $dTRYM.VOID_FUNC), disableSuccessFlag: disableSuccessFlag, extraAnalyticsAttrs: extraAnalyticsAttrs, initialMembershipSettings: initialMembershipSettings, enableMembershipSettingsChoice: enableMembershipSettingsChoice } = props;
    const peopleAndTeamsConfiguration = (0, $g6zY9.usePeopleAndTeamsConfigurationContext)();
    const remoteConfigResources = peopleAndTeamsConfiguration?.['people-menu']?.resources || null;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { triggerAnalyticsForCreateTeamSuccess: triggerAnalyticsForCreateTeamSuccessNext, triggerAnalyticsForCreateTeamFailed: triggerAnalyticsForCreateTeamFailedNext } = (0, $dVp1j.default)();
    const handleOnClickTeamLinkInFlag = (0, $42omo.useCallback)((event, teamData, invitedMembers)=>{
        event.preventDefault();
        fireEvent('ui.teamCreateDialog.clicked.teamLinkSuccessFlag', {
            teamId: teamData.id,
            numberOfMembers: invitedMembers.length,
            ...extraAnalyticsAttrs
        });
        // redirect to team page
        pushRoute((0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
            remoteConfigResources: remoteConfigResources,
            teamId: teamData.id,
            ref: product,
            src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
            orgId: props.orgId
        }));
    }, [
        extraAnalyticsAttrs,
        product,
        props.orgId,
        remoteConfigResources,
        pushRoute,
        fireEvent
    ]);
    const handleCreateTeamSuccess = (0, $42omo.useCallback)(async (teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers)=>{
        triggerAnalyticsForCreateTeamSuccessNext({
            numberOfMembers: invitedMembers.length,
            numberOfSuggestedMembers: numberOfSuggestedMembers || 0,
            teamId: teamData.id,
            defaultTeamType: initialMembershipSettings || null,
            chosenTeamType: teamData.membershipSettings,
            teamTypeChoiceEnabled: enableMembershipSettingsChoice || null,
            ...extraAnalyticsAttrs
        });
        const result = await onCreateTeamSuccess(teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers);
        const requestedContainers = result !== undefined ? result?.requestedContainers : undefined;
        if (failedInvitedMembers && failedInvitedMembers.length > 0) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
        if (!disableSuccessFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamTitle),
            description: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamDesc),
            appearance: 'success',
            id: 'create.team.success',
            actions: [
                {
                    content: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamAction),
                    onClick: (event)=>handleOnClickTeamLinkInFlag(event, teamData, invitedMembers),
                    href: (0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
                        remoteConfigResources: remoteConfigResources,
                        teamId: teamData.id,
                        ref: product,
                        src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
                        orgId: props.orgId,
                        containers: requestedContainers
                    })
                }
            ]
        });
    }, [
        initialMembershipSettings,
        enableMembershipSettingsChoice,
        extraAnalyticsAttrs,
        onCreateTeamSuccess,
        disableSuccessFlag,
        addFlag,
        formatMessage,
        remoteConfigResources,
        props.orgId,
        product,
        handleOnClickTeamLinkInFlag,
        triggerAnalyticsForCreateTeamSuccessNext
    ]);
    const handleCreateTeamFailed = (0, $42omo.useCallback)((error, invitedMembers)=>{
        if ((0, $cpl2G.isSeriousError)(error)) triggerAnalyticsForCreateTeamFailedNext({
            numberOfMembers: invitedMembers.length,
            errorMessage: error.message,
            errorStack: error.stack || null,
            errorStatus: error.status,
            traceId: error.traceId || null,
            ...extraAnalyticsAttrs
        });
        onCreateTeamFailed(error, invitedMembers);
        if (addFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
    }, [
        onCreateTeamFailed,
        addFlag,
        extraAnalyticsAttrs,
        formatMessage,
        triggerAnalyticsForCreateTeamFailedNext
    ]);
    return {
        onCreateTeamSuccess: handleCreateTeamSuccess,
        onCreateTeamFailed: handleCreateTeamFailed
    };
}
var $2d52b5011f6e7de7$export$2e2bcd8739ae039 = $2d52b5011f6e7de7$var$useTeamCreateConfiguration;


function $7e2123ed2a31706e$var$useTeamCreateMutation(props) {
    const { onCreateTeamSuccess: onCreateTeamSuccess, onCreateTeamFailed: onCreateTeamFailed } = (0, $2d52b5011f6e7de7$export$2e2bcd8739ae039)(props);
    const { cloudId: cloudId, orgId: orgId, product: product } = props;
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    // need a state to keep sync status of 2 requests: Create team and Invite members
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { loading: isCreatingTeam, error: errorCreateTeam, data: teamData, createTeam: createTeam } = (0, $8ftiF.useCreateTeamService)(cloudId, product, undefined, orgId);
    // This function is used to create teams
    const handleCreateTeamWithMembers = (0, $42omo.useCallback)((teamName, requestedMembers, membershipSettings, typeId)=>{
        if (isCreatingTeam) return;
        setSelectedMembers(requestedMembers);
        setIsFetching(true);
        const memberIds = requestedMembers.map((member)=>member.id);
        return createTeam(teamName, membershipSettings, memberIds, typeId);
    }, [
        createTeam,
        isCreatingTeam
    ]);
    const isFinishedCreateTeam = !errorCreateTeam && !isCreatingTeam && teamData;
    // call callbacks for creating teams
    (0, $hYSRS.useOnceWhen)(!!(isFinishedCreateTeam || errorCreateTeam), async ()=>{
        // always call onCreateTeamSuccess when creating team successfully, though inviting members can fail
        // since users can work around by re-inviting members in the team profile page.
        if (isFinishedCreateTeam) {
            const successfullyInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>teamData.memberIds?.includes(m.id)) : selectedMembers;
            const failedInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>!teamData.memberIds?.includes(m.id)) : undefined;
            await onCreateTeamSuccess(teamData, successfullyInvitedMembers, failedInvitedMembers);
            setIsFetching(false);
        }
        if (errorCreateTeam) {
            onCreateTeamFailed(errorCreateTeam, selectedMembers);
            // no need to invite anyone to team as members already invited
            setIsFetching(false);
        }
    }, [
        errorCreateTeam,
        isFinishedCreateTeam,
        onCreateTeamFailed,
        onCreateTeamSuccess,
        selectedMembers,
        teamData,
        setIsFetching,
        createAnalyticsEvent,
        product
    ]);
    return {
        isFetching: isFetching,
        createTeamAndAddMembers: handleCreateTeamWithMembers
    };
}
var $7e2123ed2a31706e$export$2e2bcd8739ae039 = $7e2123ed2a31706e$var$useTeamCreateMutation;


function $eca4ef8232acf504$var$TeamCreate(props) {
    const { proposedMembers: proposedMembers = [], cloudId: cloudId, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), extraAnalyticsAttrs: extraAnalyticsAttrs, enableMembershipSettingsChoice: enableMembershipSettingsChoice, initialMembershipSettings: initialMembershipSettings = enableMembershipSettingsChoice ? (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY : (0, $jQbDV.TeamMembershipSettings).OPEN, setIsLoading: setIsLoading = (0, $dTRYM.VOID_FUNC), onClose: onClose = (0, $dTRYM.VOID_FUNC), customMessages: customMessages = {}, customComponents: customComponents = {}, currentUser: currentUser, orgId: orgId, enableTeamPermissionCheck: enableTeamPermissionCheck, prepopulatedFields: prepopulatedFields = {}, onGoBack: onGoBack, hideCreateContainers: hideCreateContainers = false, headless: headless = false, onCreateClicked: onCreateClicked } = props;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { triggerAnalyticsForSubmitTeamCreateDialog: triggerAnalyticsForSubmitTeamCreateDialogNext } = (0, $dVp1j.default)();
    const isEligibleProductForInvites = props.product === 'jira' || props.product === 'atlas';
    const { canInviteToJiraSoftware: canInviteToJiraSoftware, canInviteToConfluence: canInviteToConfluence } = (0, $bte6P.useInviteCapabilities)({
        cloudId: cloudId,
        shouldRun: isEligibleProductForInvites && (0, $dh538.fg)('jira_team_experience_improvements_feature_gate')
    });
    const isTeamExperienceImprovementEnabled = isEligibleProductForInvites && canInviteToJiraSoftware && (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).getExperimentValue('jira_team_experience_improvements', 'isEnabled', false);
    const inviteAndAddToTeam = (0, $fcfcA.useInviteAndAddToTeam)({
        products: (0, $cF2M0.getInviteProducts)({
            product: props.product,
            canInviteToJiraSoftware: canInviteToJiraSoftware,
            canInviteToConfluence: canInviteToConfluence
        }),
        originProduct: props.product
    });
    const [_, setHaveISeenContainers] = (0, $171125cd3846f2ee$export$86e2cef2561044ac)((0, $41c5083138e861f6$export$829a4041f4d056e0), false);
    const showCreateContainers = (0, $42omo.useMemo)(()=>{
        if (hideCreateContainers) return false;
        if (!currentUser?.id) return false;
        if ((0, $c6GJD.default).initializeCalled()) return (0, $c6GJD.default).getExperimentValue('teams_app_auto_container_create_universal_create', 'isEnabled', false, {
            fireExperimentExposure: false
        });
        return false;
    }, [
        currentUser?.id,
        hideCreateContainers
    ]);
    const [containers, setCreateContainers] = (0, $42omo.useState)([]);
    const onCreateTeamSuccess = async (teamData, invitedMembers, failedInvitedMembers)=>{
        let requestedContainers = [];
        if (teamData.id && containers.length > 0 && showCreateContainers) {
            setHaveISeenContainers(true);
            const payload = containers.map((container)=>({
                    type: container,
                    containerSiteId: cloudId
                }));
            /*
				This is not be awaited due to performance reasons.
				These requests can take multiple seconds, so we don't want to block the UI.
			*/ (0, $2z5wT.postCreateTeamContainers)({
                teamId: teamData.id,
                containers: payload
            });
            requestedContainers = payload.map((container)=>container.type);
            fireEvent('track.requestedContainers.requested', {
                containers: Object.values((0, $exlO1.ContainerType)).reduce((acc, type)=>{
                    acc[type] = containers?.includes(type) ?? false;
                    return acc;
                }, {}),
                ...extraAnalyticsAttrs
            });
        }
        if (isTeamExperienceImprovementEnabled) {
            const { newUsersWhoNeedInvite: newUsersWhoNeedInvite } = (0, $4bb8c488d8cc97f2$export$20a8aefa6064b33c)(selectedMembers);
            // This is similarly not awaited for performance reasons.
            inviteAndAddToTeam({
                newUsersWhoNeedInvite: newUsersWhoNeedInvite,
                cloudId: cloudId,
                teamId: teamData.id,
                orgId: orgId
            });
        }
        if (props?.onCreateTeamSuccess) await props.onCreateTeamSuccess(teamData, invitedMembers, failedInvitedMembers, requestedContainers, suggestedMembers.length);
        return {
            requestedContainers: requestedContainers,
            numberOfSuggestedMembers: suggestedMembers.length
        };
    };
    const { isFetching: mutationIsLoading, createTeamAndAddMembers: createTeamAndAddMembers } = (0, $7e2123ed2a31706e$export$2e2bcd8739ae039)({
        ...props,
        onCreateTeamSuccess: onCreateTeamSuccess
    });
    const { members: proposedMembersNext, membershipSettings: initialMembershipSettingsNext, teamName: initialTeamName } = prepopulatedFields;
    const [teamName, setTeamName] = (0, $42omo.useState)(initialTeamName || '');
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const [membershipSettings, setMembershipSettings] = (0, $42omo.useState)(initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings);
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    const [suggestedMembers, setSuggestedMembers] = (0, $42omo.useState)([]);
    const [isSubmittedOnce, setIsSubmittedOnce] = (0, $42omo.useState)(false);
    const [isMemberPickerInvalid, setIsMemberPickerInvalid] = (0, $42omo.useState)(false);
    const [isCustomInputFieldInvalid, setIsCustomInputFieldInvalid] = (0, $42omo.useState)(true);
    (0, $cEyfH.useContainerPermissionsAnalyticsEvent)(cloudId, currentUser?.id);
    const { loading: loading, permissions: permissions } = (0, $3jKGE.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: !!enableTeamPermissionCheck,
        attributes: {
            userId: currentUser?.id
        }
    });
    // When team type is enabled, we want to hide the Membership Control by default for admins, to avoid the UI friction while loading types options
    const [showTeamTypePickerState, setShowTeamTypePickerState] = (0, $42omo.useState)((0, $dh538.fg)('enable_atlassian_team_types_m1') ? false : Boolean(enableMembershipSettingsChoice));
    const [showTeamTypeSelect, setShowTeamTypeSelect] = (0, $42omo.useState)(false);
    const [teamType, setTeamType] = (0, $42omo.useState)();
    const proposedMembersWithCurrentUser = (0, $42omo.useMemo)(()=>{
        const members = [
            ...proposedMembersNext ? proposedMembersNext : proposedMembers,
            ...currentUser && currentUser.id ? [
                currentUser
            ] : []
        ];
        const uniqueMembers = members.filter((member, index, self)=>index === self.findIndex((m)=>m.id === member.id));
        return uniqueMembers;
    }, [
        proposedMembersNext,
        proposedMembers,
        currentUser
    ]);
    // When team permission is loaded, we decide to render these or not based on permissions.
    (0, $42omo.useEffect)(()=>{
        if (!loading && permissions && (0, $dh538.fg)('enable_atlassian_team_types_m1')) {
            setShowTeamTypePickerState(!permissions.canAdminTeams && Boolean(enableMembershipSettingsChoice));
            setShowTeamTypeSelect(Boolean(permissions.canAdminTeams));
        }
    }, [
        loading,
        permissions,
        enableMembershipSettingsChoice
    ]);
    // did mount
    (0, $42omo.useEffect)(()=>{
        setSelectedMembers(proposedMembersWithCurrentUser);
        fireEvent('screen.teamCreateDialog.viewed', {
            proposedMembersLength: (proposedMembersNext ? proposedMembersNext : proposedMembers).length,
            ...extraAnalyticsAttrs
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        setIsFetching(!!mutationIsLoading);
        setIsLoading(!!mutationIsLoading || loading);
        // when isFetching prop change from true --> false, that means the creating team finishes
        if (mutationIsLoading === false && isFetching === true) onClose();
    }, [
        mutationIsLoading,
        isFetching,
        setIsLoading,
        onClose,
        loading
    ]);
    const handleSelectedChange = (0, $42omo.useCallback)((users, data)=>{
        setSelectedMembers(users.map((user)=>({
                id: user.id,
                email: user.email,
                fullName: user.name,
                avatarUrl: user.avatarUrl
            })));
        setSuggestedMembers((existingSuggestedMembers)=>existingSuggestedMembers.filter((suggestedMember)=>users.find((user)=>user.id === suggestedMember.id)));
        setIsMemberPickerInvalid(data.hasError || users.length === 0);
    }, [
        setIsMemberPickerInvalid,
        setSelectedMembers
    ]);
    const handleChange = (0, $42omo.useCallback)((customInput)=>{
        const isInvalid = !customInput || !customInput.value;
        setIsCustomInputFieldInvalid(isInvalid);
    }, [
        setIsCustomInputFieldInvalid
    ]);
    const handleSuggestedMemberSelection = (0, $42omo.useCallback)((newValue)=>{
        fireEvent('ui.member.suggested', {
            ...extraAnalyticsAttrs
        });
        setSuggestedMembers((existingSuggestedMembers)=>[
                ...existingSuggestedMembers,
                newValue
            ]);
    }, [
        extraAnalyticsAttrs,
        setSuggestedMembers,
        fireEvent
    ]);
    const handleTeamTypeSelectChange = (0, $42omo.useCallback)((value)=>{
        // Hide the Team Type Select when no value, which means there was no team type at all exists in the user base
        if (!value.id) {
            setShowTeamTypeSelect(false);
            setTeamType(undefined);
        } else setTeamType(value.id);
        // Show the MEMBERSHIP CONTROL section when the team type is not verified
        setShowTeamTypePickerState(!value.verified);
        if (value.verified) setMembershipSettings((0, $jQbDV.TeamMembershipSettings).ORG_ADMIN_MANAGED);
        else setMembershipSettings(initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings);
    }, [
        setShowTeamTypeSelect,
        setShowTeamTypePickerState,
        initialMembershipSettingsNext,
        initialMembershipSettings
    ]);
    const canTeamBeCreated = (0, $42omo.useCallback)(()=>{
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
        const hasCustomField = Boolean(customComponents?.customInputField);
        const result = !isMemberPickerInvalid && !teamNameValidationError && (!hasCustomField || !isCustomInputFieldInvalid) && !isFetching;
        return result;
    }, [
        isFetching,
        isMemberPickerInvalid,
        isCustomInputFieldInvalid,
        teamName,
        customComponents?.customInputField
    ]);
    const handleSubmit = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsForSubmitTeamCreateDialogNext({
            canCreateTeam: canTeamBeCreated(),
            numberOfMembers: selectedMembers.length,
            numberOfSuggestedMembers: suggestedMembers.length,
            ...extraAnalyticsAttrs
        });
        setIsSubmittedOnce(true);
        onCreateClicked?.({
            teamName: teamName,
            selectedMembers: selectedMembers,
            membershipSettings: membershipSettings
        });
        if (!canTeamBeCreated()) {
            const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
            return {
                teamName: teamNameValidationError,
                inviteMembers: selectedMembers.length === 0
            };
        }
        if (canTeamBeCreated()) {
            setIsFetching(true);
            // outsource creating a new team + invite members logic to outside
            // to reduce complexity of current file
            createTeamAndAddMembers(teamName, selectedMembers, membershipSettings, teamType);
        }
    }, [
        onCreateClicked,
        teamName,
        selectedMembers,
        membershipSettings,
        canTeamBeCreated,
        triggerAnalyticsForSubmitTeamCreateDialogNext,
        suggestedMembers.length,
        extraAnalyticsAttrs,
        createTeamAndAddMembers,
        teamType
    ]);
    const handleSubmitForExistingUsers = (0, $42omo.useCallback)(async ()=>{
        triggerAnalyticsForSubmitTeamCreateDialogNext({
            canCreateTeam: canTeamBeCreated(),
            numberOfMembers: selectedMembers.length,
            numberOfSuggestedMembers: suggestedMembers.length,
            ...extraAnalyticsAttrs
        });
        setIsSubmittedOnce(true);
        onCreateClicked?.({
            teamName: teamName,
            selectedMembers: selectedMembers,
            membershipSettings: membershipSettings
        });
        if (!canTeamBeCreated()) {
            const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
            return {
                teamName: teamNameValidationError,
                inviteMembers: selectedMembers.length === 0
            };
        }
        const { existingUsers: existingUsers } = (0, $4bb8c488d8cc97f2$export$20a8aefa6064b33c)(selectedMembers);
        setIsFetching(true);
        createTeamAndAddMembers(teamName, existingUsers, membershipSettings, teamType);
    }, [
        canTeamBeCreated,
        createTeamAndAddMembers,
        extraAnalyticsAttrs,
        membershipSettings,
        selectedMembers,
        suggestedMembers,
        teamName,
        triggerAnalyticsForSubmitTeamCreateDialogNext,
        onCreateClicked,
        teamType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d03d138c620dc77f$export$2e2bcd8739ae039), {
        headless: headless,
        handleSubmit: isTeamExperienceImprovementEnabled ? handleSubmitForExistingUsers : handleSubmit,
        onClose: onClose,
        isFetching: isFetching,
        canCreateTeams: permissions.canCreateTeams,
        maxSelectedMembers: maxSelectedMembers,
        customMessages: customMessages,
        customComponents: customComponents,
        showTeamTypePicker: showTeamTypePickerState,
        showTeamTypeSelect: showTeamTypeSelect,
        showCreateContainers: showCreateContainers,
        onGoBack: onGoBack,
        handleSuggestedMemberSelection: handleSuggestedMemberSelection,
        cloudId: cloudId,
        currentUserId: currentUser?.id,
        teamNameInputProps: {
            onChange: setTeamName,
            onSubmit: handleSubmit,
            isSubmittedOnce: isSubmittedOnce,
            initialTeamName: initialTeamName
        },
        memberPickerProps: (error)=>({
                cloudId: cloudId,
                onChange: handleSelectedChange,
                initialValues: proposedMembersWithCurrentUser,
                maxSelectedMembers: maxSelectedMembers,
                extraAnalyticsAttrs: extraAnalyticsAttrs,
                showHelperMessages: false,
                isInvalid: isSubmittedOnce ? isMemberPickerInvalid : !!error,
                showErrorMessage: Boolean(isSubmittedOnce ? isMemberPickerInvalid : error),
                currentUserEmail: currentUser?.email,
                allowEmailInvites: isTeamExperienceImprovementEnabled,
                bootstrapOptions: isTeamExperienceImprovementEnabled ? undefined : []
            }),
        customInputFieldProps: (error)=>{
            const props = {
                orgId: orgId || '',
                isRequired: true,
                isInvalid: isSubmittedOnce ? isCustomInputFieldInvalid : !!error,
                showErrorMessage: Boolean(isSubmittedOnce ? isCustomInputFieldInvalid : error),
                onChange: handleChange
            };
            return props;
        },
        teamTypePickerProps: {
            onChange: setMembershipSettings,
            defaultValue: initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings
        },
        teamTypeSelectProps: {
            cloudId: cloudId,
            onChange: handleTeamTypeSelectChange
        },
        createContainersProps: {
            cloudId: cloudId,
            //verified userId is truthy in showCreateContainers
            userId: currentUser?.id,
            onChange: setCreateContainers
        }
    });
}
const $eca4ef8232acf504$var$TeamCreateWithLazyIntlProvider = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iMEBP.LazyIntlProvider), {
        fetchLanguageFile: (0, $kLwto.fetchLanguageFile),
        children: /*#__PURE__*/ (0, $l998X.jsx)($eca4ef8232acf504$var$TeamCreate, {
            ...props
        })
    });
};
var $eca4ef8232acf504$export$2e2bcd8739ae039 = $eca4ef8232acf504$var$TeamCreateWithLazyIntlProvider;
module.exports["default"] = $eca4ef8232acf504$export$2e2bcd8739ae039;

});

parcelRegister("2z5wT", function(module, exports) {

var $asH6r = parcelRequire("asH6r");

// src/identity/team-type/types.ts
var $83ba7276a71fc72c$export$e1ed78e1f6fcb85d = "identity", $83ba7276a71fc72c$export$5e4a4c44ec9508eb = "team-type";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team-type/manifest.ts
var $e6582f18894900ee$var$identityTeamTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $83ba7276a71fc72c$export$e1ed78e1f6fcb85d),
    resourceType: (0, $83ba7276a71fc72c$export$5e4a4c44ec9508eb),
    resourceIdSlug: "{directoryId}/{teamTypeId}",
    resourceIdSegmentFormats: {
        directoryId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        teamTypeId: /[a-zA-Z0-9.\-_~]{1,64}/
    }
};
// src/identity/team-type/index.ts
var $e6582f18894900ee$export$691365bd52dea848 = class _IdentityTeamTypeAri extends (0, $3NXcb.RegisteredAri) {
    get directoryId() {
        return this._directoryId;
    }
    get teamTypeId() {
        return this._teamTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.qualifier,
            platformQualifier: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.resourceOwner,
            resourceType: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.resourceType,
            resourceId: `${opts.directoryId}/${opts.teamTypeId}`,
            resourceIdSegmentValues: {
                directoryId: opts.directoryId,
                teamTypeId: opts.teamTypeId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $e6582f18894900ee$var$identityTeamTypeAriStaticOpts);
        return new _IdentityTeamTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $e6582f18894900ee$var$identityTeamTypeAriStaticOpts);
        return new _IdentityTeamTypeAri(opts);
    }
    getVariables() {
        return {
            directoryId: this.directoryId,
            teamTypeId: this.teamTypeId
        };
    }
    constructor(opts){
        super(opts), this._directoryId = opts.resourceIdSegmentValues.directoryId, this._teamTypeId = opts.resourceIdSegmentValues.teamTypeId;
    }
};



var $erMpQ = parcelRequire("erMpQ");


var $jQbDV = parcelRequire("jQbDV");


var $3PCpU = parcelRequire("3PCpU");


var $dAQwn = parcelRequire("dAQwn");


var $5vWho = parcelRequire("5vWho");

const $24be8a5f4fdf4242$var$LIMIT_RESULTS = 5;
const $24be8a5f4fdf4242$export$51eb1e4b266d279a = '/gateway/api';
const $24be8a5f4fdf4242$export$a6635dd972d6facf = `${$24be8a5f4fdf4242$export$51eb1e4b266d279a}/v3/teams`;
const $24be8a5f4fdf4242$export$8ebb304bc6fdbba2 = `${$24be8a5f4fdf4242$export$51eb1e4b266d279a}/v4/teams`;
const $24be8a5f4fdf4242$export$d6cee1ef1aa86c6d = `${$24be8a5f4fdf4242$export$a6635dd972d6facf}/of-user`;
const $24be8a5f4fdf4242$export$5c5040d455d75334 = `${$24be8a5f4fdf4242$export$8ebb304bc6fdbba2}/search`;
const $24be8a5f4fdf4242$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$24be8a5f4fdf4242$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$24be8a5f4fdf4242$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $24be8a5f4fdf4242$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$24be8a5f4fdf4242$export$5c5040d455d75334}${(0, $erMpQ.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $24be8a5f4fdf4242$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $dAQwn.fetchJson)($24be8a5f4fdf4242$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $24be8a5f4fdf4242$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $3PCpU.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $24be8a5f4fdf4242$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $24be8a5f4fdf4242$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $dAQwn.postJson)(url, postData);
};
const $24be8a5f4fdf4242$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $asH6r.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $asH6r.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$24be8a5f4fdf4242$export$51eb1e4b266d279a}`);
    const result = await (0, $asH6r.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings, // The Team create API expects team type ID instead of ARI
    metaData.typeId ? (0, $e6582f18894900ee$export$691365bd52dea848).check(metaData.typeId) ? (0, $e6582f18894900ee$export$691365bd52dea848).parse(metaData.typeId).teamTypeId : metaData.typeId : undefined);
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $jQbDV.TeamState).ACTIVE : (0, $jQbDV.TeamState).PURGED,
        membershipSettings: (0, $5vWho.getMembershipSettings)(result.membershipSettings),
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $jQbDV.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $jQbDV.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $jQbDV.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $jQbDV.TeamPermission).FULL_READ : (0, $jQbDV.TeamPermission).NONE
    };
};
const $24be8a5f4fdf4242$export$27c5962a642c1a90 = async (payload, tenantUrl)=>{
    if (!payload.teamId || !payload.containers || payload.containers.length === 0) return;
    (0, $asH6r.teamsClient).setBaseUrl(`${tenantUrl ?? ''}${$24be8a5f4fdf4242$export$51eb1e4b266d279a}`);
    const result = await (0, $asH6r.teamsClient).createTeamContainers(payload);
    return {
        teamId: result.teamId,
        containersNotCreated: result.containersNotCreated,
        containersCreated: result.containersCreated
    };
};
const $24be8a5f4fdf4242$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$24be8a5f4fdf4242$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $erMpQ.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $24be8a5f4fdf4242$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $24be8a5f4fdf4242$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $dAQwn.postJson)(url, postData);
};
module.exports["searchTeamsOfUser"] = $24be8a5f4fdf4242$export$c52386bca71fd065;
module.exports["postCreateTeam"] = $24be8a5f4fdf4242$export$db3c0c162386baf4;
module.exports["postCreateTeamContainers"] = $24be8a5f4fdf4242$export$27c5962a642c1a90;

});

parcelRegister("8WLH9", function(module, exports) {
function $f6f03925f485eb7e$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $f6f03925f485eb7e$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($f6f03925f485eb7e$export$c75c12ecb0b3724e);
};
module.exports["trimTeamAriInObject"] = $f6f03925f485eb7e$export$c75c12ecb0b3724e;
module.exports["transformTeams"] = $f6f03925f485eb7e$export$fd398a52d6f57b46;

});

parcelRegister("1y96J", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7ef83ecb9005e49e$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $42omo.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $42omo.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};
module.exports["useService"] = $7ef83ecb9005e49e$export$6de4685a6c88b4e9;

});

parcelRegister("8zu5m", function(module, exports) {
var $fe09d2d8b6a84765$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["MEMBER_PICKER"] = "memberPicker";
    AnalyticsActionSubject["TEAM_TYPE_PICKER"] = "teamTypePicker";
    AnalyticsActionSubject["TEAM_CREATE_DIALOG"] = "teamCreateDialog";
    AnalyticsActionSubject["DROP_DOWN_MENU"] = "dropdownMenu";
    AnalyticsActionSubject["ADD_TO_TEAM_SERVICE"] = "addToTeamService";
    AnalyticsActionSubject["INVITE_TO_PRODUCT_SERVICE"] = "inviteToProductService";
    AnalyticsActionSubject["INVITE_CAPABILITIES_SERVICE"] = "inviteCapabilitiesService";
    AnalyticsActionSubject["INVITED_TEAM_MEMBERS"] = "invitedTeamMembers";
    AnalyticsActionSubject["USER"] = "user";
    AnalyticsActionSubject["REQUESTED_CONTAINERS"] = "requestedContainers";
    AnalyticsActionSubject["CONTAINER_PERMISSIONS"] = "containerPermissions";
    AnalyticsActionSubject["MEMBER"] = "member";
    return AnalyticsActionSubject;
}({});
var $fe09d2d8b6a84765$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["INVITED"] = "invited";
    AnalyticsAction["REQUESTED"] = "requested";
    AnalyticsAction["ADDED"] = "added";
    AnalyticsAction["SUGGESTED"] = "suggested";
    return AnalyticsAction;
}({});
var $fe09d2d8b6a84765$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_TEAMS"] = "peopleTeams";
    return AnalyticsSource;
}({});
module.exports["AnalyticsActionSubject"] = $fe09d2d8b6a84765$export$4bce2c1f3a5d9f61;
module.exports["AnalyticsSource"] = $fe09d2d8b6a84765$export$6890652a1aff7d1c;

});

parcelRegister("1UbNf", function(module, exports) {
const $bc45907eae291e90$export$836e07406b35f36c = ({ products: products, cloudId: cloudId })=>{
    return products.map((product)=>`ari:cloud:${product}::site/${cloudId}`);
};
module.exports["getProductAris"] = $bc45907eae291e90$export$836e07406b35f36c;

});

parcelRegister("dVp1j", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $e3Tu8 = parcelRequire("e3Tu8");

const $ba9e625f89ca50bb$export$7e9cc5548016e4d1 = ()=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const triggerAnalyticsForCreateTeamSuccess = (0, $42omo.useCallback)((attributes)=>{
        // @ts-expect-error - operational.teamCreateDialog.succeeded can not be defined in the analytics spec as it is a duplicate event
        fireEvent('operational.teamCreateDialog.succeeded', attributes);
        (0, $e3Tu8.teamCreationExp).success({
            metadata: {
                ...attributes,
                defaultTeamType: attributes.defaultTeamType ?? undefined,
                teamTypeChoiceEnabled: attributes.teamTypeChoiceEnabled === null ? undefined : attributes.teamTypeChoiceEnabled
            }
        });
        fireEvent('track.teamCreateDialog.succeeded', attributes);
    }, [
        fireEvent
    ]);
    const triggerAnalyticsForCreateTeamFailed = (0, $42omo.useCallback)((attributes)=>{
        // @ts-expect-error - operational.teamCreateDialog.failed can not be defined in the analytics spec as it is a duplicate event
        fireEvent('operational.teamCreateDialog.failed', attributes);
        (0, $e3Tu8.teamCreationExp).failure({
            metadata: {
                ...attributes,
                errorStack: attributes.errorStack ?? undefined,
                traceId: attributes.traceId ?? undefined
            }
        });
        fireEvent('track.teamCreateDialog.failed', attributes);
    }, [
        fireEvent
    ]);
    const triggerAnalyticsForSubmitTeamCreateDialog = (0, $42omo.useCallback)((attributes)=>{
        fireEvent('ui.teamCreateDialog.submitted', attributes);
        (0, $e3Tu8.teamCreationExp).start();
    }, [
        fireEvent
    ]);
    return {
        triggerAnalyticsForCreateTeamSuccess: triggerAnalyticsForCreateTeamSuccess,
        triggerAnalyticsForCreateTeamFailed: triggerAnalyticsForCreateTeamFailed,
        triggerAnalyticsForSubmitTeamCreateDialog: triggerAnalyticsForSubmitTeamCreateDialog
    };
};
var $ba9e625f89ca50bb$export$2e2bcd8739ae039 = $ba9e625f89ca50bb$export$7e9cc5548016e4d1;
module.exports["default"] = $ba9e625f89ca50bb$export$2e2bcd8739ae039;

});

parcelRegister("dTRYM", function(module, exports) {
const $4f385fb34c505736$export$a8a815044211bb75 = 50;
const $4f385fb34c505736$export$a954cbc46095ce6a = 150;
const $4f385fb34c505736$export$7e6ba5d480e9bd2f = ()=>undefined;
module.exports["MAX_MEMBERS"] = $4f385fb34c505736$export$a8a815044211bb75;
module.exports["DEBOUNCE_MS"] = $4f385fb34c505736$export$a954cbc46095ce6a;
module.exports["VOID_FUNC"] = $4f385fb34c505736$export$7e6ba5d480e9bd2f;

});

parcelRegister("7C1yo", function(module, exports) {

var $8Hi1J = parcelRequire("8Hi1J");

const $e3371b5b6d0ab65d$export$6f7ed7f72d9991fb = (teamName)=>{
    if (!teamName) return (0, $8Hi1J.ValidationError).REQUIRED;
    if (teamName.length > 100) return (0, $8Hi1J.ValidationError).EXCEED_MAX_LENGTH;
    return undefined;
};
module.exports["validateTeamName"] = $e3371b5b6d0ab65d$export$6f7ed7f72d9991fb;

});

parcelRegister("7sG51", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4732c4756b984d71$var$PREFIX = 'ptc.pt';
const $4732c4756b984d71$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // member pickers
    limitedUsersInvitationMessageInfo: {
        id: "ptc.pt.member-picker.msg.exceed.limited.number.info",
        defaultMessage: "You can invite up to {maxNumber, plural, one {1 person} other {{maxNumber} people}} at once."
    },
    limitedUsersInvitationMessageError: {
        id: "ptc.pt.member-picker.error.msg.exceed.limited.number.error2",
        defaultMessage: "You've entered more than {maxNumber, plural, one {{maxNumber} person} other {{maxNumber} people}}."
    },
    limitedUsersInvitationMessageMaximumError: {
        id: "ptc.pt.member-picker.error.msg.reach.limited.number.error",
        defaultMessage: "You can only invite up to {maxNumber, plural, one {{maxNumber} person} other {{maxNumber} people}} at once."
    },
    userPickerPlaceholder: {
        id: "ptc.pt.member-picker.placeholder",
        defaultMessage: "Choose people"
    },
    userPickerPlaceholderNext: {
        id: "ptc.pt.member-picker.placeholder.next",
        defaultMessage: "Search for team members"
    },
    userPickerNoOption: {
        id: "ptc.pt.member-picker.no-option",
        defaultMessage: "No matches."
    },
    userPickerNoOptionWithEmailSuggestion: {
        id: "ptc.pt.member-picker.no-option-with-email-suggestion",
        defaultMessage: "Enter an email address"
    },
    enterMore: {
        id: "ptc.pt.member-picker.enter-more",
        defaultMessage: "Enter more"
    },
    // team-create-dialog
    modalTitle: {
        id: "ptc.pt.team-create-dialog.title",
        defaultMessage: "Create a team"
    },
    modalTitleNext: {
        id: "ptc.pt.team-create-dialog.title.next",
        defaultMessage: "Create team"
    },
    modalTitleIconLabel: {
        id: "ptc.pt.team-create-dialog.title",
        defaultMessage: "Teams icon"
    },
    formTextWithMention: {
        id: "ptc.pt.team-create-dialog.pretext.with.mention",
        defaultMessage: "Bring everyone together with one team you can @mention, filter, and assign work to. {learnMoreLink}"
    },
    requiredFieldSummary: {
        id: "ptc.pt.team-create-dialog.required-field.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    teamNameFieldLabel: {
        id: "ptc.pt.team-create-dialog.team-name-field.label",
        defaultMessage: "Team name"
    },
    teamNameFieldLabelNext: {
        id: "ptc.pt.team-create-dialog.team-name-field.label.next",
        defaultMessage: "Name"
    },
    teamNameFieldPlaceholder: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.placeholder",
        defaultMessage: "e.g. HR Team, Redesign Project, Team Mango"
    },
    teamNameFieldRequiredErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.required.error-message",
        defaultMessage: "You must provide a team name"
    },
    teamNameFieldTooLongErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.too-long.error-message",
        defaultMessage: "Team name must be 100 characters or less"
    },
    teamNameFieldInfoMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.info-message",
        defaultMessage: "Who can see your team name?"
    },
    teamNameFieldInfoDetail: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.info-detail",
        defaultMessage: "Your team name is visible to anyone in your organisation. It may be visible on work shared outside your organisation."
    },
    submitButtonLabel: {
        id: "ptc.pt.team-create-dialog.button.submit",
        defaultMessage: "Create a team"
    },
    submitButtonLabelNext: {
        id: "ptc.pt.team-create-dialog.button.submit.next",
        defaultMessage: "Create"
    },
    cancelButtonLabel: {
        id: "ptc.pt.team-create-dialog.button.cancel",
        defaultMessage: "Cancel"
    },
    learnMore: {
        id: "ptc.pt.team-create-dialog.learn-more",
        defaultMessage: "What\u2019s a team?"
    },
    backButton: {
        id: "ptc.pt.team-create-dialog.button.back",
        defaultMessage: "Go back"
    },
    // flags of team-create-dialog
    flagSuccessCreateTeamTitle: {
        id: "ptc.pt.team-create-dialog.flag-success.title",
        defaultMessage: "Team has been created"
    },
    flagSuccessCreateTeamDesc: {
        id: "ptc.pt.team-create-dialog.flag-success.desc",
        defaultMessage: "Start collaborating by @mentioning the team\u2019s name, or view the team\u2019s profile."
    },
    flagSuccessCreateTeamAction: {
        id: "ptc.pt.team-create-dialog.flag-success.action",
        defaultMessage: "View team"
    },
    flagErrorCreateTeamTitle: {
        id: "ptc.pt.team-create-dialog.flag-error.title",
        defaultMessage: "Sorry, something went wrong"
    },
    flagErrorCreateTeamDesc: {
        id: "ptc.pt.team-create-dialog.flag-error.desc",
        defaultMessage: "We couldn't save your team. Please try again."
    },
    flagErrorCreateTeamPartialFailTitle: {
        id: "ptc.pt.team-create-dialog.flag-partial-error.title",
        defaultMessage: "Sorry, something went wrong"
    },
    flagErrorCreateTeamPartialFailDesc: {
        id: "ptc.pt.team-create-dialog.flag-partial-error.desc",
        defaultMessage: "We couldn't invite some members. Please try again."
    },
    // inviting members
    invitationsFieldLabel: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.label",
        defaultMessage: "Who should be in this team?"
    },
    invitationsFieldLabelNext: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.label.next",
        defaultMessage: "Add team members"
    },
    invitationsFieldErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.error-message",
        defaultMessage: "Teams must contain at least one member. You can invite up to {maxSelectedMembers, plural, one {# person} other {# people}} at a time."
    },
    invitationsFieldErrorMessageNext: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.error-message.next",
        defaultMessage: "You must add at least one team member"
    },
    // team membership control
    teamTypePickerLabel: {
        id: "ptc.pt.team-type-picker.field.label",
        defaultMessage: "Membership controls"
    },
    new: {
        id: "ptc.pt.team-type-picker.field.new.lozenge",
        defaultMessage: "New"
    },
    teamTypeCheckboxLabel: {
        id: "ptc.pt.team-type-picker.checkbox.label",
        defaultMessage: "Anyone can join this team without approval"
    },
    openTeam: {
        id: "ptc.pt.team-type-picker.team-type.open",
        defaultMessage: "Open team"
    },
    inviteOnlyTeam: {
        id: "ptc.pt.team-type-picker.team-type.invite-only",
        defaultMessage: "Invite-only team"
    },
    openTeamDescription: {
        id: "ptc.pt.team-type-picker.team-type.open.description",
        defaultMessage: "Anyone in your organisation can join and edit the team."
    },
    inviteOnlyTeamDescription: {
        id: "ptc.pt.team-type-picker.team-type.invite-only.description",
        defaultMessage: "Anyone in your organisation can request to join and must be approved by a current team member."
    },
    noAccessErrorStateTitle: {
        id: "ptc.pt.team-create-dialog.no-access-error.title",
        defaultMessage: "We can't create your team"
    },
    noAccessErrorStateMessage: {
        id: "ptc.pt.team-create-dialog.no-access-error.description",
        defaultMessage: "You don't have access to create teams in this organization."
    },
    noAccessErrorStateActionLabel: {
        id: "ptc.pt.team-create-dialog.no-access-error.action-label",
        defaultMessage: "OK"
    },
    teamProductAccessFlagInformInviteToProductsTitle: {
        id: "ptc.pt.team-create-dialog.experiment-flag-invite-to-products-informing.title",
        defaultMessage: "App access requested"
    },
    teamProductAccessFlagInformInviteToProductsDesc: {
        id: "ptc.pt.team-create-dialog.experiment-flag-invite-to-products-informing.desc",
        defaultMessage: "All members should receive an email confirming their access to selected products. {br}If you're not an admin, your product requests may be sent to one for approval."
    },
    // create containers
    createContainersLabel: {
        id: "ptc.pt.team-create-dialog.create-containers.label",
        defaultMessage: "Add new team spaces"
    },
    createContainersInfo: {
        id: "ptc.pt.team-create-dialog.create-containers.info",
        defaultMessage: "Spaces will be made matching this team\u2019s name and will be automatically linked."
    },
    createContainersJira: {
        id: "ptc.pt.team-create-dialog.create-containers.jira",
        defaultMessage: "Jira project"
    },
    createContainersConfluence: {
        id: "ptc.pt.team-create-dialog.create-containers.confluence",
        defaultMessage: "Confluence space"
    },
    createContainersLoom: {
        id: "ptc.pt.team-create-dialog.create-containers.loom",
        defaultMessage: "Loom space"
    },
    skeletonItemLoading: {
        id: "ptc.pt.skeleton-item.loading",
        defaultMessage: "Menu item is loading"
    },
    recommendedUsersTitle: {
        id: "ptc.pt.team-create-dialog.recommended-users.title",
        defaultMessage: "Recommended Users"
    },
    teamTypeSelectLabel: {
        id: "ptc.pt.team-type-select.label",
        defaultMessage: "Type"
    }
});
module.exports["messages"] = $4732c4756b984d71$export$defe85febe8b728c;

});

parcelRegister("kLwto", function(module, exports) {

var $hxlCp = parcelRequire("hxlCp");

function $1406cfc18ea56582$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $hxlCp.cs();
        case 'da-DK':
        case 'da':
            return $hxlCp.da();
        case 'de-DE':
        case 'de':
            return $hxlCp.de();
        case 'en-GB':
            return $hxlCp.engb();
        case 'en-US':
        case 'en':
            return $hxlCp.en();
        case 'en-ZZ':
            return $hxlCp.enzz();
        case 'es-ES':
        case 'es':
            return $hxlCp.es();
        case 'et-EE':
        case 'et':
            return $hxlCp.et();
        case 'fi-FI':
        case 'fi':
            return $hxlCp.fi();
        case 'fr-FR':
        case 'fr':
            return $hxlCp.fr();
        case 'hu-HU':
        case 'hu':
            return $hxlCp.hu();
        case 'is-IS':
        case 'is':
            return $hxlCp.is();
        case 'it-IT':
        case 'it':
            return $hxlCp.it();
        case 'ja-JP':
        case 'ja':
            return $hxlCp.ja();
        case 'ko-KR':
        case 'ko':
            return $hxlCp.ko();
        case 'nb-NB':
        case 'nb':
            return $hxlCp.nb();
        case 'nl-NL':
        case 'nl':
            return $hxlCp.nl();
        case 'pl-PL':
        case 'pl':
            return $hxlCp.pl();
        case 'pt-BR':
        case 'pt_BR':
            return $hxlCp.ptbr();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $hxlCp.pt();
        case 'ro-RO':
        case 'ro':
            return $hxlCp.ro();
        case 'ru-RU':
        case 'ru':
            return $hxlCp.ru();
        case 'sk-SK':
        case 'sk':
            return $hxlCp.sk();
        case 'sv-SE':
        case 'sv':
            return $hxlCp.sv();
        case 'tr-TR':
        case 'tr':
            return $hxlCp.tr();
        case 'th-TH':
        case 'th':
            return $hxlCp.th();
        case 'uk-UK':
        case 'uk':
            return $hxlCp.uk();
        case 'vi-VI':
        case 'vi':
            return $hxlCp.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $hxlCp.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $hxlCp.zh();
    }
    return $hxlCp.fallback();
}
module.exports["fetchLanguageFile"] = $1406cfc18ea56582$export$c08b58fa4727b0d2;

});

parcelRegister("cIiie", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $abC4X = parcelRequire("abC4X");


var $7sG51 = parcelRequire("7sG51");


var $4YhPU = parcelRequire("4YhPU");


var $e0BNA = parcelRequire("e0BNA");

const $5e2c5c2e6d57a768$var$NoAccessErrorState = ({ onAction: onAction })=>{
    const intl = (0, $8C5kA.default)();
    const action = /*#__PURE__*/ (0, $l998X.jsx)((0, $e0BNA.ActionButtonWrapper), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            onClick: onAction,
            appearance: "primary",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $7sG51.messages).noAccessErrorStateActionLabel
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
        header: intl.formatMessage((0, $7sG51.messages).noAccessErrorStateTitle),
        description: intl.formatMessage((0, $7sG51.messages).noAccessErrorStateMessage),
        primaryAction: action,
        renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $e0BNA.AccessLockSVGWrapper), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4YhPU.default), {})
            })
    });
};
var $5e2c5c2e6d57a768$export$2e2bcd8739ae039 = $5e2c5c2e6d57a768$var$NoAccessErrorState;
module.exports["default"] = $5e2c5c2e6d57a768$export$2e2bcd8739ae039;

});

parcelRegister("lKErE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $7gpC4 = parcelRequire("7gpC4");


var $fb3kw = parcelRequire("fb3kw");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $fDXXi = parcelRequire("fDXXi");


var $jQbDV = parcelRequire("jQbDV");


var $7sG51 = parcelRequire("7sG51");


var $5tgsV = parcelRequire("5tgsV");

const $7f4f61323b2e207e$export$d1c0f3d85a1ba244 = ({ defaultValue: defaultValue, onChange: onChange })=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleChange = (0, $42omo.useCallback)((event)=>{
        const chosenValue = event.currentTarget.checked ? (0, $jQbDV.TeamMembershipSettings).OPEN : (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
        fireEvent('ui.teamTypePicker.clicked', {
            defaultType: defaultValue || null,
            chosenType: chosenValue
        });
        onChange(chosenValue);
    }, [
        defaultValue,
        onChange,
        fireEvent
    ]);
    const label = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypeCheckboxLabel
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamType",
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypePickerLabel
        }),
        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5tgsV.CheckboxLine), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    ...(0, $dh538.fg)('team_type_picker_a11y_fix') ? {
                        name: 'teamType'
                    } : {},
                    defaultChecked: defaultValue === (0, $jQbDV.TeamMembershipSettings).OPEN,
                    onChange: handleChange,
                    label: label
                })
            })
    });
};
var $7f4f61323b2e207e$export$2e2bcd8739ae039 = $7f4f61323b2e207e$export$d1c0f3d85a1ba244;
module.exports["default"] = $7f4f61323b2e207e$export$2e2bcd8739ae039;

});

parcelRegister("98DYt", function(module, exports) {
/**
 * Filter out inactive users AND bot accounts
 */ const $091db23b095dff1e$export$e8eb9b725485707a = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")';
module.exports["CPUS_SEARCH_QUERY_FILTER"] = $091db23b095dff1e$export$e8eb9b725485707a;

});

parcelRegister("ko87z", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gQhRa = parcelRequire("gQhRa");


var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $7sG51 = parcelRequire("7sG51");


var $e0BNA = parcelRequire("e0BNA");

function $231c3eb2f7d43136$export$71f8f57e8cade4f9() {
    return /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.InfoPopupLearnMoreWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "#",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $7sG51.messages).learnMore
            })
        })
    });
}
function $231c3eb2f7d43136$export$ab1a3f0c3cd5e68e({ errorMsg: errorMsg }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
        testId: "team-name-empty-error",
        children: errorMsg
    });
}
function $231c3eb2f7d43136$export$1a4118ee85eefa24() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
        testId: "team-name-info-msg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $l998X.jsxs)($e0BNA.DivWrapper, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7sG51.messages).teamNameFieldInfoMessage
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: formatMessage((0, $7sG51.messages).teamNameFieldInfoDetail),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($e0BNA.InfoIconWrapper, {
                        tabIndex: 0,
                        role: "button",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                            label: formatMessage((0, $7sG51.messages).teamNameFieldInfoDetail),
                            LEGACY_size: "small",
                            color: "currentColor",
                            LEGACY_margin: "var(--ds-space-050, 4px)",
                            size: "small"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["TeamNameErrorMsg"] = $231c3eb2f7d43136$export$ab1a3f0c3cd5e68e;
module.exports["TeamNameInfoMsg"] = $231c3eb2f7d43136$export$1a4118ee85eefa24;

});

parcelRegister("8Hi1J", function(module, exports) {
var $4e712b808bb97b5a$export$2191b9da168c6cf0 = /*#__PURE__*/ function(ValidationError) {
    /**
	 * Error type when the required field not filled
	 */ ValidationError["REQUIRED"] = "required";
    ValidationError["EXCEED_MAX_LENGTH"] = "exceed_max_length";
    return ValidationError;
}({});
module.exports["ValidationError"] = $4e712b808bb97b5a$export$2191b9da168c6cf0;

});

parcelRegister("cEyfH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");

function $21b1ba75ec6b9e3e$export$8adaae1490083cd6(cloudId, userId) {
    const { loading: loading, data: data, error: error } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT'
            ],
            loom: [
                'write'
            ],
            confluence: [
                'CREATE_SPACE'
            ]
        }
    });
    const hasFiredRef = (0, $42omo.useRef)(false);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (loading || !data || Object.keys(data).length === 0 || error || hasFiredRef.current) return;
        const attributes = {
            canCreateConfluenceContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'confluence', [
                'CREATE_SPACE'
            ]) : false,
            canCreateLoomContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'loom', [
                'write'
            ]) : false,
            canCreateJiraContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'jira', [
                'CREATE_PROJECT'
            ]) : false
        };
        fireEvent('track.containerPermissions.succeeded', {
            canCreateConfluenceContainer: attributes.canCreateConfluenceContainer || false,
            canCreateLoomContainer: attributes.canCreateLoomContainer || false,
            canCreateJiraContainer: attributes.canCreateJiraContainer || false
        });
        hasFiredRef.current = true;
    }, [
        loading,
        data,
        error,
        fireEvent
    ]);
}
module.exports["useContainerPermissionsAnalyticsEvent"] = $21b1ba75ec6b9e3e$export$8adaae1490083cd6;

});

parcelRegister("8ftiF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2z5wT = parcelRequire("2z5wT");


var $8WLH9 = parcelRequire("8WLH9");


var $jQbDV = parcelRequire("jQbDV");


var $1y96J = parcelRequire("1y96J");

function $1052eef51deec84c$export$55536fa0740b1330(cloudId, product, tenantUrl, orgId) {
    const [teamInfo, setTeamInfo] = (0, $42omo.useState)({
        teamName: '',
        teamMembershipSettings: (0, $jQbDV.TeamMembershipSettings).OPEN
    });
    const requestToCreateTeam = (0, $42omo.useCallback)(()=>{
        const metaData = {
            product: product,
            cloudId: cloudId,
            tenantUrl: tenantUrl,
            orgId: orgId,
            members: teamInfo.teamMembers,
            typeId: teamInfo.typeId
        };
        return (0, $2z5wT.postCreateTeam)(teamInfo.teamName, teamInfo.teamMembershipSettings, metaData);
    }, [
        cloudId,
        product,
        tenantUrl,
        teamInfo,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $1y96J.useService)(requestToCreateTeam);
    const memoizedData = (0, $42omo.useMemo)(()=>(0, $8WLH9.trimTeamAriInObject)(data), [
        data
    ]);
    // calling creating team endpoint when teamName change
    (0, $42omo.useEffect)(()=>{
        if (!teamInfo.teamName) return;
        fetchData();
    }, [
        fetchData,
        teamInfo
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        createTeam: (teamName, teamMembershipSettings, teamMembers, typeId)=>{
            // `teamName` changes --> `requestToCreateTeam` is updated -->  `fetchData` is updated --> `memoizedData` is updated
            setTeamInfo({
                teamName: teamName,
                teamMembershipSettings: teamMembershipSettings,
                ...teamMembers && teamMembers.length > 0 && {
                    teamMembers: teamMembers
                },
                typeId: typeId
            });
        }
    };
}
module.exports["useCreateTeamService"] = $1052eef51deec84c$export$55536fa0740b1330;

});

parcelRegister("5vWho", function(module, exports) {

var $gHaxX = parcelRequire("gHaxX");


var $jQbDV = parcelRequire("jQbDV");

const $5b0eaa56a681b9bd$export$7a41eaabcfe7ab13 = (setting)=>{
    switch(setting){
        case 'OPEN':
            return (0, $jQbDV.TeamMembershipSettings).OPEN;
        case 'MEMBER_INVITE':
            return (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
        case 'ORG_ADMIN_MANAGED':
            return (0, $jQbDV.TeamMembershipSettings).ORG_ADMIN_MANAGED;
        default:
            return (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
    }
};
const $5b0eaa56a681b9bd$export$6844af0be884cf1 = (ariId)=>{
    try {
        return (0, $gHaxX.IdentityUserAri).parse(ariId).userId;
    } catch  {
        return ariId;
    }
};
module.exports["getMembershipSettings"] = $5b0eaa56a681b9bd$export$7a41eaabcfe7ab13;
module.exports["parseUserAriToUserId"] = $5b0eaa56a681b9bd$export$6844af0be884cf1;

});

parcelRegister("e3Tu8", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5 = new (0, $5aVN7.UFOExperience)('team-creation-action', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
module.exports["teamCreationExp"] = $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5;

});

parcelRegister("hxlCp", function(module, exports) {
/* istanbul ignore file */ const $dc3dab64e37c56d9$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $dc3dab64e37c56d9$export$bde1ed0f60b38f2f = ()=>(parcelRequire("3lZRK"));

const $dc3dab64e37c56d9$export$8c8450b83b664ba4 = ()=>(parcelRequire("7mqs9"));

const $dc3dab64e37c56d9$export$2fa162a495d26869 = ()=>(parcelRequire("9QXth"));

const $dc3dab64e37c56d9$export$84584c2a98eb6753 = ()=>(parcelRequire("gwBdZ"));

const $dc3dab64e37c56d9$export$141cd05f569bae45 = ()=>(parcelRequire("4gfKl"));

const $dc3dab64e37c56d9$export$a3f288d6c3177b8a = ()=>(parcelRequire("5Jjgo"));

const $dc3dab64e37c56d9$export$ca5e4045a55e76d2 = ()=>(parcelRequire("d6SYh"));

const $dc3dab64e37c56d9$export$457177dcde8472be = ()=>(parcelRequire("3oCoP"));

const $dc3dab64e37c56d9$export$ed5179c818622fb = ()=>(parcelRequire("iWlgX"));

const $dc3dab64e37c56d9$export$acb2a88f7d552ebf = ()=>(parcelRequire("bt9tU"));

const $dc3dab64e37c56d9$export$9901d21957972d53 = ()=>(parcelRequire("7iYB2"));

const $dc3dab64e37c56d9$export$226b3eccf92c9ed9 = ()=>(parcelRequire("7XDBL"));

const $dc3dab64e37c56d9$export$3486a10f30cf1ee4 = ()=>(parcelRequire("2qcAk"));

const $dc3dab64e37c56d9$export$8c6f505e9474ce90 = ()=>(parcelRequire("iAkHQ"));

const $dc3dab64e37c56d9$export$798cf677954c9533 = ()=>(parcelRequire("7fKvu"));

const $dc3dab64e37c56d9$export$38ef0e3f791a121e = ()=>(parcelRequire("QhOo0"));

const $dc3dab64e37c56d9$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("ax0PZ"));

const $dc3dab64e37c56d9$export$6ea5311eda92944f = ()=>(parcelRequire("79QiG"));

const $dc3dab64e37c56d9$export$84175d5f1cb4e39d = ()=>(parcelRequire("fCW89"));

const $dc3dab64e37c56d9$export$82924b14976e7373 = ()=>(parcelRequire("6ytYa"));

const $dc3dab64e37c56d9$export$ea30ec7f37fb148d = ()=>(parcelRequire("d21At"));

const $dc3dab64e37c56d9$export$cf48009033a0126b = ()=>(parcelRequire("86pAZ"));

const $dc3dab64e37c56d9$export$d608fa5b5bfd2021 = ()=>(parcelRequire("fBNxQ"));

const $dc3dab64e37c56d9$export$65540e5f7f6e7dce = ()=>(parcelRequire("e9b8w"));

const $dc3dab64e37c56d9$export$72451b88a72ad9c2 = ()=>(parcelRequire("jRB0q"));

const $dc3dab64e37c56d9$export$d657bc098992a431 = ()=>(parcelRequire("8DFjK"));

const $dc3dab64e37c56d9$export$312745a8a3013c00 = ()=>(parcelRequire("7iUnH"));

const $dc3dab64e37c56d9$export$e3786bf10a8abdf2 = ()=>(parcelRequire("5hoEo"));

const $dc3dab64e37c56d9$export$b65a7f08f2280505 = ()=>(parcelRequire("h5TZH"));

const $dc3dab64e37c56d9$export$41779e6acd26e15f = ()=>(parcelRequire("eKtdF"));
module.exports["fallback"] = $dc3dab64e37c56d9$export$bcd1dd1f397bba12;
module.exports["cs"] = $dc3dab64e37c56d9$export$bde1ed0f60b38f2f;
module.exports["da"] = $dc3dab64e37c56d9$export$8c8450b83b664ba4;
module.exports["de"] = $dc3dab64e37c56d9$export$2fa162a495d26869;
module.exports["en"] = $dc3dab64e37c56d9$export$84584c2a98eb6753;
module.exports["engb"] = $dc3dab64e37c56d9$export$141cd05f569bae45;
module.exports["enzz"] = $dc3dab64e37c56d9$export$a3f288d6c3177b8a;
module.exports["es"] = $dc3dab64e37c56d9$export$ca5e4045a55e76d2;
module.exports["et"] = $dc3dab64e37c56d9$export$457177dcde8472be;
module.exports["fi"] = $dc3dab64e37c56d9$export$ed5179c818622fb;
module.exports["fr"] = $dc3dab64e37c56d9$export$acb2a88f7d552ebf;
module.exports["hu"] = $dc3dab64e37c56d9$export$9901d21957972d53;
module.exports["is"] = $dc3dab64e37c56d9$export$226b3eccf92c9ed9;
module.exports["it"] = $dc3dab64e37c56d9$export$3486a10f30cf1ee4;
module.exports["ja"] = $dc3dab64e37c56d9$export$8c6f505e9474ce90;
module.exports["ko"] = $dc3dab64e37c56d9$export$798cf677954c9533;
module.exports["nb"] = $dc3dab64e37c56d9$export$38ef0e3f791a121e;
module.exports["nl"] = $dc3dab64e37c56d9$export$9c64ee4d84d79ce1;
module.exports["pl"] = $dc3dab64e37c56d9$export$6ea5311eda92944f;
module.exports["pt"] = $dc3dab64e37c56d9$export$84175d5f1cb4e39d;
module.exports["ptbr"] = $dc3dab64e37c56d9$export$82924b14976e7373;
module.exports["ro"] = $dc3dab64e37c56d9$export$ea30ec7f37fb148d;
module.exports["ru"] = $dc3dab64e37c56d9$export$cf48009033a0126b;
module.exports["sk"] = $dc3dab64e37c56d9$export$d608fa5b5bfd2021;
module.exports["sv"] = $dc3dab64e37c56d9$export$65540e5f7f6e7dce;
module.exports["tr"] = $dc3dab64e37c56d9$export$72451b88a72ad9c2;
module.exports["th"] = $dc3dab64e37c56d9$export$d657bc098992a431;
module.exports["uk"] = $dc3dab64e37c56d9$export$312745a8a3013c00;
module.exports["vi"] = $dc3dab64e37c56d9$export$e3786bf10a8abdf2;
module.exports["zh"] = $dc3dab64e37c56d9$export$b65a7f08f2280505;
module.exports["zhtw"] = $dc3dab64e37c56d9$export$41779e6acd26e15f;

});

parcelRegister("4YhPU", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $b0aab7220676f1ef$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
                        fill: "#FF991F"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
                        fill: "#FFC400"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        style: {
                            mixBlendMode: 'multiply'
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
                            fill: "#FFE380"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
                        fill: "#253858"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
                        fill: "#FFFAE5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $b0aab7220676f1ef$export$2e2bcd8739ae039 = $b0aab7220676f1ef$var$AccessLockSVG;
module.exports["default"] = $b0aab7220676f1ef$export$2e2bcd8739ae039;

});

parcelRegister("e0BNA", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5I0OA = parcelRequire("5I0OA");

const $25360cb2d3c4cdfd$var$WIDE = 344;
const $25360cb2d3c4cdfd$var$REGULAR = 280;
const $25360cb2d3c4cdfd$export$a3d31154bb4c1b51 = (0, $5I0OA.default).div`
	display: flex;
	height: 100%;
	flex-direction: row;
	position: relative;
	z-index: 10;
	margin-top: ${"var(--ds-space-150, 12px)"};
	@media (max-width: 750px) {
		flex-direction: column;
	}
`;
const $25360cb2d3c4cdfd$export$21d9f1931ef75b56 = (0, $5I0OA.default).div`
	width: ${({ wide: wide })=>wide ? $25360cb2d3c4cdfd$var$WIDE : $25360cb2d3c4cdfd$var$REGULAR}px;
	height: auto;
`;
const $25360cb2d3c4cdfd$export$cb5dc3b938560113 = (0, $5I0OA.default).div`
	display: flex;
	flex-direction: column;
	align-self: flex-start;
	align-items: center;
	min-width: 0; /* Hack to prevent flex-box growth: https://css-tricks.com/flexbox-truncated-text/ */
	text-align: center;
	flex: ${({ imageProportion: imageProportion })=>imageProportion ?? 1};
	flex-basis: ${({ wide: wide })=>wide ? $25360cb2d3c4cdfd$var$WIDE : $25360cb2d3c4cdfd$var$REGULAR}px;
	margin-right: ${"var(--ds-space-300, 24px)"};
	@media (max-width: 750px) {
		margin-right: ${"var(--ds-space-0, 0px)"};
		margin-bottom: ${"var(--ds-space-200, 16px)"};
		align-self: center;
	}
`;
const $25360cb2d3c4cdfd$export$6fae556399d8ae8c = (0, $5I0OA.default).div`
	min-width: 0; /* Hack to prevent flex-box growth: https://css-tricks.com/flexbox-truncated-text/ */
	flex: ${({ descriptionProportion: descriptionProportion })=>descriptionProportion ?? 1};
	flex-basis: ${({ wide: wide })=>wide ? 360 : 300}px;
	@media (max-width: 750px) {
		margin-left: ${"var(--ds-space-0, 0px)"};
	}
`;
const $25360cb2d3c4cdfd$export$72333014b3c1f633 = (0, $5I0OA.default).p`
	white-space: pre-line;
	margin-bottom: ${"var(--ds-space-200, 16px)"};
`;
const $25360cb2d3c4cdfd$export$d191894e85bb7b6e = (0, $5I0OA.default).div`
	margin-bottom: ${"var(--ds-space-200, 16px)"};
`;
const $25360cb2d3c4cdfd$export$25c13d716c51d627 = (0, $5I0OA.default).div`
	margin-bottom: ${"var(--ds-space-200, 16px)"};
`;
const $25360cb2d3c4cdfd$export$270c3ac2bc36353e = (0, $5I0OA.default).span`
	margin: 0;
	margin-left: ${"var(--ds-space-050, 4px)"};
	max-height: ${"var(--ds-space-200, 16px)"};
`;
const $25360cb2d3c4cdfd$export$3f20f50cdf5504e3 = (0, $5I0OA.default).div`
	display: flex;
	align-items: center;
`;
const $25360cb2d3c4cdfd$export$63d0d27d0ec104ee = (0, $5I0OA.default).div`
	display: block;
	margin-top: ${"var(--ds-space-100, 8px)"};
`;
const $25360cb2d3c4cdfd$export$71bcd744fda975e5 = (0, $5I0OA.default).div`
	margin-bottom: ${"var(--ds-space-600, 48px)"};
`;
const $25360cb2d3c4cdfd$export$fb0bb875e597a5e3 = (0, $5I0OA.default).div`
	margin-top: ${"var(--ds-space-100, 8px)"};
`;
const $25360cb2d3c4cdfd$export$c7f3ba494c9d4709 = (0, $5I0OA.default).div`
	margin-bottom: ${"var(--ds-space-200, 16px)"};
`;
const $25360cb2d3c4cdfd$export$71a5bc32813c0c0f = (0, $5I0OA.default).span`
	display: flex;
`;
const $25360cb2d3c4cdfd$export$4eb528dc7d433c71 = (0, $5I0OA.default).span`
	display: flex;
	align-items: center;
	margin-left: ${"var(--ds-space-050, 4px)"};
`;
module.exports["IllustratedDialogContent"] = $25360cb2d3c4cdfd$export$a3d31154bb4c1b51;
module.exports["SvgWrapper"] = $25360cb2d3c4cdfd$export$21d9f1931ef75b56;
module.exports["ImageSection"] = $25360cb2d3c4cdfd$export$cb5dc3b938560113;
module.exports["TeamDataSection"] = $25360cb2d3c4cdfd$export$6fae556399d8ae8c;
module.exports["DescriptionParagraph"] = $25360cb2d3c4cdfd$export$72333014b3c1f633;
module.exports["TeamNameWrapper"] = $25360cb2d3c4cdfd$export$d191894e85bb7b6e;
module.exports["UserPickerWrapper"] = $25360cb2d3c4cdfd$export$25c13d716c51d627;
module.exports["InfoIconWrapper"] = $25360cb2d3c4cdfd$export$270c3ac2bc36353e;
module.exports["DivWrapper"] = $25360cb2d3c4cdfd$export$3f20f50cdf5504e3;
module.exports["InfoPopupLearnMoreWrapper"] = $25360cb2d3c4cdfd$export$63d0d27d0ec104ee;
module.exports["AccessLockSVGWrapper"] = $25360cb2d3c4cdfd$export$71bcd744fda975e5;
module.exports["ActionButtonWrapper"] = $25360cb2d3c4cdfd$export$fb0bb875e597a5e3;

});

parcelRegister("5tgsV", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5I0OA = parcelRequire("5I0OA");

const $2cb9a19f864266ea$export$6c0243b9100d4ff4 = (0, $5I0OA.default).div`
	display: flex;
	align-items: center;
`;
module.exports["CheckboxLine"] = $2cb9a19f864266ea$export$6c0243b9100d4ff4;

});


//# sourceMappingURL=team-preview-panel.2354e551.js.map
